var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 530.2 595",
    style: {
      enableBackground: "new 0 0 530.2 595"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#53A9FF;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#1A1332;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000064318953528616160540000006795863732314174602_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000005256597472018821030000016833699143425119364_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000112618428274332832910000013719806364422893706_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000106831651349548341190000014616758725359890826_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000068657860673939558640000010770399083123704749_",
    className: "st0",
    d: "M111.4,494.9l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0L106,495c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C111.6,494.5,111.7,494.8,111.4,494.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000161592458596650286160000018320597110724611763_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000119801211400214349450000013628991243287769005_",
    className: "st0",
    d: "M105.8,498.2l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C106,497.8,106,498.1,105.8,498.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000010275175133993979910000013193646966606399150_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000165216810828142920730000016726804898100876970_",
    className: "st0",
    d: "M116.8,498l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C117,497.6,117.1,497.9,116.8,498z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000162351073446575476350000012188648283866734465_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000011734175654569108680000008618212525117748654_",
    className: "st0",
    d: "M111.1,501.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C111.4,500.9,111.4,501.2,111.1,501.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000106842565945605079760000011176748336246033542_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000106113432766533385580000009443764726703729330_",
    className: "st0",
    d: "M122.5,501.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C122.7,500.9,122.8,501.2,122.5,501.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000086681604906185748640000017931129505346725038_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000148644943998202572410000016540373227128373922_",
    className: "st0",
    d: "M116.8,504.6l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C117.1,504.2,117.1,504.4,116.8,504.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000111177296918573961020000011709658833215889287_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000021804000574329664990000013172339466148278421_",
    className: "st0",
    d: "M127.9,504.4l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C128.1,504,128.1,504.3,127.9,504.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000001653166551828057770000016584177042939074739_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000039106784113910014090000003349167038378320030_",
    className: "st0",
    d: "M122.2,507.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C122.4,507.3,122.5,507.6,122.2,507.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000084529590328974846260000001181022689459523500_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000157310534376947396000000000379614634827674282_",
    className: "st0",
    d: "M133.3,507.5l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C133.5,507.1,133.5,507.4,133.3,507.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000103976792450334402220000013609464553199085238_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000093859730225218642900000011583055449529587355_",
    className: "st0",
    d: "M127.6,510.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C127.8,510.4,127.8,510.7,127.6,510.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000070098870412779769150000006115402286588445581_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000111180248701471922500000000836196942775879605_",
    className: "st0",
    d: "M139,510.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C139.2,510.4,139.2,510.7,139,510.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000124865286826433135270000017659757054659148185_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000042694378325997790810000004558526766452423347_",
    className: "st0",
    d: "M133.3,514.1l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C133.5,513.7,133.5,513.9,133.3,514.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000065044227095177412620000015925564531292270509_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000001639940082984169610000015191707025113029011_",
    className: "st0",
    d: "M144.4,513.9l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C144.6,513.5,144.6,513.8,144.4,513.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000113350351731755663070000012626756335591988143_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000059297675500492979280000017077812493868868272_",
    className: "st0",
    d: "M138.7,517.2l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C138.9,516.8,138.9,517.1,138.7,517.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000001633007422461995780000001477262958617422737_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000177444683069095126270000009501533099807557811_",
    className: "st0",
    d: "M149.7,517l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C149.9,516.7,150,516.9,149.7,517z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000022519621111729051070000010448149656965376159_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000132788031186514595770000000426706117450956931_",
    className: "st0",
    d: "M144.1,520.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C144.3,519.9,144.3,520.2,144.1,520.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000132079777156574579380000002912320176546854824_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000028327383078812412870000002040205117125969027_",
    className: "st0",
    d: "M155.4,520.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C155.6,519.9,155.7,520.2,155.4,520.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000114061218372667172730000013448085035093411481_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000005974452071734891480000012652260609393381535_",
    className: "st0",
    d: "M149.8,523.6l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C150,523.2,150,523.5,149.8,523.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000137814409338687325780000003626873961365513386_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000143613241490187206970000010492267294426920832_",
    className: "st0",
    d: "M160.8,523.4l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C161,523,161.1,523.3,160.8,523.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000152980205739516330430000013056014168692624061_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000158727720280224294540000017529947780864085693_",
    className: "st0",
    d: "M155.1,526.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C155.4,526.3,155.4,526.6,155.1,526.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000040549983096904154150000016313417690749766016_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000108282416973119192150000008277323200295202691_",
    className: "st0",
    d: "M166.2,526.5l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C166.4,526.2,166.4,526.4,166.2,526.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000106117327840126413170000004446040352599920797_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000176760202574709208710000017784946210364076430_",
    className: "st0",
    d: "M160.5,529.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C160.7,529.4,160.8,529.7,160.5,529.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000147207452807827226100000008325692035147812538_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000130648064589229064840000012051593140130578592_",
    className: "st0",
    d: "M171.9,529.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C172.1,529.4,172.1,529.7,171.9,529.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000040574969885839688460000007595753827097941407_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000137103764807651066650000001041966526716673413_",
    className: "st0",
    d: "M166.2,533.1l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C166.4,532.7,166.5,533,166.2,533.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000077283395514074523480000004443153216137722000_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000032612824468152253550000000802622751951528379_",
    className: "st0",
    d: "M177.3,532.9l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C177.5,532.5,177.5,532.8,177.3,532.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000131332443360922516800000010834118612644553879_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000165232582854065341420000010690204401268653211_",
    className: "st0",
    d: "M171.6,536.2l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C171.8,535.8,171.8,536.1,171.6,536.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000161625658910048330090000011868898115337955519_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000148660629234815946440000017168234424386608009_",
    className: "st0",
    d: "M182.7,536l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C182.9,535.7,182.9,535.9,182.7,536z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000084528400115823004190000011369233560823117486_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000004536486634842513990000015972590672636104334_",
    className: "st0",
    d: "M177,539.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C177.2,538.9,177.2,539.2,177,539.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000026872911940993793010000010132035237799182518_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000005964217731613120290000016880279127112607148_",
    className: "st0",
    d: "M188.3,539.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C188.6,538.9,188.6,539.2,188.3,539.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000049187215636148092290000012006925193768836996_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000125565680306672013220000012072789345963789755_",
    className: "st0",
    d: "M182.7,542.6l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C182.9,542.2,182.9,542.5,182.7,542.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000067950308362289083800000011095485742015589290_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000083784495437184618380000009231516013643375532_",
    className: "st0",
    d: "M193.7,542.4l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C193.9,542.1,194,542.3,193.7,542.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000134935005253965237460000015041799039628481414_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000037655504491038554720000006879079656470882435_",
    className: "st0",
    d: "M188.1,545.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C188.3,545.3,188.3,545.6,188.1,545.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000085235123738641065860000017896748761592601488_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000008828253005121165330000008937224855622759828_",
    className: "st0",
    d: "M199.1,545.5l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C199.3,545.2,199.3,545.4,199.1,545.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000073697568820727570960000005200592898158942340_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000151525470245685926100000000010862829984329885_",
    className: "st0",
    d: "M193.4,548.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C193.6,548.4,193.7,548.7,193.4,548.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000177446583274296373210000002653221395262634916_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000141454935257556880500000017540534590207840940_",
    className: "st0",
    d: "M204.8,548.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C205,548.4,205,548.7,204.8,548.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000027600083833453890870000000611568908139037839_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000032624104296508928120000002592090266793868964_",
    className: "st0",
    d: "M199.1,552.1l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C199.3,551.7,199.4,552,199.1,552.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000079453011580335282380000010576254521497924530_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000165922408704069907090000015809018869400777358_",
    className: "st0",
    d: "M210.2,551.9l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C210.4,551.6,210.4,551.8,210.2,551.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000078028149831139120090000001932683418686738095_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000028312185719510722630000008699266676153123750_",
    className: "st0",
    d: "M204.5,555.2l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C204.7,554.8,204.8,555.1,204.5,555.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000148636098219154220690000010923483917982505148_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000140712217955014406760000003218190890468715186_",
    className: "st0",
    d: "M215.6,555l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C215.8,554.7,215.8,554.9,215.6,555z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000059269265395257325370000003512892224525279919_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000163056498472249398320000006773310983534799777_",
    className: "st0",
    d: "M209.9,558.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C210.1,557.9,210.1,558.2,209.9,558.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000171694450626726069680000005980923531220437932_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000174562572441648814390000004425994406190482304_",
    className: "st0",
    d: "M221.3,558.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C221.5,557.9,221.5,558.2,221.3,558.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000073695658997483384940000004798583566927074948_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000059285864184287977880000012141605875551144833_",
    className: "st0",
    d: "M215.6,561.6l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C215.8,561.2,215.8,561.5,215.6,561.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000173851805519902793920000018440848908779668611_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000134935489418926937470000003709561604259654568_",
    className: "st0",
    d: "M226.6,561.4l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C226.9,561.1,226.9,561.3,226.6,561.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000165923407277343631730000017019296000959712641_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000060027100976757527530000006022910539611615628_",
    className: "st0",
    d: "M221,564.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C221.2,564.3,221.2,564.6,221,564.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000054250243469517198680000000436989572512997002_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000139259362546829908010000007414293765084468889_",
    className: "st0",
    d: "M232,564.5l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C232.2,564.2,232.3,564.4,232,564.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000031906983643441834090000001189873682072167331_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000148629422772509954280000004707288997169391547_",
    className: "st0",
    d: "M226.4,567.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C226.6,567.4,226.6,567.7,226.4,567.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000132082143036541217840000007158755591364673171_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000118379150705564761800000002191209296823748537_",
    className: "st0",
    d: "M237.7,567.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C237.9,567.5,238,567.7,237.7,567.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000093150627807012443590000010589425941603039403_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000113324268208804155590000010642918770149986187_",
    className: "st0",
    d: "M232.1,571.1l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C232.3,570.7,232.3,571,232.1,571.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000005970918492081770650000012307242046584781472_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000057142163173838568160000012389158903790470025_",
    className: "st0",
    d: "M243.4,564.6l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C243.6,564.2,243.6,564.4,243.4,564.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000051344331295462682100000002601495349015804041_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000093152781048635644620000011940858619419907728_",
    className: "st0",
    d: "M249.1,561.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C249.3,560.9,249.3,561.1,249.1,561.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000053514918360207850740000015882231957041759638_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000101804835257788425500000008356536746974357386_",
    className: "st0",
    d: "M254.7,558l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C254.9,557.6,255,557.9,254.7,558z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000031929532096787204100000018376584872494180998_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000175306234656603129000000003437123443291586721_",
    className: "st0",
    d: "M260.4,554.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C260.6,554.4,260.6,554.6,260.4,554.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000072261582460934562140000008984253715775987103_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000026140545783412039220000013674090539332996259_",
    className: "st0",
    d: "M266.1,551.5l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C266.3,551.1,266.3,551.3,266.1,551.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000002385012411850709740000008389088383612813983_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000011728274826749410730000005147429795133335944_",
    className: "st0",
    d: "M271.7,548.2l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C272,547.8,272,548,271.7,548.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000062874868049672820110000000425729746231962500_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000101090397047404578010000010803713266328266377_",
    className: "st0",
    d: "M277.4,544.9l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C277.6,544.5,277.7,544.8,277.4,544.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000036242352780169841050000015863014723870847889_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000121277627538961329210000001041073893353377955_",
    className: "st0",
    d: "M283.1,541.6l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C283.3,541.3,283.3,541.5,283.1,541.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000165213751502493950410000002861418969283186331_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000136379895752682662970000008886266121578583943_",
    className: "st0",
    d: "M288.8,538.4l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C289,538,289,538.2,288.8,538.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000007388043180660460360000007278109261327950783_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000019647115595077303720000000115155073939879612_",
    className: "st0",
    d: "M294.4,535.1l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C294.6,534.7,294.7,535,294.4,535.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000144306444950299587870000006320724814158254734_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000008828118683725970550000003223433718179050900_",
    className: "st0",
    d: "M300.1,531.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C300.3,531.4,300.3,531.7,300.1,531.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000015355346852675393610000006051126939773338511_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000051377591240798103030000012104705250353525688_",
    className: "st0",
    d: "M305.8,528.5l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C306,528.2,306,528.4,305.8,528.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000057861732033130070840000008258269861843224458_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000097502895272479626180000008326071829231200953_",
    className: "st0",
    d: "M311.4,525.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C311.6,524.9,311.7,525.1,311.4,525.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000137090164576934488070000010161969357743180189_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000062901166460245586790000005558362802257558157_",
    className: "st0",
    d: "M317.1,522l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C317.3,521.6,317.3,521.9,317.1,522z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000098185204021700638120000016709016512689456302_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000110437118391993756970000005051315311194171540_",
    className: "st0",
    d: "M322.8,518.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C323,518.3,323,518.6,322.8,518.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000180349765529720627740000009935103352650276993_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000008136524026272638910000011123261481071850664_",
    className: "st0",
    d: "M243.1,570.9l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C243.3,570.6,243.3,570.8,243.1,570.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000141444612603698998780000012581318519037323950_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000044889908198085859850000011774413093551177400_",
    className: "st0",
    d: "M238,561.4l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C238.2,561.1,238.2,561.3,238,561.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000181059077375129592640000010940977723769082497_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000155868451577600224560000012868722435307838647_",
    className: "st0",
    d: "M62.1,466.4l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C62.3,466,62.3,466.3,62.1,466.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000036211010110444545890000015958154808473180860_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000172437467793954623730000000163326654988392124_",
    className: "st0",
    d: "M67.4,469.5l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C67.7,469.1,67.7,469.4,67.4,469.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000106132212623950965980000006846905963404127406_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000082365865765651786370000000855997980362184599_",
    className: "st0",
    d: "M61.8,472.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C62,472.4,62,472.7,61.8,472.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000039093401561060948640000010886546254481666691_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000182512301595597804510000005673192225790689422_",
    className: "st0",
    d: "M72.8,472.6l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C73,472.2,73.1,472.5,72.8,472.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000036942639409648561220000010681082346391733946_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000102505085147246054280000007746287179891090110_",
    className: "st0",
    d: "M67.2,475.9l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C67.4,475.5,67.4,475.8,67.2,475.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000034767875562157117800000004538706698647723145_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000176004660470034182090000005701814126230126518_",
    className: "st0",
    d: "M78.5,475.9l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C78.7,475.5,78.8,475.8,78.5,475.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000078020930663700992520000012367355619694827910_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000103248949382310869900000017048101911149575061_",
    className: "st0",
    d: "M72.9,479.2l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C73.1,478.8,73.1,479,72.9,479.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000110455346021610553550000009959552530685486253_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000037655424937579190290000003504925259814715301_",
    className: "st0",
    d: "M83.9,479l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C84.1,478.6,84.1,478.9,83.9,479z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000027594242675402164060000009069581106683989937_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000099633377398185370830000017419028912019492536_",
    className: "st0",
    d: "M78.2,482.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C78.4,481.9,78.5,482.2,78.2,482.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000034803151826890452580000004036903689295592600_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000012456577989719844600000014903482840754948008_",
    className: "st0",
    d: "M89.3,482.1l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C89.5,481.7,89.5,482,89.3,482.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000070109440786931591370000012875185304217536649_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000041281445799050136790000014422673630108163974_",
    className: "st0",
    d: "M83.6,485.4l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C83.8,485,83.9,485.3,83.6,485.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000040568469918071698810000007003492417045098160_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000179642563005854433560000007444961478086506676_",
    className: "st0",
    d: "M95,485.4l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C95.2,485,95.2,485.3,95,485.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000060753429845717404220000000408763122039542939_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000024724470698687054710000001090017108259579797_",
    className: "st0",
    d: "M89.3,488.7L87,490 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C89.5,488.3,89.5,488.6,89.3,488.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000118393341756638217080000002807387987328411054_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000060018255519724137690000009172977760504606619_",
    className: "st0",
    d: "M100.4,488.5l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C100.6,488.1,100.6,488.4,100.4,488.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000099650137270951640810000009592498234312889234_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000083809457112793201350000006659299915992023213_",
    className: "st0",
    d: "M94.7,491.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C94.9,491.4,94.9,491.7,94.7,491.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000065049298275549617390000001662454925237061771_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000159439985559226761370000014447665787511033784_",
    className: "st0",
    d: "M105.7,491.6l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C106,491.3,106,491.5,105.7,491.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000096059966652436420170000009482433785166622354_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000029726662818682517780000001841822195680980894_",
    className: "st0",
    d: "M100.1,494.9l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C100.3,494.5,100.3,494.8,100.1,494.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000163061368688052311540000004417301533336913807_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000093145088427888134440000016229252697883720851_",
    className: "st0",
    d: "M248.8,567.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C249,567.3,249,567.5,248.8,567.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000039113969842687086350000011719009497261354169_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000035504869716486813560000006149602813251174333_",
    className: "st0",
    d: "M254.4,564.4l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C254.7,564,254.7,564.2,254.4,564.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000115486701429012608260000017792215330860777910_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000169557683408249171860000007769024422929542317_",
    className: "st0",
    d: "M260.1,561.1l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C260.3,560.7,260.4,561,260.1,561.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000178913513918872831670000009077890898870373255_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000059275719201136217360000012015139386322567845_",
    className: "st0",
    d: "M265.8,557.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C266,557.5,266,557.7,265.8,557.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000137125116842215132360000012568055215808019116_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000071533618174712390620000009910478072339828388_",
    className: "st0",
    d: "M271.5,554.6l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C271.7,554.2,271.7,554.4,271.5,554.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000110443441254452054860000008209989515444325789_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000080181214345089095730000002189803955873531522_",
    className: "st0",
    d: "M277.1,551.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C277.3,550.9,277.4,551.2,277.1,551.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000095329014240267837770000001229806326608257963_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000054265263154900242170000004331319065458555045_",
    className: "st0",
    d: "M282.8,548l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C283,547.6,283,547.9,282.8,548z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000108308177775698201440000004146987714542173880_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000005225426991674579870000012397295714279702706_",
    className: "st0",
    d: "M288.5,544.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C288.7,544.4,288.7,544.6,288.5,544.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000127728299172624394390000006723542800277271726_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000079478162459697457990000010433684633526285441_",
    className: "st0",
    d: "M294.1,541.5l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C294.3,541.1,294.4,541.3,294.1,541.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000071557457067018403730000005164456621975804604_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000109723883681063198460000005304567508186090939_",
    className: "st0",
    d: "M299.8,538.2l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C300,537.8,300,538.1,299.8,538.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000031919999670962235390000009143596584521513625_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000072265021324168716080000003540697619684215993_",
    className: "st0",
    d: "M305.5,534.9l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C305.7,534.5,305.7,534.8,305.5,534.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000072260802710207056140000011230278781479517824_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000010994653093471534270000011687722820195669951_",
    className: "st0",
    d: "M311.1,531.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C311.4,531.3,311.4,531.5,311.1,531.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000090266429530137112070000008798356847826061997_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000086691069378696499320000010455409735613035916_",
    className: "st0",
    d: "M316.8,528.4l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C317,528,317.1,528.2,316.8,528.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000128453604616200719830000015857082463979381649_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000134950342249033710740000016483131918152185269_",
    className: "st0",
    d: "M322.5,525.1l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C322.7,524.7,322.7,525,322.5,525.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000149350783767382480850000009724071834631973274_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000125589953004100027950000015167666985265394850_",
    className: "st0",
    d: "M328.2,521.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C328.4,521.5,328.4,521.7,328.2,521.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000166633390130505270020000015065458528408463752_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000053523970218119266040000014888465465631537032_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000019677215839314035160000000318025171058116514_",
    className: "st0",
    d: "M334.1,512.2l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C334.3,511.8,334.3,512.1,334.1,512.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000180348964204118968640000012613882708770301058_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000146463977490451021160000015505594725891491221_",
    className: "st0",
    d: "M328.4,515.5l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C328.6,515.1,328.7,515.3,328.4,515.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000027587590260829885180000003625241814190499759_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000111169979950273792860000002160691812300179842_",
    className: "st0",
    d: "M339.8,508.9l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C340,508.5,340,508.8,339.8,508.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000129894099627035201600000006999110053949382836_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000126322786644445854170000009095709744921222329_",
    className: "st0",
    d: "M345.4,505.6l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C345.6,505.3,345.7,505.5,345.4,505.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000151539491343928017530000009693242348705290624_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000181072934129224951870000002454500671714728329_",
    className: "st0",
    d: "M351.1,502.4l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C351.3,502,351.3,502.2,351.1,502.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000047751425557511781920000016558583192619421631_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000142891105449107215690000004327612937299925687_",
    className: "st0",
    d: "M356.8,499.1l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C357,498.7,357,499,356.8,499.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000182530809565765677600000000736902870428013717_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000008865716929578822160000012849799329111084694_",
    className: "st0",
    d: "M362.4,495.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C362.6,495.4,362.7,495.7,362.4,495.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000000913739085837854550000001159441595462275741_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000142890913404006590830000010370376298991121832_",
    className: "st0",
    d: "M368.1,492.5l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C368.3,492.2,368.3,492.4,368.1,492.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000142156634401002132750000013379185353795436931_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000169527130634875652010000015174784193984026268_",
    className: "st0",
    d: "M373.8,489.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C374,488.9,374,489.1,373.8,489.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000089562696819603694960000009516741883936346808_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000140726294145780986990000012843246285973541031_",
    className: "st0",
    d: "M379.4,486l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0L374,486c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C379.7,485.6,379.7,485.9,379.4,486z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000122717020485453531300000005509840881357723313_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000122714274408183491420000011958639995288673684_",
    className: "st0",
    d: "M385.1,482.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C385.3,482.4,385.4,482.6,385.1,482.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000178897203193400224810000003765226809633862558_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000053517678231260647340000015609367540674291384_",
    className: "st0",
    d: "M390.8,479.5l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C391,479.1,391,479.3,390.8,479.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000017515292349909738690000012443562705610989195_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000013156304542341448980000005093287291359985821_",
    className: "st0",
    d: "M396.5,476.2l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C396.7,475.8,396.7,476,396.5,476.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000163754872424520299230000006279091440173052832_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000085936601180794820010000013216394892174630066_",
    className: "st0",
    d: "M402.1,472.9l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C402.3,472.5,402.4,472.8,402.1,472.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000016035482385677736090000018209514615999134372_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000122684735867457995600000004638847337308878208_",
    className: "st0",
    d: "M407.8,469.6l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C408,469.3,408,469.5,407.8,469.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000066498698449652318380000002282483472849470884_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000000204903977391346110000010458785451948501435_",
    className: "st0",
    d: "M413.5,466.4l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C413.7,466,413.7,466.2,413.5,466.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000145758982645140640520000017437653434731660220_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000123399645535994108810000008202729293441666708_",
    className: "st0",
    d: "M419.1,463.1l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C419.3,462.7,419.4,462.9,419.1,463.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000007386356601417774040000016058768089143956129_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000163776454405539230510000001196177128689579184_",
    className: "st0",
    d: "M339.5,515.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C339.7,514.9,339.7,515.2,339.5,515.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000150789129213541425580000008022617079971392410_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000131358578828580181160000009401539346914231712_",
    className: "st0",
    d: "M333.8,518.6l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C334,518.2,334,518.4,333.8,518.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000116220331711057518590000009860407949633448839_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000011019206361964919790000000757976432155125435_",
    className: "st0",
    d: "M345.1,512l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C345.3,511.6,345.4,511.9,345.1,512z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000143618149906507373880000017644970052313087409_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000139292991925544268130000005450461886358222211_",
    className: "st0",
    d: "M350.8,508.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C351,508.4,351,508.6,350.8,508.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000050650340256616120880000016337784856051439490_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000009560777107875819580000002428075502256665736_",
    className: "st0",
    d: "M356.5,505.5l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C356.7,505.1,356.7,505.3,356.5,505.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000010293479490346631050000009806591300133143224_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000183213546802827203160000000417063605467675792_",
    className: "st0",
    d: "M362.2,502.2l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C362.4,501.8,362.4,502.1,362.2,502.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000041272686440784993720000017999682763313815463_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000055693279165029659920000008501594446067400615_",
    className: "st0",
    d: "M367.8,498.9l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C368,498.6,368.1,498.8,367.8,498.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000045590986082864231600000018190328042792015019_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000093874878679392944000000012148827420494791096_",
    className: "st0",
    d: "M373.5,495.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C373.7,495.3,373.7,495.5,373.5,495.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000128480608237706413270000005417582408534885013_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000016783000927399805180000009060830228834234248_",
    className: "st0",
    d: "M379.2,492.4l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C379.4,492,379.4,492.2,379.2,492.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000057124357261163562720000001269387964273846449_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000080182922381680973670000003211651753031140737_",
    className: "st0",
    d: "M384.8,489.1l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C385,488.7,385.1,489,384.8,489.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000092457792245851990490000010663994612542349974_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000182495291933011198790000008859856701859071656_",
    className: "st0",
    d: "M390.5,485.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C390.7,485.5,390.7,485.7,390.5,485.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000142151981264539654000000015431279262635655827_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000074442394726603371490000010149755493932606394_",
    className: "st0",
    d: "M396.2,482.6l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C396.4,482.2,396.4,482.4,396.2,482.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000115495942822921404710000001660174800987393945_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000069367695994446113080000001190810605800087221_",
    className: "st0",
    d: "M401.8,479.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C402,478.9,402.1,479.2,401.8,479.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000173145360567861706950000017076454306852349829_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000072260383655520418200000001945625910582898083_",
    className: "st0",
    d: "M407.5,476l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C407.7,475.6,407.7,475.9,407.5,476z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000023249235079971580540000010573272979056880554_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000077283231560589421300000009756550090916408466_",
    className: "st0",
    d: "M413.2,472.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C413.4,472.4,413.4,472.6,413.2,472.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000129894574148233881840000016582181535788460681_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000106851993168193833940000011923950317028267908_",
    className: "st0",
    d: "M418.9,469.5l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C419.1,469.1,419.1,469.3,418.9,469.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000008837044948604875310000018187551199288436401_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000167375591215916801370000008902134323111787684_",
    className: "st0",
    d: "M424.5,466.2l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C424.7,465.8,424.8,466.1,424.5,466.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000130630317811471989360000002878449322429016966_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000183248865725745131520000002141171293932010169_",
    className: "st0",
    d: "M424.8,459.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C425,459.4,425,459.6,424.8,459.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000074424396110436504690000004049055030403788720_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000095339650121707899250000016536973503001213363_",
    className: "st0",
    d: "M430.2,462.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C430.4,462.5,430.4,462.7,430.2,462.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000068643847920821074230000004029046667539275658_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000088103923006994713230000017758114967788144299_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000042720371885497709940000005704610922794469019_",
    className: "st0",
    d: "M436.1,453.2l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C436.3,452.8,436.4,453.1,436.1,453.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000170957749504053099900000002772444760081548704_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000115476729322932608120000000794282387696807300_",
    className: "st0",
    d: "M430.5,456.5l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C430.7,456.1,430.7,456.3,430.5,456.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000013912163593950766410000012437041051166807176_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000090995023353787266330000004892069520131595655_",
    className: "st0",
    d: "M441.8,449.9l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C442,449.6,442,449.8,441.8,449.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000142139539628798116210000014385564701590864555_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000166668680260177141330000012104898032260040113_",
    className: "st0",
    d: "M447.5,446.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C447.7,446.3,447.7,446.5,447.5,446.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000002382987757598196160000003346399518418274734_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000151515314992353078260000001857397970584958626_",
    className: "st0",
    d: "M453.1,443.4l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C453.3,443,453.4,443.2,453.1,443.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000085236509036050470600000005331971110602329788_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000147901913722700526030000003204771443843766705_",
    className: "st0",
    d: "M458.8,440.1l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C459,439.7,459,440,458.8,440.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000178910870110119170550000015886466018115853729_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000098937644908005355600000006928877264891966122_",
    className: "st0",
    d: "M464.5,436.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C464.7,436.5,464.7,436.7,464.5,436.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000115508178118729138240000012666235344031880376_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000147206143607724692510000017863186558290963586_",
    className: "st0",
    d: "M470.1,433.6l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C470.4,433.2,470.4,433.4,470.1,433.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000069380764533587609870000000831076564105442215_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000114049711624476744130000014018701947469186982_",
    className: "st0",
    d: "M475.8,430.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C476,429.9,476.1,430.1,475.8,430.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000102530284713096089720000003246218039032620444_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000177476764327624819140000015115805203066322097_",
    className: "st0",
    d: "M481.5,427l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C481.7,426.6,481.7,426.9,481.5,427z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000163031566178708537720000013424422953091278217_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000098928760993561196890000012465596080826510728_",
    className: "st0",
    d: "M487.2,423.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C487.4,423.4,487.4,423.6,487.2,423.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000013154187463794976680000014132304649852575922_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000163070127950218422790000001406368421718717374_",
    className: "st0",
    d: "M441.5,456.3l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C441.7,455.9,441.7,456.2,441.5,456.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000137842050672601421770000005268972918175988114_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000085218726995634554400000002080988795743104442_",
    className: "st0",
    d: "M435.8,459.6l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C436,459.2,436.1,459.4,435.8,459.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000010997262672515751920000006128166076731316900_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000023995986450666712560000012940289858524741811_",
    className: "st0",
    d: "M447.2,453l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C447.4,452.7,447.4,452.9,447.2,453z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000178192120738154340590000009683570940801046713_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000053522069809662270370000008294596552093218486_",
    className: "st0",
    d: "M452.8,449.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C453.1,449.4,453.1,449.6,452.8,449.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000058583480525452575680000009381156608467552942_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000095330747046935335270000014789136782624208785_",
    className: "st0",
    d: "M458.5,446.5l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C458.7,446.1,458.8,446.4,458.5,446.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000128464240887257605780000014475080201785998729_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000013904366288436418940000006455917898204299167_",
    className: "st0",
    d: "M464.2,443.2l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C464.4,442.8,464.4,443.1,464.2,443.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000014593564848454022830000015373022586674876833_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000087375176786209260670000012245262004911634860_",
    className: "st0",
    d: "M469.9,439.9l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C470.1,439.6,470.1,439.8,469.9,439.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000174582845735817247670000012161711946054353830_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000054970430868336913640000010768648272854013321_",
    className: "st0",
    d: "M475.5,436.7l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C475.7,436.3,475.8,436.5,475.5,436.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000052786097953462188000000011893556353286737811_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000106860566999556317930000005871427910578500280_",
    className: "st0",
    d: "M481.2,433.4l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C481.4,433,481.4,433.3,481.2,433.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000103945210356387155260000009545006752325286784_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000123407559331888482190000007130962894253417607_",
    className: "st0",
    d: "M486.9,430.1l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C487.1,429.7,487.1,430,486.9,430.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000149351911039159487400000009719936375000417682_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000055679466316224440950000007254893444077506485_",
    className: "st0",
    d: "M492.5,426.8l-2.3,1.3 c-0.2,0.1-0.7,0.1-0.9,0l-2.2-1.3c-0.3-0.2-0.3-0.4-0.1-0.5l2.3-1.3c0.2-0.1,0.7-0.1,0.9,0l2.2,1.3 C492.7,426.5,492.8,426.7,492.5,426.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000127724571334597185140000013182697216864850319_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000034773723500659385860000008493826062609118103_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000056414008831567325400000009535661613399920258_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000052074251286302482180000014146369789980949153_",
    className: "st1",
    d: "M43.2,226.8c0-7.8,4.8-16.9,10.6-20.3 L313.2,56.7c0.3-0.2,0.6-0.3,0.9-0.4l0,0l0,0c2-0.9,3.9-1,5.4-0.4c6.5,0.9,9.4,7.1,9.4,7.1l-2.2,2.1l-2.9-0.2v200.7 c0,7.8-4.8,16.9-10.6,20.3L57.8,433.4l-3.4,7.4c0,0-7.6,0-10.3-8.1c0-0.1-0.1-0.2-0.1-0.2c0-0.1,0-0.1-0.1-0.2l0,0 c-0.5-1.3-0.7-2.9-0.7-4.7V226.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000163776758632093215620000003986751844953485732_",
    className: "st2",
    d: "M54.4,442.1c-0.1,0-8.5-0.1-11.4-8.9 l-0.2-0.6c-0.1-0.2-0.2-0.5-0.2-0.7l-0.1-0.2l0,0c-0.3-1.2-0.5-2.5-0.5-3.9v-201c0-8.2,5-17.8,11.2-21.3L312.4,55.8l-0.2-0.4 l1.5-0.2c2.2-1,4.3-1.1,6.1-0.4c6.9,1.1,10.1,7.5,10.2,7.8l0.4,0.8l-3.2,3.1l-2.1-0.1v199.4c0,8.2-5,17.8-11.2,21.3L58.7,434.3 l-3.6,7.8H54.4L54.4,442.1z M45.4,432.9c2,5.4,6.4,6.5,8.2,6.7l3.2-7l0.3-0.2l255.5-147.5c5.5-3.2,10-11.8,10-19.3v-202l3.6,0.2 l1.1-1.1c-1-1.6-3.6-5.1-8.1-5.7l-0.3-0.1c-1.2-0.5-2.7-0.4-4.3,0.3l-0.1,0.1c-0.3,0.1-0.5,0.2-0.8,0.4L54.5,207.5 c-5.5,3.2-10,11.8-10,19.3v200.9c0,1.6,0.2,3,0.6,4.3L45.4,432.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000055696957718901609650000001249507958225605776_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000158721884186000628190000008901020342586744240_",
    className: "st2",
    d: "M311.5,58.4l2-1.1 c0.3-0.2,0.6-0.3,0.9-0.4l0,0l0,0c2-0.9,3.9-1,5.4-0.4c6.5,0.9,9.4,7.1,9.4,7.1l-2.2,2.1l-2.9-0.2v0.2L311.5,58.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000156586157027249423450000001948892088418371515_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000129175619775380593070000005233286218094856611_",
    className: "st0",
    d: "M57.8,459.8 C57.8,459.7,57.8,459.7,57.8,459.8c-0.8-1.4-5.7-9.9,0.1-17.7l6.4-0.2l1.2,5.9l254.5-147c5.9-3.4,16.1-3,22.9,0.9l161.8,89.1 l3.5-4.2c7.9,8.6,1.5,15.7,1.5,15.7l0,0c-0.6,0.8-1.5,1.5-2.6,2.2L247.9,554.2c-5.9,3.4-16.1,3-22.9-0.9L62.4,463.8 C60.3,462.6,58.8,461.3,57.8,459.8L57.8,459.8C57.9,459.8,57.9,459.8,57.8,459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000100381812979349999700000013351212498412186753_",
    className: "st2",
    d: "M237.9,557.7c-4.7,0-9.7-1.1-13.6-3.4 L61.7,464.8c-2-1.2-3.6-2.5-4.6-4l0,0l-0.3-0.4l1-0.7l-1,0.7l-0.1-0.1c-0.7-1.1-6.1-10.5,0.2-18.9l0.3-0.5l8-0.2l1.1,5.3 l253.1-146.1c6.2-3.6,17-3.2,24.1,0.9l160.9,88.6l3.7-4.5l0.9,1c8.6,9.3,1.6,17.2,1.5,17.3c-0.7,0.9-1.7,1.7-2.9,2.4 L248.5,555.3C245.6,556.9,241.9,557.7,237.9,557.7z M58.8,459l0.1,0.2c0.9,1.3,2.3,2.6,4.1,3.6l162.6,89.5 c6.5,3.7,16.2,4.1,21.7,1l259.4-149.8c1-0.6,1.7-1.2,2.3-1.9c0.3-0.3,5.1-5.9-0.6-13l-3.2,3.9L342.5,303 c-6.5-3.7-16.2-4.1-21.7-1l-256,147.8l-1.4-6.5l-4.8,0.1C53.8,450.2,57.9,457.6,58.8,459z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000035509345459348166350000002036618821848071556_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000126282192695105024170000004269718600668711556_",
    className: "st2",
    d: "M503.6,390.2l1.2,0.7l3.5-4.2 c7.9,8.6,1.5,15.7,1.5,15.7l0,0c-0.6,0.8-1.5,1.5-2.6,2.2l-3.6,2.1L503.6,390.2L503.6,390.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000093873389899065148870000011872552511134775465_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000122692170228231147400000010049813195060239495_",
    className: "st2",
    d: "M234.8,331.2l-177,102.2l-3.4,7.4 c0,0-7.6,0-10.3-8.1c0-0.1-0.1-0.2-0.1-0.2c0-0.1,0-0.1-0.1-0.2l0,0c-0.5-1.3-0.7-2.9-0.7-4.7V226.8c0-3.6,1-7.5,2.7-10.9 L234.8,331.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000075866769156765128140000012445763972071077565_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000087387191214987939290000007971728784026641800_",
    className: "st0",
    d: "M60.2,439.8L319.6,290 c5.9-3.4,10.6-12.5,10.6-20.3V68.9c0-7.8-4.8-11.4-10.6-8L60.2,210.6c-5.9,3.4-10.6,12.5-10.6,20.3v200.9 C49.6,439.6,54.3,443.2,60.2,439.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000029744694516275772080000014841711286022222758_",
    className: "st2",
    d: "M56,442.3c-1.2,0-2.3-0.3-3.3-0.9 c-2.7-1.6-4.3-5.1-4.3-9.6V230.9c0-8.2,5-17.8,11.2-21.3L319,59.8c2.9-1.7,5.8-1.9,8.2-0.6c2.7,1.6,4.3,5.1,4.3,9.6v200.9 c0,8.2-5,17.8-11.2,21.3L60.8,440.9C59.1,441.8,57.5,442.3,56,442.3z M323.8,60.8c-1.1,0-2.3,0.4-3.6,1.1L60.8,211.6 c-5.5,3.2-10,11.8-10,19.3v200.9c0,3.7,1.1,6.4,3.1,7.5c1.5,0.9,3.6,0.7,5.7-0.6L319,289c5.5-3.2,10-11.8,10-19.3V68.9 c0-3.7-1.1-6.4-3.1-7.5C325.3,60.9,324.6,60.8,323.8,60.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000141419497270842003470000002003275599954292406_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000033340097042961348530000001397913630167864475_",
    className: "st0",
    d: "M62.1,418l255.6-147.6 c2-1.1,3.5-4.2,3.5-6.8V74.3c0-2.6-1.6-3.8-3.5-2.7L62.1,219.2c-2,1.1-3.5,4.2-3.5,6.8v189.3C58.5,417.9,60.1,419.1,62.1,418z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000003104503932543232210000005981127428778966457_",
    className: "st2",
    d: "M60.7,419.6c-0.5,0-1-0.1-1.5-0.4 c-1.2-0.7-1.8-2.1-1.8-3.9V226c0-3,1.8-6.5,4.1-7.8L317.1,70.6c1.2-0.7,2.5-0.8,3.5-0.2c1.2,0.7,1.8,2.1,1.8,3.9v189.3 c0,3-1.8,6.5-4.1,7.8L62.7,419.1C62,419.4,61.3,419.6,60.7,419.6z M319.1,72.4c-0.3,0-0.6,0.2-0.8,0.3L62.7,220.3 c-1.6,0.9-2.9,3.5-2.9,5.7v189.3c0,1.1,0.3,1.6,0.6,1.8c0.3,0.2,0.8,0,1.1-0.2l255.6-147.6c1.6-0.9,2.9-3.5,2.9-5.7V74.3 c0-1.1-0.3-1.6-0.6-1.8C319.3,72.4,319.2,72.4,319.1,72.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000083086125822783188660000018000868060090577588_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000096025172136553464970000012069190798645713540_",
    className: "st2",
    d: "M313.9,267.9c2-1.1,3.5-4.2,3.5-6.8V71.8 l0.2-0.1c2-1.1,3.5,0.1,3.5,2.7v189.3c0,2.6-1.6,5.6-3.5,6.8L62.1,418c-2,1.1-3.5-0.1-3.5-2.7l0,0L313.9,267.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000029756639245345072550000004433737455004090045_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000091706295637345369810000002391245308112288696_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000038379894174729915470000002937483378577147812_",
    className: "st0",
    d: "M320.2,301l0.2-0.1 c5.4-3.1,14.4-3,21.1,0.1H320.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000079488039955869776190000015691186160565034384_",
    className: "st2",
    d: "M347,302.2h-31.3l4.1-2.3 c5.7-3.3,15-3.3,22.2,0L347,302.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000128446380213488165620000000270373855804351406_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000130616950789258356980000002568375290614774939_",
    className: "st2",
    d: "M58.1,442.1l6.4-0.2l1.2,5.9l171.8-99.2 v207.9c-4.3-0.1-8.8-1.1-12.4-3.2L62.5,463.8c-2.1-1.2-3.6-2.6-4.5-4l0,0c0,0,0,0-0.1-0.1c0,0,0-0.1-0.1-0.1 C57.3,458.4,52.4,449.9,58.1,442.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000022559943855864595040000003394072279967159190_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000078009814087413579260000001163269985752678295_",
    className: "st1",
    d: "M247.9,547.7l259.4-149.8 c5.9-3.4,5.1-9.3-1.6-13.2L343,290.8c-6.8-3.9-17-4.3-22.9-0.9L60.7,439.6c-5.9,3.4-5.1,9.3,1.6,13.2L225,546.7 C231.7,550.6,242,551,247.9,547.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000163046137305674541560000013031085536721634188_",
    className: "st2",
    d: "M237.9,551.1c-4.7,0-9.7-1.1-13.6-3.4 L61.7,453.8c-3.9-2.3-6.2-5.4-6.2-8.5c0-2.7,1.6-5.1,4.6-6.8l259.4-149.8c6.2-3.6,17-3.1,24.1,0.9l162.6,93.9 c3.9,2.3,6.2,5.4,6.2,8.5c0,2.7-1.6,5.1-4.6,6.8L248.5,548.7C245.6,550.3,241.9,551.1,237.9,551.1z M330.1,288.8 c-3.5,0-6.8,0.7-9.3,2.1L61.3,440.7c-2.2,1.3-3.4,2.9-3.4,4.7c0,2.3,1.8,4.6,5,6.4l162.6,93.9c6.4,3.7,16.2,4.1,21.7,0.9 l259.4-149.8c2.2-1.3,3.4-2.9,3.4-4.7c0-2.3-1.8-4.6-5-6.4l-162.6-93.9C338.9,289.8,334.3,288.8,330.1,288.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000103979354564918480520000002916159579741748624_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000055678046729121929540000007944235236667118997_",
    className: "st0",
    d: "M176.1,504.1l255.6-147.6 c2-1.1,1.7-3.1-0.5-4.4l-88.6-51.2c-2.3-1.3-5.7-1.4-7.6-0.3L79.3,448.2c-2,1.1-1.7,3.1,0.5,4.4l88.6,51.2 C170.7,505.1,174.1,505.2,176.1,504.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000150805684720381452100000013473423603190001056_",
    className: "st2",
    d: "M172.8,506c-1.7,0-3.5-0.4-4.9-1.2 l-88.6-51.2c-1.6-0.9-2.5-2.2-2.5-3.5c0-1.2,0.7-2.2,1.9-3l255.6-147.6c2.3-1.3,6.2-1.2,8.8,0.3l88.6,51.2 c1.6,0.9,2.5,2.2,2.5,3.5c0,1.2-0.7,2.2-1.9,3L176.7,505.1C175.6,505.7,174.2,506,172.8,506z M338.2,301c-1,0-2,0.2-2.7,0.6 L79.9,449.2c-0.3,0.2-0.7,0.5-0.7,0.9c0,0.3,0.3,0.9,1.3,1.5l88.6,51.2c1.9,1.1,4.8,1.2,6.4,0.3l255.6-147.6 c0.3-0.2,0.7-0.5,0.7-0.9c0-0.3-0.3-0.9-1.3-1.4L342,302C340.9,301.3,339.5,301,338.2,301z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000136394233382474783840000002499068819361426565_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000087402167762968428690000010164584471270185865_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000129177327099774193500000015197706298927550865_",
    className: "st0",
    d: "M331.3,488.3l73.1-42.2 c2-1.1,1.7-3.1-0.5-4.4l-48.4-28c-2.3-1.3-5.7-1.4-7.6-0.3l-73.1,42.2c-2,1.1-1.7,3.1,0.5,4.4l48.4,28 C325.9,489.3,329.3,489.5,331.3,488.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000102539935122166180570000008228377848346000291_",
    className: "st2",
    d: "M328,490.3c-1.7,0-3.5-0.4-4.9-1.2 l-48.4-28c-1.6-0.9-2.5-2.2-2.5-3.5c0-1.2,0.7-2.2,1.9-3l73.1-42.2c2.3-1.3,6.2-1.2,8.8,0.3l48.4,28c1.6,0.9,2.5,2.2,2.5,3.5 c0,1.2-0.7,2.2-1.9,3l-73.1,42.2C330.8,490,329.4,490.3,328,490.3z M351.1,413.9c-1,0-2,0.2-2.7,0.6l-73.1,42.2 c-0.3,0.2-0.7,0.5-0.7,0.9c0,0.3,0.3,0.9,1.3,1.5l48.4,28c1.9,1.1,4.8,1.2,6.4,0.3l73.1-42.2c0.3-0.2,0.7-0.5,0.7-0.9 c0-0.3-0.3-0.9-1.3-1.5l-48.4-28C353.7,414.2,352.4,413.9,351.1,413.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000015326830375614163440000010196726172938791811_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000062150954205008465280000008436745562832371382_",
    className: "st2",
    d: "M357.6,423.1l-4.1-2.4 c-1.3-0.8-3.6-0.8-5,0l-4.1,2.4l-1.2-2.1l4.1-2.4c2.1-1.2,5.3-1.2,7.4,0l4.1,2.4L357.6,423.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000089559399288800832800000000444477276809812121_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000161594939904146022990000009065869624556488333_",
    className: "st2",
    d: "M288.9,462.7l-4.1-2.4 c-1.2-0.7-1.9-1.7-1.9-2.8s0.7-2.1,1.9-2.8l4.1-2.4l1.2,2.1l-4.1,2.4c-0.5,0.3-0.7,0.6-0.7,0.7s0.2,0.4,0.7,0.7l4.1,2.4 L288.9,462.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000070114292970369711880000003955380820216951445_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000036943475316144792960000018195018343136478387_",
    className: "st2",
    d: "M390.1,449.5l-1.2-2.1l4.1-2.4 c0.5-0.3,0.7-0.6,0.7-0.7c0-0.2-0.2-0.4-0.7-0.7l-4.1-2.4l1.2-2.1l4.1,2.4c1.2,0.7,1.9,1.7,1.9,2.8s-0.7,2.1-1.9,2.8 L390.1,449.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000155847387160266617630000007635257947442101684_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000080174211425197743900000006774554924569462916_",
    className: "st2",
    d: "M328.1,484.1c-1.3,0-2.6-0.3-3.7-0.9 l-4.1-2.4l1.2-2.1l4.1,2.4c1.3,0.8,3.6,0.8,5,0l4.1-2.4l1.2,2.1l-4.1,2.4C330.8,483.8,329.4,484.1,328.1,484.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000148639217981941263040000006528382936305454489_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000147218397698339971660000004584454399271511188_",
    className: "st0",
    d: "M195.5,506.4l6.3-3.6 c1.3-0.7,1.1-2-0.4-2.8l0,0c-1.5-0.8-3.7-0.9-4.9-0.2l-6.3,3.6c-1.3,0.7-1.1,2,0.4,2.8l0,0C192,507,194.2,507.1,195.5,506.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000121281591340735831050000009641242923884017027_",
    className: "st2",
    d: "M193.4,508.1c-1.2,0-2.4-0.3-3.4-0.9 c-1.1-0.7-1.8-1.6-1.8-2.7c0-0.9,0.5-1.7,1.5-2.3l6.3-3.6c1.7-0.9,4.3-0.9,6.1,0.2c1.1,0.7,1.8,1.6,1.8,2.7 c0,0.9-0.5,1.7-1.5,2.3l-6.3,3.6C195.3,507.9,194.4,508.1,193.4,508.1z M198.6,500.4c-0.6,0-1.1,0.1-1.5,0.3l-6.3,3.6 c-0.2,0.1-0.3,0.2-0.3,0.2s0.1,0.3,0.6,0.5c1.1,0.6,2.8,0.7,3.7,0.2l6.3-3.6c0.2-0.1,0.3-0.2,0.3-0.2s-0.1-0.3-0.6-0.5 C200.2,500.6,199.4,500.4,198.6,500.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000114793629211389449110000002263295861060028822_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000001660071022877912100000006008500224619663279_",
    className: "st2",
    d: "M317.9,304.3l6.3-3.6 c1.3-0.7,1.1-2-0.4-2.8l0,0c-1.5-0.8-3.7-0.9-4.9-0.2l-6.3,3.6c-1.3,0.7-1.1,2,0.4,2.8l0,0C314.4,304.9,316.6,305,317.9,304.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000029023780812479193070000002116782589277535158_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000029042385398070789860000005245766193959829399_",
    className: "st1",
    d: "M351.1,324l7.3-4.2c1-0.6,0.8-1.5-0.3-2.2 l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9C348.4,324.5,350.1,324.6,351.1,324z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000075867697759459200410000002702720786768728206_",
    className: "st2",
    d: "M349.4,325.6c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C351.1,325.4,350.3,325.6,349.4,325.6z M340.9,318.8c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L340.9,318.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000139973524329711499810000007376598617214013313_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000017489041006505319960000014620790568461564838_",
    className: "st1",
    d: "M335.3,314.9l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-1.4-0.8c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l1.4,0.8 C332.7,315.4,334.4,315.5,335.3,314.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000041265723727132828520000012357815080088234154_",
    className: "st2",
    d: "M333.7,316.5c-0.9,0-1.9-0.2-2.7-0.7 l-1.4-0.8c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l1.4,0.8c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2L336,316C335.3,316.3,334.5,316.5,333.7,316.5z M330.6,312.8c0.1,0,0.1,0.1,0.2,0.1l1.4,0.8 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-1.4-0.8c-0.8-0.5-2-0.5-2.6-0.2L330.6,312.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000012460540461675088900000011846754328319545531_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000124860462133857222870000004564689027670783881_",
    className: "st1",
    d: "M335.2,333.2l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C332.5,333.7,334.2,333.8,335.2,333.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000156581610966555910330000010583403152554593173_",
    className: "st2",
    d: "M333.5,334.8c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C335.1,334.6,334.3,334.8,333.5,334.8z M325,328c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L325,328z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000028289535467556938670000009866969216370160514_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000071518016278794342330000000812107322477527720_",
    className: "st1",
    d: "M319.4,324.1l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-1.4-0.8c-1.1-0.6-2.8-0.7-3.8-0.2L314,321c-1,0.6-0.8,1.5,0.3,2.2l1.4,0.8 C316.7,324.6,318.4,324.7,319.4,324.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000183944051125131188320000004351659697541658264_",
    className: "st2",
    d: "M317.7,325.7c-0.9,0-1.9-0.2-2.7-0.7 l-1.4-0.8c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l1.4,0.8c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C319.4,325.5,318.6,325.7,317.7,325.7z M314.6,322c0.1,0,0.1,0.1,0.2,0.1l1.4,0.8 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-1.4-0.8c-0.8-0.5-2-0.5-2.6-0.2L314.6,322z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000178193873455178265730000014049817380579144078_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000038382403291219328870000005607580438000639122_",
    className: "st1",
    d: "M319.2,342.4l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C316.5,342.9,318.2,343,319.2,342.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000152258221078589405110000003014822697480516006_",
    className: "st2",
    d: "M317.6,344c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C319.2,343.8,318.4,344,317.6,344z M309,337.2c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L309,337.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000037678255965733291870000003062263450796208542_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000152944090449388360490000002840906148702229655_",
    className: "st1",
    d: "M303.4,333.3l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-1.4-0.8c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l1.4,0.8 C300.8,333.8,302.5,333.9,303.4,333.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000141452412614201211530000005917322789286844078_",
    className: "st2",
    d: "M301.8,334.9c-0.9,0-1.9-0.2-2.7-0.7 l-1.4-0.8c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l1.4,0.8c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C303.4,334.7,302.6,334.9,301.8,334.9z M298.7,331.2c0,0,0.1,0.1,0.2,0.1l1.4,0.8 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-1.4-0.8c-0.8-0.5-2-0.5-2.6-0.2L298.7,331.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000134963534157242576220000016717271166587341240_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000179613647370262043260000002708806118943132053_",
    className: "st1",
    d: "M303.3,351.6l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C300.6,352.1,302.3,352.2,303.3,351.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000178195891533701113250000009047148841129043587_",
    className: "st2",
    d: "M301.6,353.2c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C303.2,353,302.4,353.2,301.6,353.2z M293.1,346.4c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l0,0l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L293.1,346.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000122711988858068247460000004066746839093868464_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000165192616714465608030000000957189739554137732_",
    className: "st1",
    d: "M287.5,342.5l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-1.4-0.8c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l1.4,0.8 C284.8,343,286.5,343.1,287.5,342.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000010271052715667471780000016589085862037326979_",
    className: "st2",
    d: "M285.9,344.1c-0.9,0-1.9-0.2-2.7-0.7 l-1.4-0.8c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l1.4,0.8c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C287.5,343.9,286.7,344.1,285.9,344.1z M282.8,340.4c0,0,0.1,0.1,0.2,0.1l1.4,0.8 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-1.4-0.8c-0.8-0.5-2-0.5-2.6-0.2L282.8,340.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000037664745758782611810000007157968610202514066_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000024713571098840711410000011329544975791074729_",
    className: "st1",
    d: "M287.3,360.8l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C284.7,361.3,286.4,361.4,287.3,360.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000093866136646333577970000013341268727781548939_",
    className: "st2",
    d: "M285.7,362.4c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C287.3,362.3,286.5,362.4,285.7,362.4z M277.2,355.6c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l0,0l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L277.2,355.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000070828837442561405590000017155762286207415480_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000031191793690977049180000015733832027958371990_",
    className: "st1",
    d: "M271.6,351.7l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-1.4-0.8c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l1.4,0.8 C268.9,352.2,270.6,352.3,271.6,351.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000034090440358237821060000000563540044655861657_",
    className: "st2",
    d: "M269.9,353.3c-0.9,0-1.9-0.2-2.7-0.7 l-1.4-0.8c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l1.4,0.8c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C271.5,353.2,270.7,353.3,269.9,353.3z M266.8,349.6c0,0,0.1,0.1,0.2,0.1l1.4,0.8 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-1.4-0.8c-0.8-0.5-2-0.5-2.6-0.2L266.8,349.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000069391170264156263920000012513736851585998497_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000050641641083852305470000017551447767311251123_",
    className: "st1",
    d: "M271.3,370.1l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C268.7,370.6,270.4,370.6,271.3,370.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000036955728746778662550000009598767943133230014_",
    className: "st2",
    d: "M269.7,371.7c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C271.3,371.5,270.5,371.7,269.7,371.7z M261.2,364.8c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L261.2,364.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000083796823549682073940000013657076526423349909_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000109714624610807762740000010986139782264903101_",
    className: "st1",
    d: "M255.6,361l7.3-4.2c1-0.6,0.8-1.5-0.3-2.2 l-1.4-0.8c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l1.4,0.8C252.9,361.5,254.6,361.5,255.6,361z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000098901241528101855860000006826200550630363533_",
    className: "st2",
    d: "M253.9,362.6c-0.9,0-1.9-0.2-2.7-0.7 l-1.4-0.8c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l1.4,0.8c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C255.6,362.4,254.8,362.6,253.9,362.6z M250.8,358.8c0.1,0,0.1,0.1,0.2,0.1l1.4,0.8 c0.8,0.5,2,0.5,2.6,0.2l0,0l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-1.4-0.8c-0.8-0.5-2-0.5-2.6-0.2L250.8,358.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000157267620698104999170000006286451441647883707_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000103237054331600278710000011024033495178770305_",
    className: "st1",
    d: "M255.4,379.3l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C252.7,379.8,254.4,379.8,255.4,379.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000080188687631505349720000013902729699262811821_",
    className: "st2",
    d: "M253.8,380.9c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C255.4,380.7,254.6,380.9,253.8,380.9z M245.2,374c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L245.2,374z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000074412624867495458100000002600374927857225650_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000041990648730079078990000016661661327860285838_",
    className: "st1",
    d: "M239.6,370.2l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-1.4-0.8c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l1.4,0.8 C237,370.7,238.7,370.7,239.6,370.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000104677686408808850900000002563200080324088973_",
    className: "st2",
    d: "M238,371.8c-0.9,0-1.9-0.2-2.7-0.7 l-1.4-0.8c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l1.4,0.8c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C239.6,371.6,238.8,371.8,238,371.8z M234.9,368.1c0.1,0,0.1,0.1,0.2,0.1l1.4,0.8 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-1.4-0.8c-0.8-0.5-2-0.5-2.6-0.2L234.9,368.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000177466541496352481980000005094390380548443031_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000100372613662876041640000008620434997687371150_",
    className: "st1",
    d: "M239.5,388.5l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C236.8,389,238.5,389,239.5,388.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000095306430855922822670000004119352303622693270_",
    className: "st2",
    d: "M237.8,390.1c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C239.4,389.9,238.6,390.1,237.8,390.1z M229.3,383.2c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L229.3,383.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000065763154225593823420000005325974137886711465_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000123425239302146696000000002903277492573411222_",
    className: "st1",
    d: "M223.7,379.4l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-1.4-0.8c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l1.4,0.8 C221,379.9,222.7,379.9,223.7,379.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000107574985008277937490000015484668817347286920_",
    className: "st2",
    d: "M222,381c-0.9,0-1.9-0.2-2.7-0.7l-1.4-0.8 c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l1.4,0.8c1,0.6,1.5,1.4,1.5,2.3c0,0.8-0.5,1.5-1.3,2 l-7.3,4.2C223.7,380.8,222.9,381,222,381z M218.9,377.3c0.1,0,0.1,0.1,0.2,0.1l1.4,0.8c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2 c-0.1,0-0.1-0.1-0.2-0.1l-1.4-0.8c-0.8-0.5-2-0.5-2.6-0.2L218.9,377.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000018218288919160175760000004897385856593523335_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000160152037462359975710000002057217049134142085_",
    className: "st1",
    d: "M223.5,397.7l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C220.9,398.2,222.5,398.2,223.5,397.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000134244376271048407350000014992399155182991238_",
    className: "st2",
    d: "M221.9,399.3c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C223.5,399.1,222.7,399.3,221.9,399.3z M213.3,392.4c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L213.3,392.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000111912589418633738190000000226935891186656677_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000167363294394008008500000007775766920928323751_",
    className: "st1",
    d: "M207.8,388.6l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-1.4-0.8c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l1.4,0.8 C205.1,389.1,206.8,389.1,207.8,388.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000067918286410978556990000011982965046512893873_",
    className: "st2",
    d: "M206.1,390.2c-0.9,0-1.9-0.2-2.7-0.7 l-1.4-0.8c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l1.4,0.8c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C207.7,390,206.9,390.2,206.1,390.2z M203,386.5c0.1,0,0.1,0.1,0.2,0.1l1.4,0.8 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-1.4-0.8c-0.8-0.5-2-0.5-2.6-0.2L203,386.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000160187370567258085250000016452843790957637006_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000050657938042278580100000017849771578193479301_",
    className: "st1",
    d: "M207.6,406.9l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C204.9,407.4,206.6,407.5,207.6,406.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000023246628338974979910000011032986899155235519_",
    className: "st2",
    d: "M205.9,408.5c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C207.6,408.3,206.8,408.5,205.9,408.5z M197.4,401.6c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L197.4,401.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000050653224320602475810000002238521387828253095_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000181795788741612475370000008796404108512333196_",
    className: "st1",
    d: "M191.8,397.8l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-1.4-0.8c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l1.4,0.8 C189.1,398.3,190.8,398.4,191.8,397.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000113320626801721493270000008687731218358469803_",
    className: "st2",
    d: "M190.2,399.4c-0.9,0-1.9-0.2-2.7-0.7 l-1.4-0.8c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l1.4,0.8c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C191.8,399.2,191,399.4,190.2,399.4z M187.1,395.7c0.1,0,0.1,0.1,0.2,0.1l1.4,0.8 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-1.4-0.8c-0.8-0.5-2-0.5-2.6-0.2L187.1,395.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000008846720429059140730000016027723155525185716_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000111882194835985621730000016992273438446074042_",
    className: "st1",
    d: "M191.6,416.1l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C189,416.6,190.7,416.7,191.6,416.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000037663075896584240720000010775611482126024116_",
    className: "st2",
    d: "M190,417.7c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C191.6,417.5,190.8,417.7,190,417.7z M181.5,410.8c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L181.5,410.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000075871800766283565800000002221555697202582698_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000023982546293224982980000015321092940701475501_",
    className: "st1",
    d: "M175.9,407l7.3-4.2c1-0.6,0.8-1.5-0.3-2.2 l-1.4-0.8c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l1.4,0.8C173.2,407.5,174.9,407.6,175.9,407z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000145746324843829112610000013040638442002973314_",
    className: "st2",
    d: "M174.2,408.6c-0.9,0-1.9-0.2-2.7-0.7 l-1.4-0.8c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l1.4,0.8c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C175.8,408.4,175,408.6,174.2,408.6z M171.1,404.9c0.1,0,0.1,0.1,0.2,0.1l1.4,0.8 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-1.4-0.8c-0.8-0.5-2-0.5-2.6-0.2L171.1,404.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000130646055806029283490000013908170421960873861_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000145035217754907358530000003510784917115999119_",
    className: "st1",
    d: "M175.7,425.3l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2L176,415c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C173,425.8,174.7,425.9,175.7,425.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000008127331076892498820000006752544644572889759_",
    className: "st2",
    d: "M174,426.9c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C175.7,426.7,174.9,426.9,174,426.9z M165.5,420c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L165.5,420z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000063612173890124228660000006290066160470491555_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000008127840117183176720000000026084248779668638_",
    className: "st1",
    d: "M159.9,416.2l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-1.4-0.8c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l1.4,0.8 C157.3,416.7,159,416.8,159.9,416.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000171705390124940435190000009303455645741293480_",
    className: "st2",
    d: "M158.3,417.8c-0.9,0-1.9-0.2-2.7-0.7 l-1.4-0.8c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l1.4,0.8c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C159.9,417.6,159.1,417.8,158.3,417.8z M155.2,414.1c0.1,0,0.1,0.1,0.2,0.1l1.4,0.8 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1L165,410c-0.8-0.5-2-0.5-2.6-0.2L155.2,414.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000078757850631711975380000002504070458998153344_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000029765399427274365600000009872359881761012120_",
    className: "st1",
    d: "M159.7,434.5l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C157.1,435,158.8,435.1,159.7,434.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000047044091610114025770000000924007122769158066_",
    className: "st2",
    d: "M158.1,436.1c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C159.7,435.9,158.9,436.1,158.1,436.1z M149.6,429.3c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l0,0l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L149.6,429.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000124124117774159721070000004238230150433081232_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000028296564036763430860000012137887333224046752_",
    className: "st1",
    d: "M144,425.4l7.3-4.2c1-0.6,0.8-1.5-0.3-2.2 l-1.4-0.8c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l1.4,0.8C141.3,425.9,143,426,144,425.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000061470743544838458930000011540312661129228177_",
    className: "st2",
    d: "M142.3,427c-0.9,0-1.9-0.2-2.7-0.7 l-1.4-0.8c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l1.4,0.8c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C144,426.8,143.2,427,142.3,427z M139.2,423.3c0,0,0.1,0.1,0.2,0.1l1.4,0.8c0.8,0.5,2,0.5,2.6,0.2 l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-1.4-0.8c-0.8-0.5-2-0.5-2.6-0.2L139.2,423.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000177454895418515873620000003364193630404808372_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000091006459824050882300000001395548574635071642_",
    className: "st1",
    d: "M143.8,443.7l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C141.1,444.2,142.8,444.3,143.8,443.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000082359815261049234810000017802687719851209397_",
    className: "st2",
    d: "M142.1,445.3c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C143.7,445.1,142.9,445.3,142.1,445.3z M133.6,438.5c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L133.6,438.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000131363113256692396110000010085215797922961849_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000111876587149820250870000005476793917370853302_",
    className: "st1",
    d: "M128,434.6l7.3-4.2c1-0.6,0.8-1.5-0.3-2.2 l-1.4-0.8c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l1.4,0.8C125.3,435.1,127,435.2,128,434.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000151505691832677450920000008562958049406428607_",
    className: "st2",
    d: "M126.4,436.2c-0.9,0-1.9-0.2-2.7-0.7 l-1.4-0.8c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l1.4,0.8c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C128,436,127.2,436.2,126.4,436.2z M123.3,432.5c0.1,0,0.1,0.1,0.2,0.1l1.4,0.8 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-1.4-0.8c-0.8-0.5-2-0.5-2.6-0.2L123.3,432.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000093879170083572192850000001410053648515601300_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000134964711027390198300000001543079351502184332_",
    className: "st1",
    d: "M112.1,443.8l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-1.4-0.8c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l1.4,0.8 C109.4,444.3,111.1,444.4,112.1,443.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000061432768204850874250000015887022411469666998_",
    className: "st2",
    d: "M110.4,445.4c-0.9,0-1.9-0.2-2.7-0.7 l-1.4-0.8c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l1.4,0.8c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C112,445.2,111.2,445.4,110.4,445.4z M107.3,441.7c0.1,0,0.1,0.1,0.2,0.1l1.4,0.8 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-1.4-0.8c-0.8-0.5-2-0.5-2.6-0.2L107.3,441.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000023276210857024792630000009830126029429006492_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000044156998288612917870000014192194097750726575_",
    className: "st1",
    d: "M366.7,333.1l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C364,333.6,365.7,333.6,366.7,333.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000159438231162428608370000017993023549359184530_",
    className: "st2",
    d: "M365,334.7c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C366.7,334.5,365.9,334.7,365,334.7z M356.5,327.8c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L356.5,327.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000111869587741243957980000015723457539861145753_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000163788908487062015860000011940462327355918259_",
    className: "st1",
    d: "M350.8,342.3l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2L351,332c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C348.1,342.8,349.8,342.9,350.8,342.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000078026135430178621040000005506520824801712267_",
    className: "st2",
    d: "M349.1,343.9c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C350.7,343.7,349.9,343.9,349.1,343.9z M340.6,337c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L340.6,337z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000122698724917101361590000016722997891186949271_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000132048723438139911700000008454448125640849081_",
    className: "st1",
    d: "M334.8,351.5l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C332.1,352,333.8,352.1,334.8,351.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000103977034327538749130000005290297417098155408_",
    className: "st2",
    d: "M333.2,353.1c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C334.8,352.9,334,353.1,333.2,353.1z M324.6,346.2c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L324.6,346.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000041287386243634681860000017965502977824976804_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000047780747933186743230000010500804754600338600_",
    className: "st1",
    d: "M318.9,360.7l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C316.2,361.2,317.9,361.3,318.9,360.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000018197924214115786510000014437086955337607073_",
    className: "st2",
    d: "M317.2,362.3c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C318.8,362.1,318,362.3,317.2,362.3z M308.7,355.4c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L308.7,355.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000126314665668821955220000013761872778534553476_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000093893698023201193760000014671860648493312434_",
    className: "st1",
    d: "M302.9,369.9l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C300.3,370.4,302,370.5,302.9,369.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000162338812113830665330000007272184053592999052_",
    className: "st2",
    d: "M301.3,371.5c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C302.9,371.3,302.1,371.5,301.3,371.5z M292.7,364.7c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L292.7,364.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000157994578835052751660000003287212686026197166_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000099655146392276980320000012897310202753587588_",
    className: "st1",
    d: "M286.9,379.1l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C284.3,379.6,286,379.7,286.9,379.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000113343408817459200490000000838991622521752476_",
    className: "st2",
    d: "M285.3,380.7c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C286.9,380.5,286.1,380.7,285.3,380.7z M276.8,373.9c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L276.8,373.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000081624652717470033230000006189064805879398566_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000072965892707730601440000011121896724445174440_",
    className: "st1",
    d: "M271,388.3l7.3-4.2c1-0.6,0.8-1.5-0.3-2.2 l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9C268.3,388.8,270,388.9,271,388.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000048467735985092798880000000553326001502834822_",
    className: "st2",
    d: "M269.3,389.9c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C271,389.7,270.2,389.9,269.3,389.9z M260.8,383.1c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L260.8,383.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000041986109627576118580000015161073392282726824_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000106858728623906260750000007983276915015820713_",
    className: "st1",
    d: "M255.1,397.5l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C252.4,398,254.1,398.1,255.1,397.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000083805659634744241500000015275986972626368898_",
    className: "st2",
    d: "M253.4,399.1c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C255,398.9,254.2,399.1,253.4,399.1z M244.9,392.3c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L244.9,392.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000044143869279785485600000004092847954653394109_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000172433152440392263990000005592800535553205136_",
    className: "st1",
    d: "M239.1,406.7l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C236.5,407.2,238.1,407.3,239.1,406.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000068657056921409867600000002746704722044856216_",
    className: "st2",
    d: "M237.5,408.3c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C239.1,408.2,238.3,408.3,237.5,408.3z M228.9,401.5c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L228.9,401.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000073709646613551391480000001215744371337948600_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000077288114886896164830000003356652994616887988_",
    className: "st1",
    d: "M223.2,416l7.3-4.2c1-0.6,0.8-1.5-0.3-2.2 l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9C220.5,416.4,222.2,416.5,223.2,416z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000037689031471847865880000015415724955611948983_",
    className: "st2",
    d: "M221.5,417.5c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C223.1,417.4,222.3,417.5,221.5,417.5z M213,410.7c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L213,410.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000003063616760801579070000003290491651145552574_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000159452588601968849330000007748668164576925581_",
    className: "st1",
    d: "M207.2,425.2l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C204.6,425.6,206.3,425.7,207.2,425.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000060722884658366050750000004350494915190207644_",
    className: "st2",
    d: "M205.6,426.7c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C207.2,426.6,206.4,426.7,205.6,426.7z M197.1,419.9c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L197.1,419.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000135664892776541039710000014512536487792209085_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000013191023829563102010000007768402844978275990_",
    className: "st1",
    d: "M191.3,434.4l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C188.6,434.9,190.3,434.9,191.3,434.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000178163690002948145730000009096273281654535579_",
    className: "st2",
    d: "M189.6,435.9c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C191.3,435.8,190.5,435.9,189.6,435.9z M181.1,429.1c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L181.1,429.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000086663161072981034010000012156215202821696898_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000104706162785559848630000011363540902495419301_",
    className: "st1",
    d: "M175.3,443.6l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C172.7,444.1,174.4,444.1,175.3,443.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000092423619865678005110000002760632919497370015_",
    className: "st2",
    d: "M173.7,445.2c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C175.3,445,174.5,445.2,173.7,445.2z M165.2,438.3c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L165.2,438.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000151536261283045910780000004155225180430058904_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000119095571677323012340000002662346480447794320_",
    className: "st1",
    d: "M159.4,452.8l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C156.7,453.3,158.4,453.4,159.4,452.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000144298525734591481770000010906578316643415954_",
    className: "st2",
    d: "M157.7,454.4c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C159.3,454.2,158.5,454.4,157.7,454.4z M149.2,447.5c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L149.2,447.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000168797583092070458230000015554396861031995781_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000070089777668026414700000006789153661939652771_",
    className: "st1",
    d: "M143.4,462l7.3-4.2c1-0.6,0.8-1.5-0.3-2.2 l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9C140.8,462.5,142.4,462.6,143.4,462z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000170260824436563864500000004227900974833488055_",
    className: "st2",
    d: "M141.8,463.6c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2L144,463C143.4,463.4,142.6,463.6,141.8,463.6z M133.2,456.7c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L133.2,456.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000134963075785384965230000012817947300568935313_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000174583822801958129140000001129144712148780991_",
    className: "st1",
    d: "M127.5,471.2l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C124.8,471.7,126.5,471.8,127.5,471.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000138549108442006901330000007146178717472463523_",
    className: "st2",
    d: "M125.8,472.8c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C127.5,472.6,126.7,472.8,125.8,472.8z M117.3,465.9c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L117.3,465.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000171715655000196983660000002213705555173682357_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000075140162833613662430000005058765224431901584_",
    className: "st1",
    d: "M382.4,342.1l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C379.7,342.6,381.4,342.7,382.4,342.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000114048451646648422760000012163545561670164105_",
    className: "st2",
    d: "M380.7,343.7c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C382.4,343.6,381.6,343.7,380.7,343.7z M372.2,336.9c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l0,0l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L372.2,336.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000052082711764422025790000008609245701963309503_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000160165300896293324100000010357174802056800177_",
    className: "st1",
    d: "M366.4,351.4l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C363.8,351.8,365.5,351.9,366.4,351.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000101101018984284066220000013779227954872997033_",
    className: "st2",
    d: "M364.8,352.9c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C366.4,352.8,365.6,352.9,364.8,352.9z M356.3,346.1c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L356.3,346.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000021826509625665347340000002111058687826698652_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000168816376956722460450000009285563020760782776_",
    className: "st1",
    d: "M350.5,360.6l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C347.8,361,349.5,361.1,350.5,360.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000096052823396951844990000009661640001225503423_",
    className: "st2",
    d: "M348.9,362.1c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C350.5,362,349.7,362.1,348.9,362.1z M340.3,355.3c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L340.3,355.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000086677890388051349340000017145148304268167812_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000124875538419227328670000007637440349376009632_",
    className: "st1",
    d: "M334.6,369.8l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C331.9,370.3,333.6,370.3,334.6,369.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000144313311009169252290000010287758647374980024_",
    className: "st2",
    d: "M332.9,371.3c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C334.5,371.2,333.7,371.3,332.9,371.3z M324.4,364.5c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L324.4,364.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000017484957932525074250000012297662581678294439_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000026153330809356188940000002389273777396441498_",
    className: "st1",
    d: "M318.6,379l7.3-4.2c1-0.6,0.8-1.5-0.3-2.2 l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9C316,379.5,317.6,379.5,318.6,379z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000142877496672498131290000005927611229533403581_",
    className: "st2",
    d: "M317,380.6c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C318.6,380.4,317.8,380.6,317,380.6z M308.4,373.7c0,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L308.4,373.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000178186827014911631010000015389665871584149437_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000176008029627360633420000010653343835697133745_",
    className: "st1",
    d: "M302.6,388.2l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C300,388.7,301.7,388.8,302.6,388.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000022560124832758430380000006309083671165170071_",
    className: "st2",
    d: "M301,389.8c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C302.6,389.6,301.8,389.8,301,389.8z M292.5,382.9c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l0,0l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L292.5,382.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000061453927800669365400000009683201058469735322_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000087396811965334117930000001743252216697833146_",
    className: "st1",
    d: "M286.7,397.4l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C284,397.9,285.7,398,286.7,397.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000001644059466372626300000000642995950019940505_",
    className: "st2",
    d: "M285,399c-0.9,0-1.9-0.2-2.7-0.7l-6.8-3.9 c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3c0,0.8-0.5,1.5-1.3,2 l-7.3,4.2C286.7,398.8,285.9,399,285,399z M276.5,392.1c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9c0.8,0.5,2,0.5,2.6,0.2l0,0l7.3-4.2 c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L276.5,392.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000047050465575112821650000000306564382062480781_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000135648754338650447780000017602204056821908111_",
    className: "st1",
    d: "M270.8,406.6l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C268.1,407.1,269.8,407.2,270.8,406.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000142148561501418252710000012709227975143432367_",
    className: "st2",
    d: "M269.1,408.2c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C270.7,408,269.9,408.2,269.1,408.2z M260.6,401.3c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l0,0l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L260.6,401.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000074417495539472959990000010628638040435367840_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000086682206008749176080000004336610824927648679_",
    className: "st1",
    d: "M254.8,415.8l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C252.1,416.3,253.8,416.4,254.8,415.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000078728123626239043820000011158757451644878266_",
    className: "st2",
    d: "M253.2,417.4c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C254.8,417.2,254,417.4,253.2,417.4z M244.6,410.5c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l0,0l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L244.6,410.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000080188392616985052470000001127196840246961318_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000057868086951070041890000014855872785134001544_",
    className: "st1",
    d: "M238.9,425l7.3-4.2c1-0.6,0.8-1.5-0.3-2.2 l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9C236.2,425.5,237.9,425.6,238.9,425z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000129900017099668580630000009234732905171486867_",
    className: "st2",
    d: "M237.2,426.6c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C238.8,426.4,238,426.6,237.2,426.6z M228.7,419.8c0,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L228.7,419.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000168832693880455585700000012841756349591115146_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000147904344183345617780000009599350460844146093_",
    className: "st1",
    d: "M222.9,434.2l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C220.3,434.7,222,434.8,222.9,434.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000046336671550531984960000000501319074251655301_",
    className: "st2",
    d: "M221.3,435.8c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C222.9,435.6,222.1,435.8,221.3,435.8z M212.8,429c0,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L212.8,429z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000164491353513533121630000004043559241189950632_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000107548590022749893580000010315217978690671536_",
    className: "st1",
    d: "M207,443.4l7.3-4.2c1-0.6,0.8-1.5-0.3-2.2 l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9C204.3,443.9,206,444,207,443.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000133516873594830674420000016595141798191415463_",
    className: "st2",
    d: "M205.3,445c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C207,444.8,206.2,445,205.3,445z M196.8,438.2c0,0,0.1,0.1,0.2,0.1l6.8,3.9c0.8,0.5,2,0.5,2.6,0.2 l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L196.8,438.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000072269968741475677640000002259461711711858842_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000017483866829972920480000007387075019710269592_",
    className: "st1",
    d: "M191,452.6l7.3-4.2c1-0.6,0.8-1.5-0.3-2.2 l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9C188.4,453.1,190.1,453.2,191,452.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000177456701108269408600000008924682657177871799_",
    className: "st2",
    d: "M189.4,454.2c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C191,454,190.2,454.2,189.4,454.2z M180.9,447.4c0,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L180.9,447.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000138564226180950101000000015544194251648767645_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000150088427237806586190000012470831243996315804_",
    className: "st1",
    d: "M175.1,461.9l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C172.4,462.3,174.1,462.4,175.1,461.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000126316912737757267140000014133734300605750691_",
    className: "st2",
    d: "M173.4,463.4c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C175,463.3,174.2,463.4,173.4,463.4z M164.9,456.6c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L164.9,456.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000118368076866448825000000013813740399752810165_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000163763759286039641080000001508683492854573204_",
    className: "st1",
    d: "M159.1,471.1l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C156.5,471.5,158.1,471.6,159.1,471.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000021810757204221172900000002474816588120765103_",
    className: "st2",
    d: "M157.5,472.6c-0.9,0-1.9-0.2-2.7-0.7 L148,468c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C159.1,472.5,158.3,472.6,157.5,472.6z M148.9,465.8c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c0,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L148.9,465.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000076604100682891239960000007976041454403688337_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000035509983246865209390000012714189198252088726_",
    className: "st1",
    d: "M143.2,480.3l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C140.5,480.8,142.2,480.8,143.2,480.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000091703808994674368960000011942809549992037250_",
    className: "st2",
    d: "M141.5,481.8c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C143.1,481.7,142.3,481.8,141.5,481.8z M133,475c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L133,475z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000016757988014032325250000012415323238908544924_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000101064080161524249650000017395579358236534684_",
    className: "st1",
    d: "M158.9,489.3l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2L148,483c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C156.2,489.8,157.9,489.9,158.9,489.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000055682856848934058750000009732626043072229519_",
    className: "st2",
    d: "M157.2,490.9c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C158.8,490.7,158,490.9,157.2,490.9z M148.7,484.1c0,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L148.7,484.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000088121000690394881130000014906529913608734882_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000045603110759531922000000008946797050147347886_",
    className: "st1",
    d: "M174.6,498.4l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C171.9,498.9,173.6,498.9,174.6,498.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000108289052483133080490000011843683250774055302_",
    className: "st2",
    d: "M172.9,500c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C174.5,499.8,173.7,500,172.9,500z M164.4,493.1c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L164.4,493.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000150781716310995716010000013546795936567315597_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000010307131261833826750000015801352089608024760_",
    className: "st1",
    d: "M366.3,369.7l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C363.6,370.2,365.3,370.2,366.3,369.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000036223204050161788350000014554153110534723774_",
    className: "st2",
    d: "M364.6,371.3c-1,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C366.3,371.1,365.5,371.3,364.6,371.3z M356.1,364.4c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L356.1,364.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000024705152147258254630000011955538566151577472_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000155116494932051916390000008889033623582184604_",
    className: "st1",
    d: "M350.3,378.9l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C347.7,379.4,349.4,379.4,350.3,378.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000092430812442989684240000001583010934895992225_",
    className: "st2",
    d: "M348.7,380.5c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2L351,380C350.3,380.3,349.5,380.5,348.7,380.5z M340.2,373.6c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L340.2,373.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000039823851362971762090000012212298136851105155_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000095319982834751263230000006698375548574045113_",
    className: "st1",
    d: "M334.4,388.1l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C331.7,388.6,333.4,388.6,334.4,388.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000039135279449374354650000009969652874064883090_",
    className: "st2",
    d: "M332.7,389.7c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C334.4,389.5,333.6,389.7,332.7,389.7z M324.2,382.8c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L324.2,382.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000066473838144042998420000007361950918192164228_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000042709073314217060320000016814791323507685534_",
    className: "st1",
    d: "M318.4,397.3l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C315.8,397.8,317.4,397.9,318.4,397.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000159448002750490774900000009434815531493788592_",
    className: "st2",
    d: "M316.8,398.9c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C318.4,398.7,317.6,398.9,316.8,398.9z M308.2,392c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L308.2,392z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000035512460490914367470000011180922387274485904_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000018947204036745004330000006223288963142097850_",
    className: "st1",
    d: "M302.5,406.5l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C299.8,407,301.5,407.1,302.5,406.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000013914402320512897820000000698870611165884292_",
    className: "st2",
    d: "M300.8,408.1c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C302.4,407.9,301.6,408.1,300.8,408.1z M292.3,401.2c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L292.3,401.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000001640471103038402670000006961385485631538574_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000159429500055560781730000010037497465552150938_",
    className: "st1",
    d: "M286.5,415.7l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C283.9,416.2,285.6,416.3,286.5,415.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000101076841681090295450000014919782886494303890_",
    className: "st2",
    d: "M284.9,417.3c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C286.5,417.1,285.7,417.3,284.9,417.3z M276.4,410.5c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L276.4,410.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000078735526923927047470000003940048262133954706_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000147202380399190480220000016789569632088831110_",
    className: "st1",
    d: "M270.6,424.9l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C267.9,425.4,269.6,425.5,270.6,424.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000094584551524029660570000006282510034541279648_",
    className: "st2",
    d: "M268.9,426.5c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C270.6,426.3,269.8,426.5,268.9,426.5z M260.4,419.7c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L260.4,419.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000079466439287638998160000010193933349414148029_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000062161684726944233260000009432113754131542685_",
    className: "st1",
    d: "M254.6,434.1l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C252,434.6,253.7,434.7,254.6,434.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000033345064020248457690000013333680376896715446_",
    className: "st2",
    d: "M253,435.7c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C254.6,435.5,253.8,435.7,253,435.7z M244.5,428.9c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L244.5,428.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000054959755979165471440000010959361882294071215_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000016037873657192038620000006710287211713248657_",
    className: "st1",
    d: "M238.7,443.3l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2L239,433c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C236,443.8,237.7,443.9,238.7,443.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000164479709532553449770000004820241042755103379_",
    className: "st2",
    d: "M237,444.9c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C238.7,444.7,237.9,444.9,237,444.9z M228.5,438.1c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L228.5,438.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000030451700461441900370000012495630012279232939_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000176030935680319904380000008685248372936644795_",
    className: "st1",
    d: "M222.8,452.5l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C220.1,453,221.8,453.1,222.8,452.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000139279729279537056220000008262144652096663963_",
    className: "st2",
    d: "M221.1,454.1c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C222.7,453.9,221.9,454.1,221.1,454.1z M212.6,447.3c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L212.6,447.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000163074145437308795310000000608281973163043982_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000162350484434248408570000004654354083825960089_",
    className: "st1",
    d: "M206.8,461.7l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C204.1,462.2,205.8,462.3,206.8,461.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000023256522359527394560000011817166818192665020_",
    className: "st2",
    d: "M205.2,463.3c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C206.8,463.1,206,463.3,205.2,463.3z M196.6,456.5c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L196.6,456.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000065771631895186751390000001750611843727499690_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000021092012541256877480000016459647875574907789_",
    className: "st0",
    d: "M190.8,471l7.3-4.2c1-0.6,0.8-1.5-0.3-2.2 l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9C188.2,471.5,189.9,471.5,190.8,471z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000179633310215078426390000012765525053828673176_",
    className: "st2",
    d: "M189.2,472.5c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C190.8,472.4,190,472.5,189.2,472.5z M180.7,465.7c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L180.7,465.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000029764865803607445100000009951035649689100729_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000039825817699810247560000012108267971229716633_",
    className: "st1",
    d: "M382.3,360.4l23.2-13.4 c1-0.6,0.9-1.6-0.3-2.2l-6.8-3.9c-1.1-0.7-2.8-0.7-3.8-0.2l-23.2,13.4c-1,0.6-0.9,1.6,0.3,2.2l6.8,3.9 C379.6,360.9,381.3,361,382.3,360.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000016775510706362767780000009300680077671153793_",
    className: "st2",
    d: "M380.6,362c-1,0-1.9-0.2-2.8-0.7l-6.8-3.9 c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l23.2-13.4c1.4-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-23.2,13.4C382.3,361.8,381.5,362,380.6,362z M372.1,355.2c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2.1,0.5,2.6,0.2l23.1-13.4c-0.1,0-0.1-0.1-0.2-0.2l-6.8-3.9c-0.8-0.5-2.1-0.5-2.6-0.2L372.1,355.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000109001350690694121800000002678480616718846353_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000133514534884861296770000006018729606989185666_",
    className: "st1",
    d: "M175,480.1l23.2-13.4 c1-0.6,0.9-1.6-0.3-2.2l-6.8-3.9c-1.1-0.7-2.8-0.7-3.8-0.2l-23.2,13.4c-1,0.6-0.9,1.6,0.3,2.2l6.8,3.9 C172.3,480.6,174,480.7,175,480.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000146481024240125138000000017146648871240580997_",
    className: "st2",
    d: "M173.3,481.7c-1,0-1.9-0.2-2.8-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l23.2-13.4c1.4-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-23.2,13.4C174.9,481.5,174.1,481.7,173.3,481.7z M164.8,474.9c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2.1,0.5,2.6,0.2l23.1-13.4c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2.1-0.5-2.6-0.2L164.8,474.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000150782541827897324050000002750470517167285412_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000076575114204431297840000011788332213602332059_",
    className: "st1",
    d: "M111.9,462.1l23.2-13.4 c1-0.6,0.9-1.6-0.3-2.2l-6.8-3.9c-1.1-0.7-2.8-0.7-3.8-0.2L101,455.8c-1,0.6-0.9,1.6,0.3,2.2l6.8,3.9 C109.2,462.6,110.9,462.7,111.9,462.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000183966815276025336340000011107292583079773844_",
    className: "st2",
    d: "M110.2,463.7c-1,0-1.9-0.2-2.8-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l23.2-13.4c1.4-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-23.2,13.4C111.9,463.5,111.1,463.7,110.2,463.7z M101.7,456.9c0.1,0,0.1,0.1,0.2,0.2l6.8,3.9 c0.8,0.5,2.1,0.5,2.6,0.2l23.1-13.4c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2.1-0.5-2.6-0.2L101.7,456.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000143576782543412539710000009682831008523061419_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000122699623555784024720000011295320606100407441_",
    className: "st1",
    d: "M381.8,378.6l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C379.2,379.1,380.8,379.2,381.8,378.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000020366645689556131590000011809468583981103256_",
    className: "st2",
    d: "M380.2,380.2c-1,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C381.8,380,381,380.2,380.2,380.2z M371.6,373.4c0,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L371.6,373.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000011013284401375245820000015046684797302336928_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000162349829016117784230000006522214204096070578_",
    className: "st1",
    d: "M365.9,387.8l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C363.2,388.3,364.9,388.4,365.9,387.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000012451325284378813390000011512990103911829391_",
    className: "st2",
    d: "M364.2,389.4c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C365.8,389.2,365,389.4,364.2,389.4z M355.7,382.6c0,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L355.7,382.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000158710283472738088810000006310265486557046167_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000098920818825142660590000016602128138067285667_",
    className: "st1",
    d: "M413.7,360.2l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C411.1,360.7,412.8,360.8,413.7,360.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000107575087550639491180000004713510984992337557_",
    className: "st2",
    d: "M412.1,361.8c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C413.7,361.6,412.9,361.8,412.1,361.8z M403.6,355c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L403.6,355z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000051349354911322767730000003608479123874281097_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000007396519627986973740000005325804934940925864_",
    className: "st1",
    d: "M397.8,369.4l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C395.1,369.9,396.8,370,397.8,369.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000088829577912380695090000010220944942508845449_",
    className: "st2",
    d: "M396.1,371c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C397.8,370.8,397,371,396.1,371z M387.6,364.2c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L387.6,364.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000043447549142227858450000013741884039694973069_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000026129170764738246300000010276712526583213704_",
    className: "st1",
    d: "M286.2,433.9l71.1-41 c1-0.6,0.9-1.6-0.3-2.2l-6.8-3.9c-1.1-0.7-2.8-0.7-3.8-0.2l-71.1,41c-1,0.6-0.9,1.6,0.3,2.2l6.8,3.9 C283.5,434.3,285.2,434.4,286.2,433.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000049191986488708744710000010036213683808206722_",
    className: "st2",
    d: "M284.5,435.4c-1,0-1.9-0.2-2.8-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l71.1-41c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-71.1,41C286.2,435.3,285.4,435.4,284.5,435.4z M276,428.6c0.1,0,0.1,0.1,0.2,0.2l6.8,3.9 c0.8,0.5,2.1,0.5,2.6,0.2l71-41c-0.1,0-0.1-0.1-0.2-0.2l-6.8-3.9c-0.8-0.5-2.1-0.5-2.6-0.2L276,428.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000165934620355993737220000014722513866115164842_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000005952778322727486760000016195702964909957043_",
    className: "st1",
    d: "M270.2,443.1l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C267.5,443.6,269.2,443.7,270.2,443.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000072993402048498535710000014330200430814764472_",
    className: "st2",
    d: "M268.5,444.7c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C270.2,444.5,269.4,444.7,268.5,444.7z M260,437.8c0,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L260,437.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000176736768820647831610000012947942387391125903_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000049184403373204109710000007283365962997362609_",
    className: "st1",
    d: "M254.2,452.3l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C251.6,452.8,253.3,452.9,254.2,452.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000101809768290198333560000011130888215051351471_",
    className: "st2",
    d: "M252.6,453.9c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C254.2,453.7,253.4,453.9,252.6,453.9z M244.1,447c0,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1L254,443c-0.8-0.5-2-0.5-2.6-0.2L244.1,447z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000139984361898147613350000008295918893864830383_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000136411798638515171170000004114174587832941707_",
    className: "st1",
    d: "M238.3,461.5l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C235.6,462,237.3,462.1,238.3,461.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000087407868214647308890000009860981422556460963_",
    className: "st2",
    d: "M236.6,463.1c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C238.3,462.9,237.5,463.1,236.6,463.1z M228.1,456.2c0,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L228.1,456.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000109744614860067944180000012493594267670245015_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000039128001579203999430000017064586753485120905_",
    className: "st1",
    d: "M222.3,470.7l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C219.7,471.2,221.4,471.3,222.3,470.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000140720655845944002620000007741046231703575208_",
    className: "st2",
    d: "M220.7,472.3c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C222.3,472.1,221.5,472.3,220.7,472.3z M212.2,465.4c0,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L212.2,465.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000162333581759480119940000015214900113303966605_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000115506291538074115310000012205239282463936673_",
    className: "st1",
    d: "M206.4,479.9l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C203.7,480.4,205.4,480.5,206.4,479.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000115478867790242353540000007731542924305851581_",
    className: "st2",
    d: "M204.7,481.5c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2L207,481C206.3,481.3,205.5,481.5,204.7,481.5z M196.2,474.7c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L196.2,474.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000078017871436841760470000005597308903716894645_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000140692662856766108150000011072069380989430194_",
    className: "st1",
    d: "M190.4,489.1l7.3-4.2 c1-0.6,0.8-1.5-0.3-2.2l-6.8-3.9c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l6.8,3.9 C187.8,489.6,189.5,489.7,190.4,489.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000161601551414887669150000009764496884629386917_",
    className: "st2",
    d: "M188.8,490.7c-0.9,0-1.9-0.2-2.7-0.7 l-6.8-3.9c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l6.8,3.9c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C190.4,490.5,189.6,490.7,188.8,490.7z M180.3,483.9c0.1,0,0.1,0.1,0.2,0.1l6.8,3.9 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-6.8-3.9c-0.8-0.5-2-0.5-2.6-0.2L180.3,483.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000067200821341699052760000004042382792417431699_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000039096014955553472250000010212033763112789139_",
    className: "st1",
    d: "M96.1,453l7.3-4.2c1-0.6,0.8-1.5-0.3-2.2 l-1.4-0.8c-1.1-0.6-2.8-0.7-3.8-0.2l-7.3,4.2c-1,0.6-0.8,1.5,0.3,2.2l1.4,0.8C93.5,453.5,95.1,453.6,96.1,453z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000152237951740429721970000011834929721212305558_",
    className: "st2",
    d: "M94.5,454.6c-0.9,0-1.9-0.2-2.7-0.7 l-1.4-0.8c-1-0.6-1.5-1.4-1.5-2.3c0-0.8,0.5-1.5,1.3-2l7.3-4.2c1.3-0.8,3.5-0.7,5,0.2l1.4,0.8c1,0.6,1.5,1.4,1.5,2.3 c0,0.8-0.5,1.5-1.3,2l-7.3,4.2C96.1,454.4,95.3,454.6,94.5,454.6z M91.4,450.9c0.1,0,0.1,0.1,0.2,0.1l1.4,0.8 c0.8,0.5,2,0.5,2.6,0.2l7.3-4.2c-0.1,0-0.1-0.1-0.2-0.1l-1.4-0.8c-0.8-0.5-2-0.5-2.6-0.2L91.4,450.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000149364566290111027900000016213477641357285782_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000177453947739887797250000015739007808799019181_",
    className: "st2",
    d: "M81.5,440.8l0.7-0.4 c1.3-0.7,1.1-2-0.4-2.9l0,0c-1.5-0.9-3.7-0.9-5-0.2l-0.7,0.4c-1.3,0.7-1.1,2,0.4,2.9l0,0C78,441.5,80.2,441.6,81.5,440.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000086673706484776574720000013291800247522924716_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000052100533658223267210000001410025877222540166_",
    x: 84.7,
    y: 422,
    transform: "matrix(0.8668 -0.4987 0.4987 0.8668 -196.8496 109.5502)",
    className: "st2",
    width: 43.9,
    height: 2.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000137127141920822454160000004425264106408887956_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000043451944548980667110000000115146603332611006_",
    x: 131.2,
    y: 402.5,
    transform: "matrix(0.8657 -0.5005 0.5005 0.8657 -183.2015 124.4966)",
    className: "st2",
    width: 18.5,
    height: 2.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000036958435635126477740000015792114441410624130_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000165195169355884503660000017290844333984961983_",
    x: 286.8,
    y: 311.9,
    transform: "matrix(0.8674 -0.4976 0.4976 0.8674 -116.3676 189.5127)",
    className: "st2",
    width: 21.2,
    height: 2.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000009551495026248093950000004549577292374007450_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000088832152153500842420000003225952920111697545_",
    className: "st2",
    d: "M482.1,405.3l-1.2-2.1l15.6-9 c0.8-0.5,1.2-1,1.2-1.5s-0.5-1.1-1.2-1.5l-32-18.5l1.2-2.1l32,18.5c1.6,0.9,2.4,2.2,2.4,3.6s-0.9,2.7-2.4,3.6L482.1,405.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000143588483164769271560000006965657032453380522_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000140698912124646709050000007557320003314338223_",
    x: 218.4,
    y: 519.1,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -351.9967 456.8562)",
    className: "st2",
    width: 2.4,
    height: 28.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000078034370086453006280000010385940582677682860_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000067948296632099644700000007898396197433378495_",
    x: 194,
    y: 510.9,
    transform: "matrix(0.5 -0.866 0.866 0.5 -352.049 428.5959)",
    className: "st2",
    width: 2.4,
    height: 16.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000096061313079120941430000003227669575083982236_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000145042126860638743010000006130782735967502515_",
    x: 454.5,
    y: 360.5,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -89.2718 577.788)",
    className: "st2",
    width: 2.4,
    height: 11.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000106862691690759486840000015453387374567209344_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000078748986205251082740000015511108946420549793_",
    x: 496.8,
    y: 403.2,
    className: "st2",
    width: 2.4,
    height: 6.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000021101118936343951810000001240293724668062650_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000168075593732393789010000006808768696178255545_",
    x: 474.1,
    y: 416.5,
    className: "st2",
    width: 2.4,
    height: 6.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000084508795637367623730000015341078676441906052_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000119840638620940378550000014504637918023816339_",
    x: 242.7,
    y: 549.3,
    className: "st2",
    width: 2.4,
    height: 6.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000128482203550955100520000008820136839590851204_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000033349500807882215470000001827914642699275706_",
    x: 255.7,
    y: 542.2,
    className: "st2",
    width: 2.4,
    height: 6.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000019662352107290394500000002861699382955108267_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000023966992793750816580000017231825435934291121_",
    x: 282,
    y: 527.4,
    className: "st2",
    width: 2.4,
    height: 6.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000076582690134460193900000002200394864563011990_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000060025830630765499920000010448101729348895162_",
    className: "st0",
    d: "M61,462.6c-2.5-6.1-1.8-10.4-1.7-10.6 l2.4,0.4l-1.2-0.2l1.2,0.2c0,0-0.6,3.9,1.6,9.3L61,462.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000073000058453052169000000008749398694219361931_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000181777726890686567450000014797444380726661539_",
    className: "st0",
    d: "M74.1,470.7c-1.9-5.5-1-10.4-1-10.6 l2.4,0.5c0,0-0.8,4.4,0.9,9.3L74.1,470.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000006709105144341670220000016518733145726476717_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000132081183986808897300000007906230837551368343_",
    x: 229.1,
    y: 549.3,
    className: "st0",
    width: 2.4,
    height: 5.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000039820830760630323550000009946478743030893759_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000152945574922273190200000009359117069634185369_",
    x: 207.5,
    y: 537.6,
    className: "st0",
    width: 2.4,
    height: 6.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000137853837145471493770000001796149315832072365_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000093889521234423155040000015499068637687901363_",
    className: "st0",
    d: "M100.2,483c-0.4,0-0.9-0.1-1.3-0.4 l-6.7-3.9c-1.4-0.8-2.4-2.7-2.4-4.5c0-1.1,0.4-2,1.2-2.5c0.7-0.4,1.6-0.4,2.4,0.1l6.7,3.9c1.4,0.8,2.4,2.7,2.4,4.5 c0,1.1-0.4,2-1.2,2.5C101,483,100.6,483,100.2,483z M93.4,476.7l6.6,3.8c0-0.1,0-0.2,0-0.3c0-1-0.6-2.1-1.2-2.4l-6.6-3.8 c0,0.1,0,0.2,0,0.3C92.2,475.3,92.9,476.4,93.4,476.7L93.4,476.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000110457027661481031450000002238818648811843263_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000043457778034748767630000013542042276555690661_",
    className: "st0",
    d: "M115.8,492c-0.4,0-0.9-0.1-1.3-0.4 l-6.7-3.9c-1.4-0.8-2.4-2.7-2.4-4.5c0-1.1,0.4-2,1.2-2.5c0.7-0.4,1.6-0.4,2.4,0.1l6.7,3.9c1.4,0.8,2.4,2.7,2.4,4.5 c0,1.1-0.4,2-1.2,2.5C116.5,491.9,116.2,492,115.8,492z M109,485.7l6.6,3.8c0-0.1,0-0.2,0-0.3c0-1-0.6-2-1.2-2.4l-6.6-3.8 c0,0.1,0,0.2,0,0.3C107.8,484.3,108.4,485.3,109,485.7L109,485.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000129889447280592834500000004717474186139746191_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000120556600914409624610000017481766610574608551_",
    x: 55.8,
    y: 204.8,
    transform: "matrix(0.5463 -0.8376 0.8376 0.5463 -148.802 142.3136)",
    className: "st2",
    width: 2.4,
    height: 7.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000070797209996592808580000016773776426357267387_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000109735975895949626160000009543950121030488976_",
    x: 87.9,
    y: 185.8,
    transform: "matrix(0.5463 -0.8376 0.8376 0.5463 -118.3405 160.5907)",
    className: "st2",
    width: 2.4,
    height: 7.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000066508231156770411480000011972702916933242025_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000175285929476916603350000017235076429076110508_",
    x: 307.1,
    y: 59.8,
    transform: "matrix(0.5463 -0.8376 0.8376 0.5463 86.5911 287.0499)",
    className: "st2",
    width: 2.4,
    height: 7.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000162346292741585086800000007542426436660761529_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000091704637736487942420000005233269227889863615_",
    x: 289.8,
    y: 69.5,
    transform: "matrix(0.5462 -0.8376 0.8376 0.5462 70.6411 276.9951)",
    className: "st2",
    width: 2.4,
    height: 7.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000159453915471111580760000007541920132409658510_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000036961640833374159600000002156893681001723827_",
    x: 45.3,
    y: 222.6,
    transform: "matrix(0.4989 -0.8666 0.8666 0.4989 -172.2352 153.3182)",
    className: "st0",
    width: 2.4,
    height: 6.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000069361361951423417810000008903068390164307134_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000106847684059015594630000013934400098250755744_",
    x: 45.3,
    y: 276.6,
    transform: "matrix(0.4988 -0.8667 0.8667 0.4988 -219.1071 180.4818)",
    className: "st0",
    width: 2.4,
    height: 6.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000072257561411415487270000013196756571722821513_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000134250147774265510480000017172023857204506019_",
    x: 317.6,
    y: 263.6,
    transform: "matrix(0.4991 -0.8666 0.8666 0.4991 -69.9949 409.0409)",
    className: "st0",
    width: 2.4,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000033342954934892040500000001542583224316901510_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000016066839082526423930000011382860988229207486_",
    x: 45.3,
    y: 415.7,
    transform: "matrix(0.4988 -0.8667 0.8667 0.4988 -339.6444 250.1669)",
    className: "st0",
    width: 2.4,
    height: 6.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000112592907608637940420000018035506535126066081_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000055689579044142915000000017084698276580574871_",
    x: 45.4,
    y: 427.3,
    transform: "matrix(0.499 -0.8666 0.8666 0.499 -349.5827 255.9253)",
    className: "st0",
    width: 2.4,
    height: 6.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000054266228804128130290000009671015163686494854_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000009567469066697994040000000267939489897754044_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000078745710704252256440000011355909087220777610_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000168812111601112960520000011313006014148757665_",
    className: "st0",
    d: "M170.2,278.3l34.3-19.7 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6L170.2,267c-0.5,0.3-0.8,1-0.8,1.6v9.1C169.4,278.2,169.7,278.5,170.2,278.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000099661252583028580900000018026002253531400358_",
    className: "st1",
    d: "M169.9,279.1c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l34.3-19.7c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-34.3,19.7C170.3,279,170.1,279.1,169.9,279.1z M204.7,247.9l-34.1,19.6c-0.2,0.1-0.5,0.6-0.5,1v9 l34.1-19.6c0.2-0.1,0.5-0.6,0.5-1V247.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000129193086489237280870000001294811822412649354_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000018230093148407411240000003736122344958275223_",
    className: "st1",
    d: "M237.6,239.5l1.9-1.1 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6l-1.9,1.1c-0.5,0.3-0.8,1-0.8,1.6v9.1C236.8,239.5,237.1,239.7,237.6,239.5z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000181059139648173301110000014561289106586440356_",
    className: "st1",
    d: "M237.3,240.3c-0.2,0-0.4-0.1-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l1.9-1.1c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-1.9,1.1C237.7,240.2,237.5,240.3,237.3,240.3z M239.7,227.7l-1.7,1c-0.2,0.1-0.5,0.6-0.5,1v9l1.7-1 c0.2-0.1,0.5-0.6,0.5-1V227.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000183248092135442636630000006604668497913589907_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000101789302527262178020000017256231284499243680_",
    className: "st0",
    d: "M155.3,304.3l1.9-1.1 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6l-1.9,1.1c-0.5,0.3-0.8,1-0.8,1.6v9.1C154.5,304.2,154.9,304.5,155.3,304.3z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000161596370288881671410000006860269031952244384_",
    className: "st1",
    d: "M155,305.1c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l1.9-1.1c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-1.9,1.1C155.5,305,155.2,305.1,155,305.1z M157.4,292.5l-1.7,1c-0.2,0.1-0.5,0.6-0.5,1v9l1.7-1 c0.2-0.1,0.5-0.6,0.5-1V292.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000017499932335003111790000005829825455181280927_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000154386071758451556950000008464000034775627398_",
    className: "st0",
    d: "M251.1,231.7l12.7-7.3 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6l-12.7,7.3c-0.5,0.3-0.8,1-0.8,1.6v9.1C250.3,231.7,250.7,232,251.1,231.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000124143974730294871820000015340698803756162453_",
    className: "st1",
    d: "M250.8,232.5c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l12.7-7.3c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-12.7,7.3C251.2,232.4,251,232.5,250.8,232.5z M263.9,213.8l-12.4,7.2c-0.2,0.1-0.5,0.6-0.5,1v9 l12.4-7.2c0.2-0.1,0.5-0.6,0.5-1V213.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000145771961747001096260000003301574125889966265_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000176728230736567895610000000545224195687287982_",
    className: "st0",
    d: "M168.6,314.4l1.3-0.7 c0.5-0.3,0.8-1,0.8-1.6V303c0-0.6-0.4-0.9-0.8-0.6l-1.3,0.7c-0.5,0.3-0.8,1-0.8,1.6v9.1C167.8,314.4,168.2,314.7,168.6,314.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000111870092137157153410000003163571712439809716_",
    className: "st1",
    d: "M168.3,315.2c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l1.3-0.7c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2L169,315C168.7,315.1,168.5,315.2,168.3,315.2z M170.1,303l-1.1,0.6c-0.2,0.1-0.5,0.6-0.5,1v9l1.1-0.6 c0.2-0.1,0.5-0.6,0.5-1V303z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000099643888684626007350000017216025484016684943_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000021085446322585432300000007792288394661262983_",
    className: "st1",
    d: "M119.9,307.2l0.1-0.1 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6l-0.1,0.1c-0.5,0.3-0.8,1-0.8,1.6v9.1C119.1,307.2,119.4,307.5,119.9,307.2z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000150063227802662961930000000396257689397817527_",
    className: "st1",
    d: "M119.6,308c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2c0.5-0.3,1-0.3,1.4-0.1c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-0.1,0.1C120,308,119.8,308,119.6,308z M120.2,296.6c-0.2,0.2-0.4,0.6-0.4,0.9v9 c0.2-0.2,0.4-0.6,0.4-0.9V296.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000181052503816186206620000009085986868641969824_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000094593845157983145980000000990977318485635754_",
    className: "st1",
    d: "M268.9,221.4l0.1-0.1 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6l-0.1,0.1c-0.5,0.3-0.8,1-0.8,1.6v9.1C268.1,221.4,268.5,221.7,268.9,221.4z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000168813020814770250010000001612096508904477355_",
    className: "st1",
    d: "M268.6,222.2c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2c0.5-0.3,1-0.3,1.4-0.1c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-0.1,0.1C269.1,222.2,268.8,222.2,268.6,222.2z M269.2,210.8c-0.2,0.2-0.4,0.6-0.4,0.9v9 c0.2-0.2,0.4-0.6,0.4-0.9V210.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000011725260491790102720000008335008942236331651_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000176766140438914264730000008716630944357275539_",
    className: "st1",
    d: "M97,337.9l0.1-0.1c0.5-0.3,0.8-1,0.8-1.6 v-9.1c0-0.6-0.4-0.9-0.8-0.6l-0.1,0.1c-0.5,0.3-0.8,1-0.8,1.6v9.1C96.1,337.8,96.5,338.1,97,337.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000021118662054350489330000002120492184944851588_",
    className: "st1",
    d: "M96.6,338.6c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3V328c0-0.9,0.5-1.8,1.2-2.2c0.5-0.3,1-0.3,1.4-0.1c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-0.1,0.1C97.1,338.6,96.9,338.6,96.6,338.6z M97.3,327.2c-0.2,0.2-0.4,0.6-0.4,0.9v9 c0.2-0.2,0.4-0.6,0.4-0.9V327.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000165235251845071081010000001115202533246229945_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000070107776843716577130000006697389924130305972_",
    className: "st1",
    d: "M102.3,334.8l0.1-0.1 c0.5-0.3,0.8-1,0.8-1.6V324c0-0.6-0.4-0.9-0.8-0.6l-0.1,0.1c-0.5,0.3-0.8,1-0.8,1.6v9.1C101.5,334.8,101.9,335,102.3,334.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000044894087532061402280000008379033076176533139_",
    className: "st1",
    d: "M102,335.6c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3V325c0-0.9,0.5-1.8,1.2-2.2c0.5-0.3,1-0.3,1.4-0.1c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-0.1,0.1C102.5,335.5,102.2,335.6,102,335.6z M102.6,324.1c-0.2,0.2-0.4,0.6-0.4,0.9v9 c0.2-0.2,0.4-0.6,0.4-0.9V324.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000117639165459474664920000015588377559474204074_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000152972093497241654100000008020625652204504995_",
    className: "st1",
    d: "M214.2,252.9l17-9.8 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6l-17,9.8c-0.5,0.3-0.8,1-0.8,1.6v9.1C213.4,252.9,213.8,253.2,214.2,252.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000096022814777806831150000000222312464314364578_",
    className: "st1",
    d: "M213.9,253.7c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l17-9.8c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-17,9.8C214.4,253.6,214.1,253.7,213.9,253.7z M231.4,232.5l-16.8,9.7c-0.2,0.1-0.5,0.6-0.5,1v9 l16.8-9.7c0.2-0.1,0.5-0.6,0.5-1V232.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000142894572175120166410000000164211736141306044_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000065764402043041720840000007956290609085033126_",
    className: "st1",
    d: "M130.9,300.9l3.8-2.2 c0.5-0.3,0.8-1,0.8-1.6V288c0-0.6-0.4-0.9-0.8-0.6l-3.8,2.2c-0.5,0.3-0.8,1-0.8,1.6v9.1C130.1,300.8,130.5,301.1,130.9,300.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000085236336147122352170000007562428121898036101_",
    className: "st1",
    d: "M130.6,301.7c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l3.8-2.2c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-3.8,2.2C131.1,301.6,130.8,301.7,130.6,301.7z M134.9,288.1l-3.6,2.1c-0.2,0.1-0.5,0.6-0.5,1v9 l3.6-2.1c0.2-0.1,0.5-0.6,0.5-1V288.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000030465187521527110510000015886839089262880158_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000180364464477842384430000006955753683021309104_",
    className: "st0",
    d: "M143.1,293.8l17-9.8 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6l-17,9.8c-0.5,0.3-0.8,1-0.8,1.6v9.1C142.3,293.8,142.7,294.1,143.1,293.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000008840055492102318920000018346528557800255625_",
    className: "st1",
    d: "M142.8,294.6c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3V284c0-0.9,0.5-1.8,1.2-2.2l17-9.8c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-17,9.8C143.3,294.6,143,294.6,142.8,294.6z M160.4,273.4l-16.8,9.7c-0.2,0.1-0.5,0.6-0.5,1v9l16.8-9.7 c0.2-0.1,0.5-0.6,0.5-1V273.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000104670314032978394430000007508748356696120981_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000010996876721376182280000008961728705667567807_",
    className: "st0",
    d: "M232.3,260l19.8-11.4 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6l-19.8,11.4c-0.5,0.3-0.8,1-0.8,1.6v9.1C231.4,260,231.8,260.2,232.3,260z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000089533604885218866490000015543576914443454134_",
    className: "st1",
    d: "M231.9,260.8c-0.2,0-0.4-0.1-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l19.8-11.4c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-19.8,11.4C232.4,260.7,232.2,260.8,231.9,260.8z M252.2,237.9l-19.6,11.3c-0.2,0.1-0.5,0.6-0.5,1v9 l19.6-11.3c0.2-0.1,0.5-0.6,0.5-1V237.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000088130873051668517230000005571424522447117457_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000099640991302069716400000018022039951613793922_",
    className: "st0",
    d: "M196.2,280.7l1.9-1.1 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6l-1.9,1.1c-0.5,0.3-0.8,1-0.8,1.6v9.1C195.4,280.7,195.8,281,196.2,280.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000073689503248935073410000015990335682697979015_",
    className: "st1",
    d: "M195.9,281.5c-0.2,0-0.4-0.1-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l1.9-1.1c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-1.9,1.1C196.4,281.4,196.1,281.5,195.9,281.5z M198.3,269l-1.7,1c-0.2,0.1-0.5,0.6-0.5,1v9l1.7-1 c0.2-0.1,0.5-0.6,0.5-1V269z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000106838004323689597130000011243697106203582114_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000181048638379992054270000012036533790400378291_",
    className: "st1",
    d: "M177.7,309.2l6.1-3.5 c0.5-0.3,0.8-1,0.8-1.6V295c0-0.6-0.4-0.9-0.8-0.6l-6.1,3.5c-0.5,0.3-0.8,1-0.8,1.6v9.1C176.9,309.1,177.3,309.4,177.7,309.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000026853558901424851380000016366979143598050985_",
    className: "st1",
    d: "M177.4,310c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l6.1-3.5c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-6.1,3.5C177.9,309.9,177.6,310,177.4,310z M184,295l-5.9,3.4c-0.2,0.1-0.5,0.6-0.5,1v9l5.9-3.4 c0.2-0.1,0.5-0.6,0.5-1V295z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000027582933769889843250000017682505218294927033_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000148624548506333677140000018335316998059422613_",
    className: "st1",
    d: "M269.8,255.8l17-9.8 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6l-17,9.8c-0.5,0.3-0.8,1-0.8,1.6v9.1C269,255.8,269.3,256.1,269.8,255.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000141436181994056096580000011215980388589002159_",
    className: "st1",
    d: "M269.5,256.6c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3V246c0-0.9,0.5-1.8,1.2-2.2l17-9.8c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-17,9.8C269.9,256.5,269.7,256.6,269.5,256.6z M287,235.4l-16.8,9.7c-0.2,0.1-0.5,0.6-0.5,1v9l16.8-9.7 c0.2-0.1,0.5-0.6,0.5-1V235.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000090975323884677401990000009018944737596871346_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000101067513611825848060000010063701885200287647_",
    className: "st0",
    d: "M219.9,273.5l-28.2,16.2 c-0.5,0.3-0.8,1-0.8,1.6v9.1c0,0.6,0.4,0.9,0.8,0.6l38.9-22.4c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6l-3.3,1.9 L219.9,273.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000124851546045955349010000003128319105076647333_",
    className: "st1",
    d: "M191.4,301.9c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l28.2-16.2l0.7,1.2l-28.2,16.2c-0.2,0.1-0.5,0.6-0.5,1v9l38.7-22.3 c0.2-0.1,0.5-0.6,0.5-1v-9l-3.1,1.8l-0.7-1.2l3.3-1.9c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2L192,301.7C191.8,301.9,191.6,301.9,191.4,301.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000080884729606315964480000015711718406301788553_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000006706171957154602020000013163873429256248194_",
    className: "st0",
    d: "M129.8,336.8l28.4-16.3 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6l-28.4,16.3c-0.5,0.3-0.8,1-0.8,1.6v9.1C128.9,336.7,129.3,337,129.8,336.8z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000059997320815131986280000011567531094844458898_",
    className: "st1",
    d: "M129.4,337.6c-0.2,0-0.4,0-0.6-0.1 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l28.4-16.3c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2L130,337.5C129.9,337.5,129.7,337.6,129.4,337.6z M158.3,309.8L130.1,326c-0.2,0.1-0.5,0.6-0.5,1v9 l28.2-16.2c0.2-0.1,0.5-0.6,0.5-1L158.3,309.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000016791294208166388130000002057070161006782616_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000145741776579440552490000009754847161525022368_",
    className: "st1",
    d: "M237.6,274.7l2.3-1.3 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6l-2.3,1.3c-0.5,0.3-0.8,1-0.8,1.6v9.1C236.8,274.7,237.1,275,237.6,274.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000154426391286331302710000004651257946903109002_",
    className: "st1",
    d: "M237.3,275.5c-0.2,0-0.4-0.1-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l2.3-1.3c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-2.3,1.3C237.7,275.4,237.5,275.5,237.3,275.5z M240,262.8l-2.1,1.2c-0.2,0.1-0.5,0.6-0.5,1v9l2.1-1.2 c0.2-0.1,0.5-0.6,0.5-1V262.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000123420112486744955990000007629980968767103662_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000003822716280736760630000002149979412831099277_",
    className: "st0",
    d: "M117.9,343.6l2.3-1.3 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6l-2.3,1.3c-0.5,0.3-0.8,1-0.8,1.6v9.1C117.1,343.6,117.4,343.9,117.9,343.6z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000182516849240785307170000003497738315528218280_",
    className: "st1",
    d: "M117.6,344.4c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l2.3-1.3c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-2.3,1.3C118,344.3,117.8,344.4,117.6,344.4z M120.3,331.7l-2.1,1.2c-0.2,0.1-0.5,0.6-0.5,1v9l2.1-1.2 c0.2-0.1,0.5-0.6,0.5-1V331.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000038397363068683700570000002349146879423056057_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000124132668802460686490000017784641191411156870_",
    className: "st0",
    d: "M257.7,245.3l38.1-21.9 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6l-38,21.9c-0.5,0.3-0.8,1-0.8,1.6v9.1C256.9,245.3,257.3,245.6,257.7,245.3z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000169528412501813344100000010866699635027710861_",
    className: "st1",
    d: "M257.4,246.1c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l38.1-21.9c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2L258,245.9C257.9,246,257.6,246.1,257.4,246.1z M296,212.7l-37.9,21.8c-0.2,0.1-0.5,0.6-0.5,1v9 l37.9-21.8c0.2-0.1,0.5-0.6,0.5-1V212.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000055665195048752864570000010693729460614342043_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000015329549640854293730000012371632214403804594_",
    className: "st0",
    d: "M205.2,275.6l17-9.8 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6l-17,9.8c-0.5,0.3-0.8,1-0.8,1.6v9.1C204.4,275.5,204.7,275.8,205.2,275.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000005979017248369263380000017315191961534021505_",
    className: "st1",
    d: "M204.9,276.3c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l17-9.8c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-17,9.8C205.3,276.3,205.1,276.3,204.9,276.3z M222.4,255.1l-16.8,9.7c-0.2,0.1-0.5,0.6-0.5,1v9 l16.8-9.7c0.2-0.1,0.5-0.6,0.5-1V255.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000115516886199838080070000008577178211521972888_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000049906594105923764970000009377741523075198092_",
    className: "st0",
    d: "M110,330.4l38-21.9 c0.5-0.3,0.8-1,0.8-1.6v-9.1c0-0.6-0.4-0.9-0.8-0.6L110,319c-0.5,0.3-0.8,1-0.8,1.6v9.1C109.1,330.4,109.5,330.6,110,330.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000039817604774399249300000002489236915178222222_",
    className: "st1",
    d: "M109.6,331.2c-0.2,0-0.4,0-0.6-0.2 c-0.4-0.2-0.6-0.7-0.6-1.3v-9.1c0-0.9,0.5-1.8,1.2-2.2l38-21.9c0.4-0.2,0.9-0.3,1.2,0c0.4,0.2,0.6,0.7,0.6,1.3v9.1 c0,0.9-0.5,1.8-1.2,2.2l-38,21.9C110.1,331.1,109.9,331.2,109.6,331.2z M148.1,297.9l-37.8,21.8c-0.2,0.1-0.5,0.6-0.5,1v9 l37.8-21.8c0.2-0.1,0.5-0.6,0.5-1V297.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000168825686629744716980000014284821131053963422_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000011004702048628988240000002495910168883950006_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000003785866372467678480000013634965588220190615_",
    x: 179.1,
    y: 279.1,
    transform: "matrix(1.312682e-03 -1 1 1.312682e-03 -99.5743 459.9442)",
    className: "st1",
    width: 2.8,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000029745395497969918930000004378180150388604043_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000075862990736058662440000004995293256981662880_",
    x: 177.9,
    y: 286.6,
    transform: "matrix(1.312686e-03 -1 1 1.312686e-03 -107.0261 467.4164)",
    className: "st1",
    width: 5.2,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000147213753515376102100000015619505003585697922_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000129176922850785923270000002657126477691965063_",
    x: 179.1,
    y: 294.1,
    transform: "matrix(2.595448e-03 -1 1 2.595448e-03 -114.7062 474.5102)",
    className: "st1",
    width: 2.8,
    height: 1.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000091723508065727504860000014155936195316844975_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000040565671337977703460000014841356570680674460_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000167370092613266513930000001015373177345553798_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000088120974330259576350000014455854778767388825_",
    x: 249.6,
    y: 256.1,
    className: "st1",
    width: 1.4,
    height: 2.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000142874554863797566680000004387432624211703456_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000000218085760378401680000008233890674097248177_",
    x: 247.6,
    y: 264.3,
    transform: "matrix(1.282814e-03 -1 1 1.282814e-03 -15.0854 514.8531)",
    className: "st1",
    width: 5.2,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000049929858056269790870000005593232717444925837_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000083066991590411398040000005184370954412388245_",
    x: 248.8,
    y: 271.7,
    transform: "matrix(1.312686e-03 -1 1 1.312686e-03 -22.5445 522.3174)",
    className: "st1",
    width: 2.8,
    height: 1.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000019660739195170107250000004546535497344652452_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000155845178111795762530000011740210410550536578_",
    className: "st1",
    d: "M249.7,283l1-0.6 c1.8-1.1,3.3-3.9,3.3-6.4l0,0c0-2.5-1.5-3.6-3.3-2.5l-1,0.6c-1.8,1.1-3.3,3.9-3.3,6.4l0,0C246.4,282.9,247.9,284,249.7,283z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000075135754611298151090000012511555660318523071_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000054960703029230270910000000814103796586808970_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000149347871738867757660000009372265017959799971_",
    className: "st0",
    d: "M288.2,189.2l14.1-8.3 c2-1.2,3.7-4.3,3.7-7l0.1-53.3c0-2.7-1.6-3.9-3.7-2.8l-14.1,8.3c-2,1.2-3.7,4.3-3.7,7l-0.1,53.3 C284.5,189.2,286.2,190.4,288.2,189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000024000160003351201800000011555185441458754729_",
    className: "st1",
    d: "M286.7,190.4c-0.5,0-0.9-0.1-1.3-0.3 c-1-0.6-1.6-1.9-1.6-3.6l0.1-53.3c0-3,1.8-6.3,4-7.6l14.1-8.3c1.1-0.6,2.2-0.7,3.1-0.2c1,0.6,1.6,1.9,1.6,3.6l-0.1,53.3 c0,3-1.8,6.3-4,7.6l-14.1,8.3C287.9,190.2,287.3,190.4,286.7,190.4z M303.8,118.1c-0.4,0-0.8,0.2-1.1,0.3l-14.1,8.3 c-1.8,1-3.3,4-3.3,6.4l-0.1,53.3c0,1.1,0.3,2,0.9,2.4c0.6,0.3,1.2,0.1,1.7-0.2l14.1-8.3c1.8-1,3.3-4,3.3-6.4l0.1-53.3 c0-1.1-0.3-2-0.9-2.4C304.2,118.2,304,118.1,303.8,118.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000016074531686627392060000001735164553744922553_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000145745451669580859650000017418430012980398506_",
    className: "st1",
    d: "M300.1,177.6l0.2-0.1 c0.8-0.5,1.5-1.8,1.5-2.9l0.1-51c0-1.1-0.7-1.6-1.5-1.2l-0.2,0.1c-0.8,0.5-1.5,1.8-1.5,2.9l-0.1,51 C298.6,177.6,299.2,178.1,300.1,177.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000114033484934749454370000014652739394357489831_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000021816359688283135730000006585590616988797840_",
    className: "st0",
    d: "M288.9,183.9l11-6.5 c0.6-0.4,1.1-1.3,1.2-2.2l0,0c0-0.8-0.5-1.2-1.1-0.9l-11,6.5c-0.6,0.4-1.1,1.3-1.2,2.2l0,0 C287.8,183.9,288.3,184.3,288.9,183.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000007386306979098443330000011044647399735469222_",
    className: "st1",
    d: "M288.5,184.7c-0.2,0-0.4-0.1-0.6-0.2 c-0.5-0.3-0.7-0.8-0.7-1.5c0-1.1,0.6-2.3,1.5-2.8l11-6.5c0.5-0.3,1-0.3,1.4-0.1c0.5,0.3,0.7,0.8,0.7,1.5c0,1.1-0.6,2.3-1.5,2.8 l-11,6.5C289,184.7,288.8,184.7,288.5,184.7z M300.3,174.9l-11,6.6c-0.4,0.2-0.8,0.9-0.8,1.6c0,0.2,0,0.3,0.1,0.3l0.4,0.5 l-0.4-0.6l11-6.5c0.4-0.2,0.8-0.9,0.8-1.6C300.4,175,300.4,174.9,300.3,174.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000096750053605921839540000012616585473666336139_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000088122083728230949500000010184649798916297888_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000106846974842039811810000017798329359392983936_",
    className: "st0",
    d: "M74.9,312l29.7-17.1c2-1.2,3.7-4.3,3.7-7 l0.1-53.3c0-2.7-1.6-3.9-3.7-2.8L75,248.9c-2,1.2-3.7,4.3-3.7,7l-0.1,53.3C71.2,311.9,72.9,313.2,74.9,312z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000080195984550802966740000010139011551478896308_",
    className: "st1",
    d: "M73.5,313.2c-0.5,0-0.9-0.1-1.3-0.3 c-1-0.6-1.6-1.9-1.6-3.6l0.1-53.3c0-3,1.8-6.3,4-7.6l29.7-17.1c1.1-0.6,2.2-0.7,3.1-0.2c1,0.6,1.6,1.9,1.6,3.6L109,288 c0,3-1.8,6.3-4,7.6l-29.7,17.1l-0.3-0.6l0.3,0.6C74.6,313,74,313.2,73.5,313.2z M106.1,232.1c-0.4,0-0.8,0.2-1.1,0.3 l-29.7,17.1c-1.8,1-3.3,4-3.3,6.4l-0.1,53.3c0,1.1,0.3,2,0.9,2.4c0.6,0.3,1.2,0.1,1.7-0.2l29.7-17.1c1.8-1,3.3-4,3.3-6.4 l0.1-53.3c0-1.1-0.3-2-0.9-2.4C106.5,232.1,106.3,232.1,106.1,232.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000093898384275871057850000011534873234305654164_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000168074452904239271280000005295079811000221108_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000008138114606052472650000017459490750075825814_",
    className: "st1",
    d: "M76.5,262.1l7.4-4.2 c0.6-0.4,1.1-1.3,1.2-2.2l0,0c0-0.8-0.5-1.2-1.1-0.9l-7.4,4.2c-0.6,0.4-1.1,1.3-1.2,2.2l0,0C75.4,262.1,75.9,262.5,76.5,262.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000127042240210504564790000007792644257629612193_",
    className: "st1",
    d: "M76.1,262.9c-0.2,0-0.4-0.1-0.6-0.2 c-0.5-0.3-0.7-0.8-0.7-1.5c0-1.1,0.6-2.3,1.5-2.8l7.4-4.2c0.5-0.3,1-0.3,1.4-0.1c0.5,0.3,0.7,0.8,0.7,1.5 c0,1.1-0.6,2.3-1.5,2.8l-7.4,4.2C76.6,262.9,76.3,262.9,76.1,262.9z M84.3,255.3l-7.4,4.3c-0.4,0.2-0.8,0.9-0.8,1.6 c0,0.2,0,0.3,0.1,0.3v-0.1l7.4-4.2c0.4-0.2,0.8-0.9,0.8-1.6C84.3,255.4,84.3,255.3,84.3,255.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000166673910194664457700000005288232731802250401_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000096761687259016802130000001392732085645517450_",
    className: "st0",
    d: "M76.5,268l7.4-4.2 c0.6-0.4,1.1-1.3,1.2-2.2l0,0c0-0.8-0.5-1.2-1.1-0.9l-7.4,4.2c-0.6,0.4-1.1,1.3-1.2,2.2l0,0C75.4,268,75.9,268.4,76.5,268z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000070093370941309171300000018412852862950894000_",
    className: "st1",
    d: "M76,268.6c-0.2,0-0.4,0-0.5-0.1 c-0.4-0.2-0.6-0.7-0.6-1.3c0-1,0.6-2.1,1.4-2.6l7.4-4.2c0.4-0.2,0.9-0.3,1.2-0.1c0.4,0.2,0.6,0.7,0.6,1.3c0,1-0.6,2.1-1.4,2.6 l-7.4,4.2C76.5,268.5,76.3,268.6,76,268.6z M84.3,261c-0.1,0-0.1,0-0.2,0.1l-7.4,4.2c-0.5,0.3-0.9,1.1-0.9,1.8 c0,0.3,0.1,0.5,0.2,0.5c0.1,0,0.2,0,0.3-0.1l7.4-4.2c0.5-0.3,0.9-1.1,0.9-1.8C84.6,261.3,84.5,261.1,84.3,261 C84.4,261,84.4,261,84.3,261z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000002362280472738285760000006451537283252116368_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000004532019170959642320000014690264360189778622_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000129176320950141625700000013985115834378813093_",
    className: "st1",
    d: "M88.2,268.5l14.9-8.6 c0.6-0.4,1.1-1.3,1.2-2.2l0,0c0-0.8-0.5-1.2-1.1-0.9l-14.9,8.6c-0.6,0.4-1.1,1.3-1.2,2.2l0,0C87,268.5,87.5,268.9,88.2,268.5z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000116914120757020351660000011596626385889318023_",
    className: "st1",
    d: "M87.7,269.4c-0.2,0-0.4-0.1-0.6-0.2 c-0.5-0.3-0.7-0.8-0.7-1.5c0-1.1,0.6-2.3,1.5-2.8l14.9-8.6c0.5-0.3,1-0.3,1.4-0.1c0.5,0.3,0.7,0.8,0.7,1.5 c0,1.1-0.6,2.3-1.5,2.8l-14.9,8.6l0,0C88.3,269.3,88,269.4,87.7,269.4z M103.5,257.4l-15,8.7c-0.4,0.2-0.8,0.9-0.8,1.6 c0,0.2,0,0.3,0.1,0.3v-0.1l14.9-8.6c0.4-0.2,0.8-0.9,0.8-1.6C103.6,257.5,103.5,257.4,103.5,257.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000034053093998363940050000004712225504299003040_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000011718648548656455470000016969697839910662790_",
    className: "st0",
    d: "M88.2,274.4l14.9-8.6 c0.6-0.4,1.1-1.3,1.2-2.2l0,0c0-0.8-0.5-1.2-1.1-0.9l-14.9,8.6c-0.6,0.4-1.1,1.3-1.2,2.2l0,0C87,274.4,87.5,274.8,88.2,274.4z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000059274654402294812890000009965920937318337165_",
    className: "st1",
    d: "M87.7,275c-0.2,0-0.4,0-0.5-0.1 c-0.4-0.2-0.6-0.7-0.6-1.3c0-1,0.6-2.1,1.4-2.6l14.9-8.6c0.4-0.2,0.9-0.3,1.2-0.1c0.4,0.2,0.6,0.7,0.6,1.3 c0,1-0.6,2.1-1.4,2.6l-14.9,8.6C88.2,275,87.9,275,87.7,275z M103.6,263.1c-0.1,0-0.1,0-0.2,0.1l-14.9,8.6 c-0.5,0.3-0.9,1.1-0.9,1.8c0,0.3,0.1,0.5,0.2,0.5c0.1,0,0.2,0,0.3-0.1l14.9-8.6c0.5-0.3,0.9-1.1,0.9-1.8 C103.8,263.4,103.7,263.2,103.6,263.1L103.6,263.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000159460056807103949260000007231661909281656235_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000069371287772576496000000014787581377162888097_",
    className: "st0",
    d: "M88.2,280.4l14.9-8.6 c0.6-0.4,1.1-1.3,1.2-2.2l0,0c0-0.8-0.5-1.2-1.1-0.9l-14.9,8.6c-0.6,0.4-1.1,1.3-1.2,2.2l0,0C87,280.3,87.5,280.7,88.2,280.4z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000015341830631703225190000015335219502705605254_",
    className: "st1",
    d: "M87.7,281c-0.2,0-0.4,0-0.5-0.1 c-0.4-0.2-0.6-0.7-0.6-1.3c0-1,0.6-2.1,1.4-2.6l14.9-8.6c0.4-0.2,0.9-0.3,1.2-0.1c0.4,0.2,0.6,0.7,0.6,1.3 c0,1-0.6,2.1-1.4,2.6l-14.9,8.6C88.2,280.9,87.9,281,87.7,281z M103.5,269c-0.1,0-0.1,0-0.2,0.1l-14.9,8.6 c-0.5,0.3-0.9,1.1-0.9,1.8c0,0.3,0.1,0.5,0.2,0.5c0.1,0,0.2,0,0.3-0.1l14.9-8.6c0.5-0.3,0.9-1.1,0.9-1.8 C103.8,269.3,103.7,269.1,103.5,269C103.6,269,103.6,269,103.5,269z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000016074779298603725790000006888437354351215240_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000010269377564367557730000012516292949213193875_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000100368607213446656940000010261988142180359065_",
    className: "st1",
    d: "M76.4,294.3l7.5-4.3 c0.6-0.3,1.1-1.3,1.1-2.1v-0.2c0-0.8-0.5-1.2-1.1-0.8l-7.5,4.3c-0.6,0.3-1.1,1.3-1.1,2.1v0.2 C75.3,294.2,75.8,294.6,76.4,294.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000090281293169479130050000012848042722465919646_",
    className: "st1",
    d: "M76,295.1c-0.2,0-0.4-0.1-0.6-0.2 c-0.5-0.3-0.7-0.8-0.7-1.5v-0.2c0-1,0.6-2.2,1.4-2.7l7.5-4.3c0.5-0.3,1-0.3,1.4-0.1c0.5,0.3,0.7,0.8,0.7,1.5v0.2 c0,1-0.6,2.2-1.4,2.7l-7.5,4.3C76.5,295,76.2,295.1,76,295.1z M84.3,287.4l-7.5,4.4c-0.3,0.2-0.7,0.9-0.7,1.5v0.2 c0,0.2,0.1,0.3,0.1,0.3v-0.1l7.5-4.3c0.3-0.2,0.7-0.9,0.7-1.5v-0.2C84.3,287.5,84.3,287.4,84.3,287.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000017499331087284878140000007978844398559835532_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000116237883760966915990000016430448493367494590_",
    className: "st0",
    d: "M76.4,300.2l7.5-4.3 c0.6-0.3,1.1-1.3,1.1-2.1v-0.2c0-0.8-0.5-1.2-1.1-0.8l-7.5,4.3c-0.6,0.3-1.1,1.3-1.1,2.1v0.2 C75.3,300.2,75.8,300.5,76.4,300.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000129187449300137045160000003363427145767051433_",
    className: "st1",
    d: "M76,300.8c-0.2,0-0.4,0-0.5-0.1 c-0.4-0.2-0.6-0.7-0.6-1.3v-0.2c0-1,0.6-2,1.3-2.5l7.5-4.3c0.4-0.2,0.8-0.3,1.2-0.1c0.4,0.2,0.6,0.7,0.6,1.3v0.2 c0,1-0.6,2-1.3,2.5l-7.5,4.3C76.4,300.7,76.2,300.8,76,300.8z M84.3,293.1c0,0-0.1,0-0.2,0.1l-7.5,4.3c-0.4,0.3-0.8,1-0.8,1.7 v0.2c0,0.3,0.1,0.4,0.1,0.5c0,0,0.1,0,0.2-0.1l7.5-4.3c0.4-0.3,0.8-1,0.8-1.7v-0.2C84.5,293.3,84.4,293.2,84.3,293.1 C84.4,293.1,84.4,293.1,84.3,293.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000079486924439654523440000000381210578766288295_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000103959596145229814290000011076191450054625440_",
    className: "st0",
    d: "M93.2,258.4l6.8-3.9 c1.9-1.1,3.4-3.9,3.4-6.4l0,0c0-2.5-1.5-3.6-3.4-2.5l-6.8,3.9c-1.9,1.1-3.4,3.9-3.4,6.4l0,0C89.9,258.3,91.4,259.5,93.2,258.4z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000137103330084491459900000013169299159130329237_",
    className: "st1",
    d: "M91.9,259.2c-0.4,0-0.8-0.1-1.1-0.3 c-0.9-0.5-1.4-1.7-1.4-3.1c0-2.7,1.6-5.7,3.6-6.8l6.8-3.9c1-0.6,1.9-0.6,2.7-0.2c0.9,0.5,1.4,1.7,1.4,3.1 c0,2.7-1.6,5.7-3.6,6.8l-6.8,3.9C92.9,259.1,92.4,259.2,91.9,259.2z M93,258l0.2,0.4L93,258l6.8-3.9c1.7-1,3.1-3.7,3.1-6 c0-1.1-0.3-2-0.9-2.3c-0.6-0.3-1.3-0.1-1.7,0.2l-6.8,3.9c-1.7,1-3.1,3.7-3.1,6c0,1.1,0.3,2,0.9,2.3S92.5,258.3,93,258z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000042711136599521462620000006980393486848522920_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000049183213752194818470000004501800558031433861_",
    className: "st1",
    d: "M93.7,290.2l6.8-3.9 c1.9-1.1,3.4-3.9,3.4-6.4l0,0c0-2.5-1.5-3.6-3.4-2.5l-6.8,3.9c-1.9,1.1-3.4,3.9-3.4,6.4l0,0C90.3,290.1,91.8,291.3,93.7,290.2z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000005253761510258178980000004001363327939552656_",
    className: "st1",
    d: "M92.4,291.3c-0.4,0-0.8-0.1-1.2-0.3 c-1-0.6-1.5-1.8-1.5-3.3c0-2.7,1.6-5.8,3.7-7l6.8-3.9c1-0.6,2.1-0.7,2.9-0.2c1,0.6,1.5,1.8,1.5,3.3c0,2.7-1.6,5.8-3.7,7 l-6.8,3.9C93.5,291.1,92.9,291.3,92.4,291.3z M101.8,277.6c-0.4,0-0.7,0.2-1,0.3l-6.8,3.9c-1.6,0.9-3,3.6-3,5.8 c0,1,0.3,1.8,0.8,2.1c0.5,0.3,1.1,0.1,1.5-0.2l6.8-3.9c1.6-0.9,3-3.6,3-5.8c0-1-0.3-1.8-0.8-2.1 C102.2,277.7,102,277.6,101.8,277.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000150816561812079588730000013103516155855954085_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000137837831867446022740000001730102481790808203_",
    className: "st1",
    d: "M78.6,285.9l0.5-0.3 c1.8-1,3.2-3.8,3.2-6.2v-6.3c0-2.4-1.4-3.5-3.2-2.4l-0.5,0.3c-1.8,1-3.2,3.8-3.2,6.2v6.3C75.3,285.8,76.8,286.9,78.6,285.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000066479998690190774770000005349962154441277111_",
    className: "st1",
    d: "M77.3,287c-0.4,0-0.8-0.1-1.2-0.3 c-0.9-0.5-1.5-1.7-1.5-3.2v-6.3c0-2.6,1.6-5.6,3.6-6.8l0.5-0.3c1-0.6,2-0.6,2.8-0.2c0.9,0.5,1.5,1.7,1.5,3.2v6.3 c0,2.6-1.6,5.6-3.6,6.8l-0.5,0.3C78.4,286.8,77.8,287,77.3,287z M80.3,271c-0.3,0-0.7,0.1-0.9,0.3l-0.5,0.3 c-1.6,0.9-2.9,3.5-2.9,5.6v6.3c0,1,0.3,1.7,0.8,2s1,0.1,1.4-0.2l0.5-0.3c1.6-0.9,2.9-3.5,2.9-5.6v-6.3c0-1-0.3-1.7-0.8-2 C80.7,271.1,80.5,271,80.3,271z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000126282371345666377530000016281515722785881258_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000180345768578128197920000011962743948934719911_",
    className: "st1",
    d: "M69.2,354.6l-0.7-1.2l4.8-2.8l0.7,1.2 L69.2,354.6z M77.3,350l-0.7-1.2l4.8-2.8l0.7,1.2L77.3,350z M85.3,345.4l-0.7-1.2l4.8-2.8l0.7,1.2L85.3,345.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000135663842305139552850000005468041168041234585_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000175323017612317491740000008391440739294294185_",
    className: "st1",
    d: "M101,353.2l-0.7-1.2l3.2-1.8l0.7,1.2 L101,353.2z M107.4,349.5l-0.7-1.2l4.8-2.8l0.7,1.2L107.4,349.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000090290734566615459480000010956949448442021815_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000005241763553991073260000010111236653859774112_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000182496850773962208720000016864509070008570284_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000173129771990461971490000011065822451995573155_",
    className: "st0",
    d: "M117.9,287.3L275,196.9 c2-1.2,3.7-4.3,3.7-7l0.1-53.3c0-2.7-1.6-3.9-3.7-2.8L118,224.2c-2,1.2-3.7,4.3-3.7,7l-0.1,53.3 C114.2,287.2,115.9,288.4,117.9,287.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000032613267730777066740000015164902318259842725_",
    className: "st1",
    d: "M116.4,288.4c-0.5,0-0.9-0.1-1.3-0.3 c-1-0.6-1.6-1.9-1.6-3.6l0.1-53.3c0-3,1.8-6.3,4-7.6l157.1-90.4c1.1-0.6,2.2-0.7,3.1-0.2c1,0.6,1.6,1.9,1.6,3.6l-0.1,53.3 c0,3-1.8,6.3-4,7.6l-157.1,90.4l0,0C117.6,288.2,117,288.4,116.4,288.4z M276.5,134.1c-0.4,0-0.8,0.2-1.1,0.3l-157.1,90.4 c-1.8,1-3.3,4-3.3,6.4l-0.1,53.3c0,1.1,0.3,2,0.9,2.4c0.6,0.3,1.2,0.1,1.7-0.2l0,0l157.1-90.4c1.8-1,3.3-4,3.3-6.4l0.1-53.3 c0-1.1-0.3-2-0.9-2.4C276.9,134.1,276.7,134.1,276.5,134.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000044162046258997751310000008761467604905206173_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000013871320999178800860000010980674321187724221_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_00000028295404642402984610000016687550380805664147_",
    transform: "matrix(0.5011 -0.8654 0.8654 0.5011 -84.2675 275.0745)",
    className: "st0",
    cx: 196.4,
    cy: 210.6,
    rx: 24.3,
    ry: 14
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000170270849916633058570000008411330047118147736_",
    className: "st1",
    d: "M188.8,233.4c-1.8,0-3.4-0.4-4.8-1.2 c-3.5-2-5.4-6.2-5.4-11.7c0-11.1,7.9-24.7,17.5-30.3c4.8-2.8,9.4-3.2,12.8-1.2c3.5,2,5.4,6.2,5.4,11.7 c0,11.1-7.9,24.7-17.5,30.3C194,232.6,191.2,233.4,188.8,233.4z M204.1,189.1c-2.2,0-4.7,0.8-7.3,2.2 c-9.3,5.3-16.8,18.4-16.8,29.1l0,0c0,5,1.7,8.8,4.7,10.5s7.1,1.3,11.4-1.2c9.3-5.3,16.8-18.4,16.8-29.1c0-5-1.7-8.8-4.7-10.5 C207,189.5,205.6,189.1,204.1,189.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000097492811326800281230000004691413456645948075_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000078757090960141480180000000045861489625293743_",
    className: "st1",
    d: "M120.8,280.8c-0.9,0-1.5-0.7-1.5-1.8 v-5.6h1.4v5.6c0,0,0,0.4,0.1,0.4l0.6,1.3C121.2,280.8,121,280.8,120.8,280.8z M124.8,278.9l-0.7-1.2l4.8-2.8l0.7,1.2 L124.8,278.9z M132.8,274.2l-0.7-1.2l4.8-2.8l0.7,1.2L132.8,274.2z M120.7,269.8h-1.4v-5.6h1.4V269.8z M140.8,269.6l-0.7-1.2 l4.8-2.8l0.7,1.2L140.8,269.6z M148.9,265l-0.7-1.2l4.8-2.8l0.7,1.2L148.9,265z M120.7,260.5h-1.4v-5.6h1.4V260.5z  M156.9,260.4l-0.7-1.2l4.8-2.8l0.7,1.2L156.9,260.4z M164.9,255.7l-0.7-1.2l4.8-2.8l0.7,1.2L164.9,255.7z M120.7,251.3h-1.4 v-5.6h1.4V251.3z M172.9,251.1l-0.7-1.2l4.8-2.8l0.7,1.2L172.9,251.1z M181,246.5l-0.7-1.2l4.8-2.8l0.7,1.2L181,246.5z  M120.7,242h-1.4v-5.6h1.4V242z M189,241.9l-0.7-1.2l4.8-2.8l0.7,1.2L189,241.9z M197,237.3l-0.7-1.2l4.8-2.8l0.7,1.2 L197,237.3z M120.8,232.7h-1.4v-3c0-1,0.5-2,1.3-2.7l1,1c-0.5,0.4-0.8,1.2-0.8,1.7L120.8,232.7z M205.1,232.6l-0.7-1.2 l4.8-2.8l0.7,1.2L205.1,232.6z M213.1,228l-0.7-1.2l4.8-2.8l0.7,1.2L213.1,228z M124.6,226.2l-0.7-1.2l4.8-2.8l0.7,1.2 L124.6,226.2z M221.1,223.4l-0.7-1.2l4.8-2.8l0.7,1.2L221.1,223.4z M132.7,221.6l-0.7-1.2l4.8-2.8l0.7,1.2L132.7,221.6z  M229.1,218.8l-0.7-1.2l4.8-2.8l0.7,1.2L229.1,218.8z M140.7,216.9l-0.7-1.2l4.8-2.8l0.7,1.2L140.7,216.9z M237.2,214.1 l-0.7-1.2l4.8-2.8l0.7,1.2L237.2,214.1z M148.7,212.3l-0.7-1.2l4.8-2.8l0.7,1.2L148.7,212.3z M245.2,209.5l-0.7-1.2l4.8-2.8 l0.7,1.2L245.2,209.5z M156.8,207.7l-0.7-1.2l4.8-2.8l0.7,1.2L156.8,207.7z M253.2,204.9l-0.7-1.2l4.8-2.8l0.7,1.2 L253.2,204.9z M164.8,203.1l-0.7-1.2l4.8-2.8l0.7,1.2L164.8,203.1z M261.3,200.3l-0.7-1.2l4.8-2.8l0.7,1.2L261.3,200.3z  M172.8,198.4l-0.7-1.2l4.8-2.8l0.7,1.2L172.8,198.4z M269.3,195.7l-0.7-1.2l2.7-1.6c0.5-0.3,0.9-0.9,1.1-1.5l1.3,0.4 c-0.3,1-0.9,1.9-1.7,2.3L269.3,195.7z M180.8,193.8l-0.7-1.2l4.8-2.8l0.7,1.2L180.8,193.8z M188.9,189.2l-0.7-1.2l4.8-2.8 l0.7,1.2L188.9,189.2z M273.8,187.9h-1.4v-5.6h1.4V187.9z M196.9,184.6l-0.7-1.2l4.8-2.8l0.7,1.2L196.9,184.6z M204.9,180 l-0.7-1.2l4.8-2.8l0.7,1.2L204.9,180z M273.9,178.6h-1.4V173h1.4V178.6z M213,175.3l-0.7-1.2l4.8-2.8l0.7,1.2L213,175.3z  M221,170.7l-0.7-1.2l4.8-2.8l0.7,1.2L221,170.7z M273.9,169.3h-1.4v-5.6h1.4V169.3z M229,166.1l-0.7-1.2l4.8-2.8l0.7,1.2 L229,166.1z M237,161.5l-0.7-1.2l4.8-2.8l0.7,1.2L237,161.5z M273.9,160.1h-1.4v-5.6h1.4V160.1z M245.1,156.8l-0.7-1.2 l4.8-2.8l0.7,1.2L245.1,156.8z M253.1,152.2l-0.7-1.2l4.8-2.8l0.7,1.2L253.1,152.2z M273.9,150.8h-1.4v-5.6h1.4V150.8z  M261.1,147.6l-0.7-1.2l4.8-2.8l0.7,1.2L261.1,147.6z M269.2,143l-0.7-1.2l2.9-1.7c1.3-0.7,2.5,0,2.5,1.4h-1.4 c0,0,0-0.4-0.1-0.4c0,0-0.1,0-0.3,0.1L269.2,143z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000093898717434955947010000002599122837331558545_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000182511017719150247370000013200813781020239008_",
    className: "st1",
    d: "M194.1,203.6c-0.9-0.1-2,1.2-2,2.4v7.3 v7.3c0,1.2,1.1,1.2,2,0.1l10.5-13.3c0.8-1.1,0.8-2.5,0-2.6L194.1,203.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000033332125197027115980000009023838713039367048_",
    className: "st1",
    d: "M192.9,222.2c-0.2,0-0.3,0-0.5-0.1 c-0.6-0.2-0.9-0.8-0.9-1.5V206c0-0.9,0.5-1.9,1.2-2.5c0.5-0.4,1-0.6,1.5-0.6l10.5,1.2c0.5,0.1,0.9,0.4,1.1,0.8 c0.3,0.8,0.1,1.9-0.6,2.8L194.7,221C194.2,221.8,193.5,222.2,192.9,222.2z M194,204.3c-0.1,0-0.2,0-0.4,0.2 c-0.4,0.4-0.7,1-0.7,1.5v14.5c0,0.2,0,0.2,0,0.2s0.3-0.1,0.7-0.5l10.5-13.3c0.5-0.6,0.5-1.3,0.4-1.5L194,204.3 C194.1,204.3,194.1,204.3,194,204.3z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000124124136864919657620000006541963798818775726_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000097471629570776108840000009248517809251236788_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000010275426477722354830000008746601888087214000_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000039841902178674192640000013514753002606870915_",
    className: "st0",
    d: "M365.5,123.6c5.9-7.3,7.9-20.5,4.3-29.1 c-3.3-8-16.3-11.1-21.9-4.6c-2.5,2.9,5.4,14.8,2.7,21c-3.8,8.8-11.8,14.5-9.8,19.7c0,0,1.1,2.1,4.4,1.7c1.4-0.2,2.9-0.2,3.1-0.7 c0.6-1.6,2.1-4.3,4.8-4.6l0,0C356.8,129.5,361.5,128.5,365.5,123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000009556921214861045490000010576504567327861388_",
    className: "st1",
    d: "M344.4,133c-3,0-4.1-2-4.2-2.1 c-1.4-3.5,1.2-7.1,4.2-11.2c1.9-2.7,4.1-5.7,5.6-9.1c1.3-3.1-0.2-7.9-1.6-12.1c-1.3-4.1-2.4-7.4-1-9c2.5-3,6.8-4.3,11.5-3.6 c5.3,0.8,9.8,4.1,11.6,8.3c3.7,8.9,1.7,22.3-4.4,29.8l0,0c-4,5-9,6.3-13.1,3.6c-2.2,0.5-3.4,2.8-3.9,4.2 c-0.3,0.8-1.4,0.9-2.8,1.1c-0.3,0-0.6,0.1-0.9,0.1C345.1,133,344.7,133,344.4,133z M341.5,130.3c0,0,1,1.6,3.7,1.2 c0.3,0,0.6-0.1,0.9-0.1c0.6-0.1,1.5-0.2,1.7-0.3c0.6-1.6,2.3-4.6,5.3-5l0.3-0.1l0.2,0.2c3.4,2.5,7.8,1.3,11.4-3.2 c5.7-7.1,7.7-20.1,4.2-28.4c-1.6-3.8-5.7-6.7-10.5-7.5c-4.2-0.7-8,0.5-10.2,3.1c-0.9,1.1,0.2,4.4,1.2,7.7 c1.5,4.5,3.1,9.5,1.6,13.1c-1.6,3.6-3.8,6.7-5.8,9.4C342.7,124.5,340.5,127.6,341.5,130.3L341.5,130.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000018195163497948303630000007775357982423232909_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000099658355219025162030000016012689710220906125_",
    className: "st0",
    d: "M358.8,122.5c5.9-7.3,7.9-20.5,4.3-29.1 c-3.1-7.6-10.8-8.8-16.1-2.5c-5.8,6.8-8,19-5.3,27.7c0.3,0.8,0.2,1.7-0.1,2.4c-0.8,1.8-2.1,5.5-0.8,9.5c0.2,0.5,0.6,0.4,0.8-0.1 c0.6-1.6,2.1-4.3,4.8-4.6l0,0C350.1,128.5,354.8,127.5,358.8,122.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000047048787850020683930000013844968090088907964_",
    className: "st1",
    d: "M341.2,131.6L341.2,131.6 c-0.5,0-0.9-0.3-1-0.8c-1.4-4.2-0.1-8.1,0.8-10c0.3-0.6,0.3-1.2,0.1-1.9c-2.8-9-0.4-21.5,5.4-28.4c2.7-3.2,6.1-4.7,9.5-4.1 c3.4,0.5,6.2,3,7.8,6.9c3.7,8.9,1.7,22.3-4.4,29.8l0,0c-4,5-9,6.3-13.1,3.6c-2.2,0.5-3.4,2.8-3.9,4.2 C342.1,131.3,341.7,131.6,341.2,131.6z M354.7,87.6c-2.5,0-5.1,1.3-7.1,3.8c-5.6,6.5-7.8,18.4-5.1,27.1c0.3,1,0.3,2-0.2,2.9 c-0.8,1.6-1.8,4.8-1,8.3c0.8-1.8,2.4-4.1,5.1-4.4l0.3-0.1l0.2,0.2c3.4,2.5,7.8,1.3,11.4-3.2l0,0c5.7-7.1,7.7-20.1,4.2-28.4 c-1.4-3.4-3.8-5.6-6.7-6C355.5,87.6,355.1,87.6,354.7,87.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000174566338070352290900000012493005745964009900_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000082333703280078677960000014611285767693708418_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000113311800170240656790000005444530018792086929_",
    className: "st0",
    d: "M350.6,101.8c-0.9,1.2-2.1,1-2.7-0.4 c-0.5-1.4-0.2-3.4,0.7-4.6c0.9-1.2,2.1-1,2.7,0.4C351.9,98.6,351.6,100.7,350.6,101.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000089556945089623582980000008359824254960337337_",
    className: "st1",
    d: "M349.3,103.3c-0.1,0-0.2,0-0.3,0 c-0.7-0.1-1.4-0.7-1.7-1.6c-0.6-1.6-0.3-3.9,0.8-5.3c0.6-0.7,1.4-1.1,2.1-1s1.4,0.7,1.7,1.6c0.6,1.6,0.3,3.9-0.8,5.3l0,0 C350.6,102.9,350,103.3,349.3,103.3z M350,96.8c-0.2,0-0.5,0.2-0.8,0.5c-0.8,1-1.1,2.8-0.6,3.9c0.2,0.4,0.4,0.7,0.6,0.7 s0.5-0.1,0.8-0.5l0,0c0.8-1,1.1-2.8,0.6-3.9C350.5,97.1,350.3,96.8,350,96.8L350,96.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000069367372889667878950000005517606045983860119_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000173872826340816689210000004943064653724772004_",
    className: "st0",
    d: "M353.6,109.6c-0.9,1.2-2.1,1-2.7-0.4 c-0.5-1.4-0.2-3.4,0.7-4.6c0.9-1.2,2.1-1,2.7,0.4C354.9,106.4,354.5,108.5,353.6,109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000088091104634859782930000015188241345160314757_",
    className: "st1",
    d: "M352.3,111.1c-0.1,0-0.2,0-0.3,0 c-0.7-0.1-1.4-0.7-1.7-1.6c-0.6-1.6-0.3-3.9,0.8-5.3c0.6-0.7,1.4-1.1,2.1-1s1.4,0.7,1.7,1.6c0.6,1.6,0.3,3.9-0.8,5.3 C353.6,110.7,353,111.1,352.3,111.1z M353,104.5c-0.2,0-0.5,0.2-0.8,0.5c-0.8,1-1.1,2.8-0.6,3.9c0.2,0.4,0.4,0.7,0.6,0.7 s0.5-0.1,0.8-0.5l0,0c0.8-1,1.1-2.8,0.6-3.9C353.5,104.8,353.3,104.6,353,104.5L353,104.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000103257290607579225650000014680203985971968144_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000178903632894112258780000017141777900640945027_",
    className: "st0",
    d: "M356.6,117.4c-0.9,1.2-2.1,1-2.7-0.4 c-0.5-1.4-0.2-3.4,0.7-4.6s2.1-1,2.7,0.4C357.9,114.2,357.5,116.2,356.6,117.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000044148813597786200760000011967776399297264311_",
    className: "st1",
    d: "M355.3,118.8c-0.1,0-0.2,0-0.3,0 c-0.7-0.1-1.4-0.7-1.7-1.6c-0.6-1.6-0.3-3.9,0.8-5.3c0.6-0.7,1.4-1.1,2.1-1s1.4,0.7,1.7,1.6c0.6,1.6,0.3,3.9-0.8,5.3l0,0 C356.6,118.5,356,118.8,355.3,118.8z M356,112.3c-0.2,0-0.5,0.2-0.8,0.5c-0.8,1-1.1,2.8-0.6,3.9c0.2,0.4,0.4,0.7,0.6,0.7 s0.6-0.1,0.8-0.5l0,0c0.8-1,1.1-2.8,0.6-3.9C356.5,112.6,356.3,112.3,356,112.3L356,112.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000111185612299727606670000007532901761222972307_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000163794765642717516710000001436980289860458161_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000041256078720192834050000006594984697959422114_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_00000149357095044908258030000009781902151778117508_",
    transform: "matrix(0.4561 -0.8899 0.8899 0.4561 -20.8244 263.6448)",
    className: "st1",
    cx: 205.3,
    cy: 148.9,
    rx: 21.4,
    ry: 37.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000150822889767030279640000017912347199543204782_",
    className: "st1",
    d: "M219.9,175.1 c-16.6,0-36.6-10.6-45.5-24.3c-4.5-7-5.5-13.8-2.8-19.1s8.8-8.5,17.2-8.9c16.9-0.8,38.2,10,47.4,24.3l0,0 c4.5,7,5.5,13.8,2.8,19.1c-2.7,5.3-8.8,8.5-17.2,8.9C221.1,175.1,220.5,175.1,219.9,175.1z M190.7,124.1c-0.6,0-1.2,0-1.8,0 c-7.8,0.4-13.5,3.3-16,8.2s-1.5,11.2,2.7,17.8c8.9,13.9,29.6,24.4,46.1,23.6c7.8-0.4,13.5-3.3,16-8.2 c2.5-4.9,1.5-11.2-2.7-17.8l0,0C226.3,134.4,206.8,124.1,190.7,124.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000118384554606335522880000018025743198505741502_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_00000039095165006508347410000004233488035813449115_",
    transform: "matrix(0.4561 -0.8899 0.8899 0.4561 -18.0129 263.3794)",
    className: "st0",
    cx: 206.5,
    cy: 146.4,
    rx: 21.4,
    ry: 37.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000149348244336354836180000011654483733784279195_",
    className: "st1",
    d: "M221.1,172.6 c-16.6,0-36.6-10.6-45.5-24.3c-4.5-7-5.5-13.8-2.8-19.1s8.8-8.5,17.2-8.9c16.9-0.8,38.2,10,47.4,24.3l0,0 c4.5,7,5.5,13.8,2.8,19.1c-2.7,5.3-8.8,8.5-17.2,8.9C222.4,172.6,221.7,172.6,221.1,172.6z M191.9,121.6c-0.6,0-1.2,0-1.8,0 c-7.8,0.4-13.5,3.3-16,8.2s-1.5,11.2,2.7,17.8c8.9,13.9,29.6,24.4,46.1,23.6c7.8-0.4,13.5-3.3,16-8.2 c2.5-4.9,1.5-11.2-2.7-17.8l0,0C227.6,131.9,208.1,121.6,191.9,121.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000057869515589250641760000017021392386836788920_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000168812026964917331220000010589736004434831787_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_00000165215673484058822590000004853148661531080340_",
    transform: "matrix(0.4561 -0.8899 0.8899 0.4561 -9.4127 262.7536)",
    className: "st1",
    cx: 210.3,
    cy: 139.1,
    rx: 21.4,
    ry: 37.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000094597686737756173520000002565428775342820751_",
    className: "st1",
    d: "M224.9,165.3 c-16.6,0-36.6-10.6-45.5-24.3c-4.5-7-5.5-13.8-2.8-19.1s8.8-8.5,17.2-8.9c16.9-0.8,38.2,10,47.4,24.3l0,0 c4.5,7,5.5,13.8,2.8,19.1s-8.8,8.5-17.2,8.9C226.1,165.3,225.5,165.3,224.9,165.3z M195.7,114.3c-0.6,0-1.2,0-1.8,0 c-7.8,0.4-13.5,3.3-16,8.2s-1.5,11.2,2.7,17.8c9,13.9,29.6,24.4,46.1,23.6c7.8-0.4,13.5-3.3,16-8.2s1.5-11.2-2.7-17.8l0,0 C231.3,124.6,211.8,114.3,195.7,114.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000014609070788446253200000011052058556684646840_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_00000024694959639323861120000005674136332643293852_",
    transform: "matrix(0.4561 -0.8899 0.8899 0.4561 -6.5933 262.5921)",
    className: "st0",
    cx: 211.5,
    cy: 136.7,
    rx: 21.4,
    ry: 37.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000024720081871933544910000000576537708602972040_",
    className: "st1",
    d: "M226.1,162.9 c-16.6,0-36.6-10.6-45.5-24.3c-4.5-7-5.5-13.8-2.8-19.1s8.8-8.5,17.2-8.9c16.9-0.8,38.2,10,47.4,24.3l0,0 c4.5,7,5.5,13.8,2.8,19.1s-8.8,8.5-17.2,8.9C227.4,162.8,226.7,162.9,226.1,162.9z M196.9,111.8c-0.6,0-1.2,0-1.8,0 c-7.8,0.4-13.5,3.3-16,8.2s-1.5,11.2,2.7,17.8c9,13.9,29.6,24.4,46.1,23.6c7.8-0.4,13.5-3.3,16-8.2s1.5-11.2-2.7-17.8l0,0 C232.6,122.2,213.1,111.8,196.9,111.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000057833981754896158300000018310716540901687220_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000100352576352750263580000001811877554468371601_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000034088002865708666500000008318079297923388310_",
    className: "st0",
    d: "M206.4,121.2c1.4,2.2,0.4,4-2.1,4.2 c-2.6,0.1-5.8-1.5-7.2-3.7c-1.4-2.2-0.4-4,2.1-4.2C201.7,117.4,205,119.1,206.4,121.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000157300640528182017630000009614201936383755162_",
    className: "st1",
    d: "M203.9,126.1c-2.8,0-6-1.7-7.5-4 c-0.8-1.3-1-2.5-0.5-3.5s1.6-1.6,3.1-1.7c2.8-0.2,6.3,1.6,7.8,4c0.8,1.3,1,2.5,0.5,3.5s-1.6,1.6-3.1,1.7 C204.2,126.1,204,126.1,203.9,126.1z M199.4,118.2c-0.1,0-0.2,0-0.2,0c-1,0-1.7,0.4-2,0.9c-0.3,0.6-0.1,1.3,0.4,2.2 c1.3,1.9,4.2,3.5,6.6,3.4c1,0,1.7-0.4,2-0.9c0.3-0.6,0.1-1.3-0.4-2.2l0,0C204.6,119.7,201.7,118.2,199.4,118.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000075848647180790683050000012540579063300832915_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000141422191887786156340000000699740006979523983_",
    className: "st0",
    d: "M205.1,123.7c-1.4-2.2-4.6-3.8-7.2-3.7 c-0.5,0-0.9,0.1-1.3,0.3c0.1,0.4,0.3,0.8,0.5,1.3c1.4,2.2,4.6,3.8,7.2,3.7c0.5,0,0.9-0.1,1.3-0.3 C205.5,124.6,205.3,124.2,205.1,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000086678284816060231860000015910160648730403971_",
    className: "st1",
    d: "M204,126c-2.8,0-6-1.7-7.5-4 c-0.3-0.5-0.5-0.9-0.6-1.5l-0.1-0.6l0.6-0.2c0.5-0.2,1-0.3,1.6-0.3c2.9-0.1,6.3,1.6,7.8,4c0.3,0.5,0.5,0.9,0.6,1.5l0.1,0.6 l-0.6,0.2c-0.5,0.2-1,0.3-1.6,0.3C204.2,126,204.1,126,204,126z M197.4,120.8c0.1,0.1,0.1,0.3,0.2,0.4c1.3,1.9,4.3,3.5,6.6,3.4 c0.2,0,0.3,0,0.5-0.1c-0.1-0.1-0.1-0.3-0.2-0.4l0,0c-1.3-1.9-4.3-3.5-6.6-3.4C197.7,120.7,197.6,120.7,197.4,120.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000034077780799147590750000012712743933051241656_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000181056433576404325660000018292862013392395160_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000183946139698676002580000016301861904257801905_",
    className: "st0",
    d: "M226.8,131.6c-1.5,1.2-4.8,0.7-7.3-1.1 s-3.3-4.3-1.8-5.5s4.8-0.7,7.3,1.1C227.5,127.9,228.3,130.4,226.8,131.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000109026552656645703950000016430091828513902223_",
    className: "st1",
    d: "M224.5,132.9c-1.7,0-3.7-0.7-5.4-1.9 c-1.7-1.3-2.8-2.9-2.8-4.3c0-0.9,0.4-1.7,1.1-2.2c1.8-1.4,5.4-0.9,8.1,1.1c1.7,1.3,2.8,2.9,2.8,4.3c0,0.9-0.4,1.7-1.1,2.2l0,0 C226.5,132.6,225.6,132.9,224.5,132.9z M220,125c-0.7,0-1.4,0.2-1.8,0.5s-0.5,0.6-0.5,1.1c0,1,0.9,2.3,2.3,3.2 c2.2,1.6,5.2,2.1,6.5,1.1l0,0c0.4-0.3,0.5-0.6,0.5-1.1c0-1-0.9-2.3-2.3-3.2C223.2,125.6,221.4,125,220,125z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000136369634942442245270000005196145753370864046_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000079445851907501946780000009179549679244491669_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000102542312344280894180000010448731300171690899_",
    className: "st0",
    d: "M231.9,147c-2.9-1-5.3-3.3-5.2-5.3 c0.1-1.9,2.5-2.7,5.5-1.8c2.9,1,5.3,3.3,5.2,5.3C237.3,147.2,234.9,148,231.9,147z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000173148312893153954230000001240505290796148145_",
    className: "st1",
    d: "M234.3,148.1c-0.8,0-1.7-0.1-2.6-0.5 l0,0c-3.3-1.1-5.7-3.7-5.7-6c0-0.9,0.5-1.6,1.2-2.1c1.2-0.8,3.1-0.9,5.2-0.2c3.3,1.1,5.7,3.7,5.7,6c0,0.9-0.5,1.6-1.2,2.1 C236.2,147.9,235.3,148.1,234.3,148.1z M232.2,146.3c1.6,0.5,3.1,0.5,4-0.1c0.4-0.3,0.6-0.6,0.6-1.1c0.1-1.6-2.1-3.7-4.7-4.6 c-1.6-0.5-3.1-0.5-4,0.1c-0.4,0.3-0.6,0.6-0.6,1.1C227.4,143.4,229.5,145.5,232.2,146.3L232.2,146.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000120559193908550473310000003908376976010834054_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000092444306019041790370000007216498147438312374_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_00000145039483822939324800000017421438733591049387_",
    transform: "matrix(0.4561 -0.8899 0.8899 0.4561 -14.8047 279.6003)",
    className: "st0",
    cx: 221.3,
    cy: 151.9,
    rx: 3.3,
    ry: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000112611051668181729720000014640996912730406039_",
    className: "st1",
    d: "M223.6,156.5c-2.8,0-6-1.7-7.5-4l0,0 c-0.8-1.3-1-2.5-0.5-3.5s1.6-1.6,3.1-1.7c2.8-0.1,6.3,1.6,7.8,4c0.8,1.3,1,2.5,0.5,3.5s-1.6,1.6-3.1,1.7 C223.8,156.5,223.7,156.5,223.6,156.5z M217.2,151.7c1.3,1.9,4.3,3.5,6.6,3.4c1,0,1.7-0.4,2-0.9c0.3-0.6,0.1-1.3-0.4-2.2 c-1.3-1.9-4.3-3.5-6.6-3.4c-1,0-1.7,0.4-2,0.9C216.6,150.1,216.7,150.9,217.2,151.7L217.2,151.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000041279503414430559830000000058338270058087841_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000120524411288701088310000006784741438721973392_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000183963532118112592510000003885226120917290673_",
    className: "st0",
    d: "M196.2,141.8c1.5-1.2,4.8-0.7,7.3,1.1 s3.3,4.3,1.8,5.5s-4.8,0.7-7.3-1.1C195.5,145.4,194.7,143,196.2,141.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000016039072187456085540000007950948084580566452_",
    className: "st1",
    d: "M203,149.7c-1.7,0-3.7-0.7-5.4-1.9 c-1.7-1.3-2.8-2.9-2.8-4.3c0-0.9,0.4-1.7,1.1-2.2c1.8-1.4,5.4-0.9,8.1,1.1c1.7,1.3,2.8,2.9,2.8,4.3c0,0.9-0.4,1.7-1.1,2.2 C205,149.4,204.1,149.7,203,149.7z M198.5,141.8c-0.7,0-1.4,0.2-1.8,0.5s-0.5,0.6-0.5,1.1c0,1,0.9,2.3,2.3,3.2 c2.2,1.6,5.2,2.1,6.5,1.1c0.4-0.3,0.5-0.6,0.5-1.1c0-1-0.9-2.3-2.3-3.2C201.7,142.4,199.9,141.8,198.5,141.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000099645086116174622360000006377815904058315434_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000103263226817879132050000003724452130841749379_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000130615034542839934090000014236804107305922202_",
    className: "st0",
    d: "M191.1,126.3c2.9,1,5.3,3.3,5.2,5.3 c-0.1,1.9-2.5,2.7-5.5,1.8c-2.9-1-5.3-3.3-5.2-5.3C185.7,126.1,188.1,125.3,191.1,126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000013185833919026225950000015772733571546286223_",
    className: "st1",
    d: "M193.2,134.5c-0.8,0-1.7-0.1-2.6-0.5 c-3.3-1.1-5.7-3.7-5.7-6c0-0.9,0.5-1.6,1.2-2.1c1.2-0.8,3.1-0.9,5.2-0.2l0,0c3.3,1.1,5.7,3.7,5.7,6c0,0.9-0.5,1.6-1.2,2.1 C195.1,134.2,194.2,134.5,193.2,134.5z M188.7,126.6c-0.7,0-1.3,0.2-1.8,0.4c-0.4,0.3-0.6,0.6-0.6,1.1 c-0.1,1.6,2.1,3.7,4.7,4.6c1.6,0.5,3.1,0.5,4-0.1c0.4-0.3,0.6-0.6,0.6-1.1c0.1-1.6-2.1-3.7-4.7-4.6l0,0 C190.1,126.7,189.3,126.6,188.7,126.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000058591690882315783590000010880963247542564249_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000023242089506912848740000009657362345569415357_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000013877134513505655050000001528241011913131666_",
    className: "st0",
    d: "M211.6,134.9c1.5,0.5,2.6,1.7,2.6,2.6 c0,1-1.3,1.4-2.7,0.9c-1.5-0.5-2.6-1.7-2.6-2.6S210.1,134.4,211.6,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000176026453283803686980000012656404459720913032_",
    className: "st1",
    d: "M212.6,139.3c-0.4,0-0.9-0.1-1.4-0.2 c-1.8-0.6-3.1-2-3.1-3.3c0-0.6,0.3-1,0.7-1.3c0.7-0.5,1.8-0.5,2.9-0.2l0,0c1.8,0.6,3.1,2,3.1,3.3c0,0.6-0.3,1-0.7,1.3 C213.7,139.2,213.2,139.3,212.6,139.3z M210.4,135.4c-0.3,0-0.6,0.1-0.7,0.2c-0.1,0.1-0.1,0.1-0.1,0.3c0,0.6,0.9,1.5,2.1,2 c0.8,0.3,1.4,0.2,1.7,0c0.1-0.1,0.1-0.1,0.1-0.3c0-0.6-0.9-1.5-2.1-2l0,0C211,135.4,210.7,135.4,210.4,135.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000088132141378342033930000003266273387255069313_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000031186370130225363290000015531816804061997970_",
    className: "st0",
    d: "M204.1,147.3c-1.4-2.2-4.6-3.8-7.2-3.7 c-0.5,0-0.9,0.1-1.3,0.3c0.1,0.4,0.3,0.8,0.5,1.3c1.4,2.2,4.6,3.8,7.2,3.7c0.5,0,0.9-0.1,1.3-0.3 C204.6,148.2,204.4,147.8,204.1,147.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000062896143209141197880000002322672604920037808_",
    className: "st1",
    d: "M203.1,149.6c-2.8,0-6-1.7-7.5-4 c-0.3-0.5-0.5-0.9-0.6-1.5l-0.1-0.6l0.6-0.2c0.5-0.2,1-0.3,1.6-0.3c2.9-0.1,6.3,1.6,7.8,4l0,0c0.3,0.5,0.5,0.9,0.6,1.5l0.1,0.6 l-0.6,0.2c-0.5,0.2-1,0.3-1.6,0.3C203.3,149.6,203.2,149.6,203.1,149.6z M196.5,144.4c0.1,0.1,0.1,0.3,0.2,0.4 c1.3,1.9,4.3,3.5,6.6,3.4c0.2,0,0.3,0,0.5-0.1c-0.1-0.1-0.1-0.3-0.2-0.4l0,0c-1.3-1.9-4.3-3.5-6.6-3.4 C196.8,144.3,196.6,144.4,196.5,144.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000052788944518092957700000010902932127480851853_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000033327656088436959340000015625248110504874628_",
    className: "st0",
    d: "M194.4,132.1c-1.4-2.2-4.6-3.8-7.2-3.7 c-0.5,0-0.9,0.1-1.3,0.3c0.1,0.4,0.3,0.8,0.5,1.3c1.4,2.2,4.6,3.8,7.2,3.7c0.5,0,0.9-0.1,1.3-0.3 C194.8,132.9,194.6,132.5,194.4,132.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000083053460180006962840000006674953125015826586_",
    className: "st1",
    d: "M193.3,134.3c-2.8,0-6-1.7-7.5-4 c-0.3-0.5-0.5-0.9-0.6-1.5l-0.1-0.6l0.6-0.2c0.5-0.2,1-0.3,1.6-0.3c2.8-0.2,6.3,1.6,7.8,4l0,0c0.3,0.5,0.5,0.9,0.6,1.5l0.1,0.6 l-0.6,0.2c-0.5,0.2-1,0.3-1.6,0.3C193.5,134.3,193.4,134.3,193.3,134.3z M186.7,129.1c0.1,0.1,0.1,0.3,0.2,0.4 c1.3,1.9,4.3,3.5,6.6,3.4c0.2,0,0.3,0,0.5-0.1c-0.1-0.1-0.1-0.3-0.2-0.4l0,0c-1.3-1.9-4.3-3.5-6.6-3.4 C187,129.1,186.9,129.1,186.7,129.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000083047021134231696650000011237798044257500075_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000018225130477971392340000005772057857866832299_",
    className: "st0",
    d: "M225.6,130.7c-1.4-2.2-4.6-3.8-7.2-3.7 c-0.5,0-0.9,0.1-1.3,0.3c0.1,0.4,0.3,0.8,0.5,1.3c1.4,2.2,4.6,3.8,7.2,3.7c0.5,0,0.9-0.1,1.3-0.3 C226,131.5,225.9,131.1,225.6,130.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000055706644933770769420000001574235780231400093_",
    className: "st1",
    d: "M224.5,132.9c-2.8,0-6-1.7-7.5-4 c-0.3-0.5-0.5-0.9-0.6-1.5l-0.1-0.6l0.6-0.2c0.5-0.2,1-0.3,1.6-0.3c2.8-0.1,6.3,1.6,7.8,4c0.3,0.5,0.5,0.9,0.6,1.5l0.1,0.6 l-0.6,0.2c-0.5,0.2-1,0.3-1.6,0.3C224.7,132.9,224.6,132.9,224.5,132.9z M217.9,127.7c0.1,0.1,0.1,0.3,0.2,0.4 c1.3,1.9,4.3,3.5,6.6,3.4c0.2,0,0.3,0,0.5-0.1c-0.1-0.1-0.1-0.3-0.2-0.4l0,0c-1.3-1.9-4.2-3.5-6.6-3.4 C218.2,127.7,218.1,127.7,217.9,127.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000046313126925675483940000009283676228928547483_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000060005524461671694490000010741478398127842738_",
    className: "st0",
    d: "M235.5,145.7c-1.4-2.2-4.6-3.8-7.2-3.7 c-0.5,0-0.9,0.1-1.3,0.3c0.1,0.4,0.3,0.8,0.5,1.3c1.4,2.2,4.6,3.8,7.2,3.7c0.5,0,0.9-0.1,1.3-0.3 C235.9,146.6,235.8,146.1,235.5,145.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000132055984283620040430000012214944223274208154_",
    className: "st1",
    d: "M234.4,148c-2.8,0-6-1.7-7.5-4 c-0.3-0.5-0.5-0.9-0.6-1.5l-0.1-0.6l0.6-0.2c0.5-0.2,1-0.3,1.6-0.3c2.8-0.1,6.3,1.6,7.8,4c0.3,0.5,0.5,0.9,0.6,1.5l0.1,0.6 l-0.6,0.2c-0.5,0.2-1,0.3-1.6,0.3C234.6,147.9,234.5,148,234.4,148z M227.8,142.8c0.1,0.1,0.1,0.3,0.2,0.4 c1.3,1.9,4.3,3.5,6.6,3.4c0.2,0,0.3,0,0.5-0.1c-0.1-0.1-0.1-0.3-0.2-0.4l0,0c-1.3-1.9-4.3-3.5-6.6-3.4 C228.1,142.7,228,142.7,227.8,142.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000088829561529715055300000002630123486856155545_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000055686343640216006830000014135209068990463376_",
    className: "st0",
    d: "M224.7,154.2c-1.4-2.2-4.6-3.8-7.2-3.7 c-0.5,0-0.9,0.1-1.3,0.3c0.1,0.4,0.3,0.8,0.5,1.3c1.4,2.2,4.6,3.8,7.2,3.7c0.5,0,0.9-0.1,1.3-0.3 C225.1,155.1,224.9,154.7,224.7,154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000121257945269579790830000007198093356198215870_",
    className: "st1",
    d: "M223.6,156.5c-2.8,0-6-1.7-7.5-4 c-0.3-0.5-0.5-0.9-0.6-1.5l-0.1-0.6l0.6-0.2c0.5-0.2,1-0.3,1.6-0.3c2.9-0.1,6.3,1.6,7.8,4l0,0c0.3,0.5,0.5,0.9,0.6,1.5l0.1,0.6 l-0.6,0.2c-0.5,0.2-1,0.3-1.6,0.3C223.8,156.5,223.7,156.5,223.6,156.5z M217,151.3c0.1,0.1,0.1,0.3,0.2,0.4 c1.3,1.9,4.2,3.5,6.6,3.4c0.2,0,0.3,0,0.5-0.1c-0.1-0.1-0.1-0.3-0.2-0.4c-1.3-1.9-4.3-3.5-6.6-3.4 C217.3,151.2,217.2,151.3,217,151.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000111886098638051983180000001084602408157854888_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000053544002433939902060000015429713274156432023_",
    className: "st0",
    d: "M185.6,158.3c0,0-18.5-16.6-37.1-14.3 l4.2-8.1c0,0,19.9-1,36.7,15.1L185.6,158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000016036313398980663740000000619148224172540316_",
    className: "st1",
    d: "M185.2,158.8 c-0.2-0.2-18.5-16.4-36.5-14.2l-1.3,0.2l4.9-9.6h0.4c0.2,0,20.4-0.8,37.2,15.3l-1,1c-15.1-14.5-32.9-15-35.8-15l-3.4,6.6 c18.2-1.4,35.6,14,36.4,14.7L185.2,158.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000154426267094246023270000001123902704142208408_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000037669523951396610120000001657751655847002008_",
    x: 151.8,
    y: 139.2,
    transform: "matrix(0.4555 -0.8902 0.8902 0.4555 -39.5594 215.0939)",
    className: "st1",
    width: 8.5,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000018219864926741113870000015243835666284602552_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000067209458779659646940000008855341250962103715_",
    x: 183.3,
    y: 153.8,
    transform: "matrix(0.4555 -0.8902 0.8902 0.4555 -35.4317 251.1052)",
    className: "st1",
    width: 8.5,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000088101130442288398660000010250577107834716815_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000111182715055623779920000006006785601691924410_",
    x: 224.9,
    y: 167,
    transform: "matrix(0.4555 -0.8902 0.8902 0.4555 -24.5642 295.3347)",
    className: "st1",
    width: 8.5,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000006688708744194807800000012346881571531196304_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000165955410518194071100000010716127128389460389_",
    x: 212.6,
    y: 167.6,
    transform: "matrix(0.4555 -0.8902 0.8902 0.4555 -31.7395 284.6909)",
    className: "st1",
    width: 8.5,
    height: 1.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000152249807761163531840000006326533270005855408_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000163072768130099537100000010957996207892692113_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000067947769772901978210000015210892461592785801_",
    className: "st0",
    d: "M310.6,133.9l-57-18.8 c-3.9-0.9-8.1-5.2-9.5-9.5l-14-29.7c-0.8-2.7,4.1-8,6.5-7.5l64.9,14.8c2.4,0.6,5,3.2,5.9,5.9l10.3,33.3 C319.1,126.7,314.4,134.8,310.6,133.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000167355990729599437370000013820549851581813136_",
    className: "st1",
    d: "M311.2,134.6c-0.3,0-0.5,0-0.8-0.1h-0.1 l-57-18.8c-4-0.9-8.5-5.4-9.9-10l-13.9-29.6c-0.6-1.9,0.8-4.3,2.3-5.9c1.4-1.5,3.4-2.9,5-2.6l64.9,14.8c2.7,0.6,5.5,3.4,6.4,6.4 l10.3,33.3c1,3.2-0.9,7.9-3.2,10.4C313.9,133.9,312.5,134.6,311.2,134.6z M310.7,133.2c1.4,0.3,2.7-0.9,3.4-1.7 c2.1-2.2,3.7-6.4,2.9-9l-10.3-33.3c-0.8-2.5-3.2-5-5.4-5.5L236.6,69c-0.8-0.2-2.4,0.7-3.7,2.2c-1.5,1.6-2.3,3.4-2,4.4l13.9,29.6 c1.3,4.3,5.3,8.3,9,9.2L310.7,133.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000074406330963455807720000009213308295264627862_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000173849134210280428490000006019239904770901136_",
    className: "st0",
    d: "M309.7,133.7l-59.6-13.6 c-3.9-0.9-8.1-5.2-9.5-9.5l-10.3-33.3c-0.8-2.7,0.4-4.5,2.8-3.9L298,88.2c2.4,0.6,5,3.2,5.9,5.9l10.3,33.3 C315.6,131.8,313.6,134.6,309.7,133.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000006668610676528246100000007309596888434178958_",
    className: "st1",
    d: "M311.1,134.6c-0.5,0-1-0.1-1.5-0.2 L250,120.8c-4.1-0.9-8.6-5.4-10-10l-10.3-33.3c-0.5-1.7-0.3-3.2,0.5-4.1c0.7-0.8,1.9-1.1,3.1-0.8l64.9,14.8 c2.7,0.6,5.5,3.4,6.4,6.4l10.3,33.3c0.8,2.5,0.5,4.8-0.7,6.1C313.4,134.2,312.3,134.6,311.1,134.6z M309.9,133.1 c1.4,0.3,2.6,0.1,3.3-0.7c0.9-1,1.1-2.7,0.4-4.8l-10.3-33.3c-0.8-2.5-3.2-5-5.4-5.5L233,74c-0.6-0.1-1.3-0.2-1.8,0.3 s-0.6,1.5-0.2,2.7l10.3,33.3c1.3,4.2,5.3,8.2,8.9,9.1L309.9,133.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000138568402454380991780000000965318126449058468_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000140703815430250771550000012774097035391709104_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000163781173340504583030000014443754099687065780_",
    className: "st0",
    d: "M303.3,117.6l-57-13 c-1.3-0.3-2.8-1.8-3.3-3.3l-5.7-18.5c-0.5-1.5,0.2-2.5,1.6-2.2l57,13c1.3,0.3,2.8,1.8,3.3,3.3l5.7,18.5 C305.3,117,304.6,117.9,303.3,117.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000072986530100646760600000016999700522944645040_",
    className: "st1",
    d: "M303.8,118.4c-0.2,0-0.4,0-0.6-0.1 l-57-13c-1.6-0.4-3.2-2-3.8-3.8L236.7,83c-0.3-1-0.2-2,0.4-2.6c0.5-0.5,1.2-0.7,2-0.5l57,13c1.6,0.4,3.2,2,3.8,3.8l5.7,18.5 c0.3,1,0.2,2-0.4,2.6C304.8,118.2,304.3,118.4,303.8,118.4z M238.5,81.3c-0.1,0-0.3,0-0.4,0.1c-0.2,0.2-0.2,0.6,0,1.2l5.7,18.5 c0.4,1.3,1.7,2.6,2.8,2.8l57,13c0.2,0,0.5,0.1,0.7-0.1c0.2-0.2,0.2-0.6,0-1.2l-5.7-18.5c-0.4-1.3-1.7-2.6-2.8-2.8l-57-13 C238.7,81.3,238.6,81.3,238.5,81.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000042694390191087009670000002146030623055107245_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000041981511761562012270000003720286261256536206_",
    className: "st1",
    d: "M306.5,127.2L249,114.1 c-1.2-0.3-2.5-1.5-2.8-2.6l0,0c-0.4-1.2,0.3-1.9,1.5-1.6l57.4,13.1c1.2,0.3,2.5,1.5,2.8,2.6l0,0 C308.4,126.7,307.7,127.5,306.5,127.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000155124767877695164540000014866837142394066104_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000134971890665784677760000013987175546517293740_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000127752157471357075600000003663035787335783049_",
    x: 246.7,
    y: 102.4,
    transform: "matrix(0.3975 -0.9176 0.9176 0.3975 55.3462 290.4191)",
    className: "st1",
    width: 4.2,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000064330035022016016020000016275229121014878348_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000141438103974006362660000002697529789203350449_",
    x: 252.2,
    y: 103.6,
    transform: "matrix(0.3975 -0.9176 0.9176 0.3975 57.4955 296.1565)",
    className: "st1",
    width: 4.2,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000086650623185982019520000010914852740278087330_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000099624016191576389690000017659405344631155093_",
    x: 257.7,
    y: 104.9,
    transform: "matrix(0.3975 -0.9176 0.9176 0.3975 59.6573 302.0204)",
    className: "st1",
    width: 4.2,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000010998683002896715880000014634013914626055050_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000165939513185000146440000000051258426179135104_",
    x: 290.7,
    y: 112.4,
    transform: "matrix(0.3975 -0.9176 0.9176 0.3975 72.5885 336.8388)",
    className: "st1",
    width: 4.2,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000004534371902732415640000004451881874648342157_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000150788188595552072640000011937879365997541046_",
    x: 296.2,
    y: 113.7,
    transform: "matrix(0.3975 -0.9176 0.9176 0.3975 74.7528 342.6968)",
    className: "st1",
    width: 4.2,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000134958028669200194290000009151424710334562452_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000019670410621289871140000001882454851239542174_",
    x: 263.2,
    y: 106.1,
    transform: "matrix(0.3975 -0.9176 0.9176 0.3975 61.8032 307.7693)",
    className: "st1",
    width: 4.2,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000147215066359094249950000004568876738342900622_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000145751070115782608430000017892173169782884249_",
    x: 268.7,
    y: 107.4,
    transform: "matrix(0.3975 -0.9176 0.9176 0.3975 63.9648 313.6352)",
    className: "st1",
    width: 4.2,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000077313432091432055700000006718660468028422805_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000170271408312369629640000016570315022280800428_",
    x: 274.3,
    y: 108.7,
    transform: "matrix(0.3975 -0.9176 0.9176 0.3975 66.1333 319.481)",
    className: "st1",
    width: 4.2,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000040576415519660821570000015534947450435565445_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000077285254864764702780000006141580264215772574_",
    x: 279.7,
    y: 109.9,
    transform: "matrix(0.3975 -0.9176 0.9176 0.3975 68.2746 325.2434)",
    className: "st1",
    width: 4.2,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000062172425434887117560000003440825720612903567_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000022540334498910367080000011565767458182489989_",
    x: 285.2,
    y: 111.2,
    transform: "matrix(0.3975 -0.9176 0.9176 0.3975 70.4427 331.09)",
    className: "st1",
    width: 4.2,
    height: 1.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000103257490929058294820000002530272489981732238_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000080890258948276085030000005613335975156385440_",
    className: "st1",
    points: "300.8,113.5 245.9,101  246.2,99.6 301.1,112.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000158736182744189868940000004767358495201943185_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000072960060779477296390000017575276159155830432_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000042728241667500904440000008829657940249029559_",
    className: "st1",
    d: "M276.9,103.4c-0.2,0-0.4,0-0.6-0.1 c-1.3-0.3-2.7-1.5-3.1-2.8c-0.2-0.7-0.1-1.4,0.3-1.9s1.1-0.6,1.9-0.5c1.3,0.3,2.7,1.5,3.1,2.8l0,0c0.2,0.7,0.1,1.4-0.3,1.9 C277.9,103.3,277.4,103.4,276.9,103.4z M274.8,99.5c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2,0,0.5c0.2,0.8,1.2,1.7,2.1,1.9 c0.3,0.1,0.5,0,0.6,0c0.1-0.1,0.1-0.2,0-0.5c-0.2-0.8-1.2-1.7-2.1-1.9C275,99.5,274.9,99.5,274.8,99.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000144337128787571432980000012016500285578794683_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000118391224452725309440000001023569066062523820_",
    className: "st1",
    d: "M275.2,98c-0.2,0-0.4,0-0.6-0.1 c-1.3-0.3-2.7-1.5-3.1-2.8c-0.2-0.7-0.1-1.4,0.3-1.9s1.1-0.6,1.9-0.5c1.3,0.3,2.7,1.5,3.1,2.8c0.2,0.7,0.1,1.4-0.3,1.9 C276.2,97.8,275.8,98,275.2,98z M273.1,94.1c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2,0,0.5c0.2,0.8,1.2,1.7,2.1,1.9 c0.3,0.1,0.5,0,0.6,0c0.1-0.1,0.1-0.2,0-0.5l0,0c-0.2-0.8-1.2-1.7-2.1-1.9C273.3,94.1,273.2,94.1,273.1,94.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000108273083422586230350000013315019116964271237_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000132062152046070817670000001339327820043002017_",
    x: 264.9,
    y: 97.1,
    transform: "matrix(0.8929 -0.4503 0.4503 0.8929 -15.2225 131.642)",
    className: "st1",
    width: 8.3,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000018232205199305323120000001379066763651653799_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000102503757669467072760000003051689208906826410_",
    x: 267.5,
    y: 88.9,
    transform: "matrix(0.5861 -0.8103 0.8103 0.5861 33.5948 256.8492)",
    className: "st1",
    width: 1.4,
    height: 13.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000098914131272244135530000016049210533257395337_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000087400427346716438510000009384761328587790218_",
    className: "st0",
    d: "M299,87.6l-68.9-44c-1.9-1-3.2-3-3.1-4.5 l-2.6-2c0.2-1.5,5.1-6.4,7-5.4l69.9,38.4c1.9,1,3.2,3,3.1,4.5l-0.7,6.6C303.5,82.6,300.9,88.6,299,87.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000098913241585951834940000006119475259956883093_",
    className: "st1",
    d: "M299.5,88.4c-0.3,0-0.6-0.1-0.8-0.2l0,0 l-68.9-44c-1.9-1.1-3.4-3.1-3.4-4.8l-2.7-2V37c0.2-1.5,3.2-4.5,5.2-5.6c1.1-0.6,2-0.7,2.7-0.3l69.9,38.4 c2.1,1.2,3.6,3.4,3.4,5.2l-0.7,6.6c-0.1,1.2-2,5.9-4,7C300,88.4,299.7,88.4,299.5,88.4z M299.4,87c0,0,0.1,0.1,0.3-0.1 c1.4-0.7,3.2-4.7,3.3-5.9l0.7-6.6c0.1-1.1-1-2.9-2.7-3.8l-70-38.3c-0.1-0.1-0.5-0.2-1.4,0.3c-1.8,1-3.9,3.2-4.4,4.2l2.6,1.9v0.4 c-0.1,1.1,1,2.9,2.7,3.8L299.4,87z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000125580393094756548230000008876279387941413251_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000090259964278034149920000000944952526007652227_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000031891880573793942580000017278388404314488205_",
    className: "st0",
    d: "M296.6,87.1l-69.9-38.4 c-1.9-1-3.2-3-3.1-4.5l0.7-6.6c0.2-1.5,1.8-1.8,3.6-0.8l69.9,38.4c1.9,1,3.2,3,3.1,4.5l-0.7,6.6 C300,87.7,298.4,88.1,296.6,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000162344248538098759120000014254580883132513668_",
    className: "st1",
    d: "M298.5,88.4c-0.7,0-1.5-0.2-2.3-0.7 l-69.9-38.4c-2.1-1.2-3.6-3.4-3.4-5.2l0.7-6.6c0.1-0.8,0.5-1.4,1.1-1.7c0.9-0.5,2.2-0.3,3.5,0.4l69.9,38.4 c2.1,1.2,3.6,3.4,3.4,5.2l-0.7,6.6c-0.1,0.8-0.5,1.4-1.1,1.7C299.4,88.3,299,88.4,298.5,88.4z M296.9,86.5 c1.1,0.6,1.8,0.6,2.2,0.4c0.2-0.1,0.4-0.3,0.4-0.7l0.7-6.6c0.1-1.1-1-2.9-2.7-3.8l-69.9-38.4c-1-0.6-1.8-0.6-2.2-0.4 c-0.2,0.1-0.4,0.3-0.4,0.7l-0.7,6.6c-0.1,1.1,1,2.9,2.7,3.8L296.9,86.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000088096289038527220980000006276160299539486399_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000123406491410977702150000016487628358007804824_",
    className: "st1",
    points: "228.6,37.2 236.7,54.2  251.1,62.1 242.3,44.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000052101834831056603880000008599592768718112398_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000026149668257425701730000007356499338837533574_",
    className: "st1",
    points: "250.9,49.4 259.1,66.5  273.5,74.4 264.7,57  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000166667396636061021700000016938200516362788278_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_00000023243813508600636900000010677638712866698659_",
    className: "st1",
    points: "273.3,61.7 281.5,78.8  295.9,86.7 287.1,69.3  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000003817173291495846940000010683197311096342420_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000075147453734604414780000008251202868300163206_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000163762279200835403580000007703664059557722533_",
    className: "st0",
    d: "M281.9,191.3l-5.3-2.4l-2.4-6.4l1.1-2.5 l0,0l-5.9-3.8l-11.7,1l-6.2-4.5c-0.1-0.1-0.2,0-0.2,0.1L248,180c0,0,0,0,0,0.1l0,0l-3-1.9l0,0l-3.2,7.2c0,0-0.1,0.3-0.1,0.5v2.4 c0,0.9,1.1,1.9,2.5,2.3l2,0.5c0.3,0.8,0.8,1.5,1.3,2.3c0.4,0.6,1,1.2,1.5,1.7l-0.7,1.6v0.1c-0.4,0.6,0.1,1.5,1.2,2.1l3.3,2.1 c1.2,0.8,2.7,0.9,3.4,0.3l1-0.8c2.1,0.9,4.3,1.5,6.5,1.8l1,1.4c0.7,1,2.2,1.6,3.4,1.5l3.2-0.3c0.6-0.1,0.9-0.2,1.1-0.5l0.1-0.1 l0,0l2.4-5.3l1.5,0.4c1.2,0.3,2.2,0,2.4-0.7L281.9,191.3L281.9,191.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000011739614580419025100000000512696277360798126_",
    className: "st1",
    d: "M267.7,205.9c-1.4,0-2.9-0.8-3.7-1.8 l-0.8-1.1c-2-0.3-4-0.8-6-1.6l-0.6,0.6c-0.9,0.8-2.7,0.7-4.2-0.3l-3.3-2.1c-1.4-0.9-2-2.1-1.4-3.1l0.5-1.1 c-0.5-0.5-0.9-1-1.2-1.5c-0.5-0.7-0.9-1.4-1.3-2.1l-1.7-0.4c-1.7-0.5-3-1.7-3-3V186c0-0.3,0.1-0.6,0.2-0.7l3.4-7.6l0.7-0.2 l0.3,0.2l2.3,1.4l3-6.8l0.4-0.2c0.3-0.1,0.5,0,0.7,0.1l5.9,4.3l11.7-1l6.3,4l0.3,0.5l-0.2,0.3l-1,2.2l2.2,5.8l5.3,2.3l0.3,0.7 l-0.2,0.3l-3.2,7.2c-0.1,0.3-0.3,0.7-0.8,0.9c-0.6,0.4-1.5,0.4-2.5,0.2l-0.9-0.3l-2.2,4.9c-0.3,0.7-1,0.8-1.6,0.9l-3.2,0.3 C267.9,205.9,267.8,205.9,267.7,205.9z M257,199.7l0.4,0.2c2.1,0.9,4.3,1.5,6.3,1.7h0.3l1.2,1.6c0.5,0.8,1.8,1.3,2.8,1.2 l3.2-0.3c0.2,0,0.5-0.1,0.5-0.1l0.1-0.2l2.6-5.8l2.1,0.6c0.7,0.2,1.2,0.1,1.4,0c0.1-0.1,0.1-0.1,0.1-0.2l3-6.8l-4.9-2.2 l-2.6-6.9l1-2.2l-5.2-3.4l-11.7,1l-5.8-4.2l-3.2,7.3l-0.7-0.3l-2.3-1.5l-2.9,6.5c0,0,0,0.1,0,0.2v2.4c0,0.5,0.8,1.3,2,1.6 l2.3,0.6l0.1,0.3c0.3,0.7,0.7,1.5,1.3,2.2c0.4,0.5,0.8,1,1.4,1.7l0.3,0.3l-1,2.2c-0.1,0.2,0.2,0.7,1,1.2l3.3,2.1 c1.1,0.7,2.2,0.7,2.5,0.4L257,199.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000146461067560174238950000014433361692533916805_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000180362166956557709470000006876110043499294646_",
    className: "st0",
    d: "M279.4,186.3l-2-0.5 c-0.3-0.8-0.8-1.5-1.3-2.3c-0.6-0.8-1.2-1.5-2-2.2l1-0.8c0.7-0.6,0.3-1.7-0.9-2.5l-3.3-2.1c-1.2-0.8-2.7-0.9-3.4-0.3l-1,0.8 c-2.1-0.9-4.3-1.5-6.5-1.8l-1-1.4c-0.7-1-2.2-1.6-3.4-1.5l-3.2,0.3c-1.2,0.1-1.6,1-0.9,2l1,1.4c-1.5,0.7-2.5,1.6-3.2,2.8l-2-0.5 c-1.4-0.4-2.5,0.1-2.5,0.9v2.4c0,0.9,1.1,1.9,2.5,2.3l2,0.5c0.3,0.8,0.8,1.5,1.3,2.3c0.6,0.8,1.2,1.5,2,2.2l-1,0.8 c-0.7,0.6-0.3,1.7,0.9,2.5l3.3,2.1c1.2,0.8,2.7,0.9,3.4,0.3l1-0.8c2.1,0.9,4.3,1.5,6.5,1.8l1,1.4c0.7,1,2.2,1.6,3.4,1.5l3.2-0.3 c1.2-0.1,1.6-1,0.9-2l-1-1.4c1.5-0.7,2.5-1.6,3.2-2.8l2,0.5c1.4,0.4,2.5-0.1,2.5-0.9v-2.4C281.9,187.7,280.7,186.6,279.4,186.3z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000074425789643399330640000007230803517732714141_",
    className: "st1",
    d: "M270.9,198.6c-1.3,0-2.9-0.8-3.7-1.8 l-0.8-1.1c-2-0.3-4-0.8-6-1.6l-0.6,0.6c-0.9,0.8-2.7,0.7-4.2-0.3l-3.3-2.1c-0.9-0.6-1.5-1.4-1.6-2.2c0-0.5,0.2-1,0.6-1.4 l0.4-0.4c-0.6-0.6-1.1-1.2-1.5-1.8c-0.5-0.7-0.9-1.4-1.3-2.1l-1.6-0.4c-1.7-0.5-3-1.7-3-3v-2.4c0-0.5,0.2-1,0.6-1.3 c0.6-0.5,1.6-0.6,2.7-0.3l1.5,0.4c0.6-0.9,1.4-1.7,2.4-2.2l-0.5-0.7c-0.5-0.7-0.6-1.4-0.3-2c0.3-0.6,0.9-1,1.7-1.1l3.2-0.3 c1.4-0.1,3.2,0.6,4,1.8l0.8,1.1c2,0.3,4,0.8,6,1.6l0.6-0.6c0.9-0.8,2.7-0.7,4.2,0.3l3.3,2.1c0.9,0.6,1.5,1.4,1.6,2.2 c0,0.5-0.2,1-0.6,1.4l-0.4,0.4c0.6,0.6,1.1,1.2,1.5,1.8c0.5,0.7,0.9,1.4,1.3,2.1l1.7,0.4c1.7,0.5,3,1.7,3,3v2.4 c0,0.5-0.2,1-0.6,1.3c-0.6,0.5-1.6,0.6-2.7,0.3l-1.5-0.4c-0.6,0.9-1.4,1.7-2.4,2.2l0.5,0.7c0.5,0.7,0.6,1.4,0.3,2 c-0.3,0.6-0.9,1-1.7,1.1l-3.2,0.3C271.2,198.6,271.1,198.6,270.9,198.6z M260.2,192.4l0.4,0.2c2.1,0.9,4.3,1.5,6.3,1.7h0.3 l1.2,1.6c0.5,0.8,1.8,1.3,2.8,1.2l3.2-0.3c0.4,0,0.5-0.2,0.6-0.3c0-0.1,0-0.3-0.2-0.6l-1.5-2.1l0.8-0.3c1.3-0.6,2.3-1.4,2.8-2.5 l0.3-0.5l2.5,0.7c0.7,0.2,1.3,0.1,1.5-0.1c0.1-0.1,0.1-0.1,0.1-0.2v-2.4c0-0.4-0.8-1.3-2-1.6l-2.3-0.6l-0.1-0.3 c-0.3-0.7-0.7-1.5-1.3-2.2c-0.5-0.7-1.2-1.4-1.9-2.1l-0.5-0.5l1.5-1.3c0.1,0,0.1-0.1,0.1-0.2c0-0.3-0.3-0.7-0.9-1.1l-3.3-2.1 c-1.1-0.7-2.2-0.7-2.5-0.4l-1.3,1.1l-0.4-0.2c-2.1-0.9-4.2-1.5-6.3-1.7h-0.3l-1.2-1.6c-0.5-0.8-1.8-1.3-2.8-1.2l-3.2,0.3 c-0.4,0-0.5,0.2-0.6,0.3c0,0.1,0,0.3,0.2,0.6l1.5,2.1l-0.8,0.3c-1.3,0.6-2.3,1.4-2.8,2.5l-0.3,0.5l-2.5-0.7 c-0.7-0.2-1.3-0.1-1.5,0.1c-0.1,0.1-0.1,0.1-0.1,0.2v2.4c0,0.4,0.8,1.3,2,1.6l2.3,0.6l0.1,0.3c0.3,0.7,0.7,1.5,1.3,2.2 c0.5,0.7,1.1,1.4,1.9,2.1l0.5,0.5l-1.5,1.3c-0.1,0-0.1,0.1-0.1,0.2c0,0.3,0.3,0.7,0.9,1.1l3.3,2.1c1,0.7,2.2,0.7,2.5,0.4 L260.2,192.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000099620470822415946200000009305563547630911104_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000111175127759427937460000014696508084177222291_",
    x: 243.8,
    y: 186.6,
    transform: "matrix(0.4061 -0.9138 0.9138 0.4061 -23.9541 337.6498)",
    className: "st1",
    width: 8,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000057106396517076296840000018267167207314654343_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000067232903514488336670000010238965492823903670_",
    x: 245.8,
    y: 192.9,
    transform: "matrix(0.4062 -0.9138 0.9138 0.4062 -28.554 343.244)",
    className: "st1",
    width: 8,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000015342440077890056640000001293582419774118046_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000140714276326252831090000007549879318204783800_",
    x: 254.3,
    y: 196.7,
    transform: "matrix(0.4061 -0.9138 0.9138 0.4061 -26.9683 353.308)",
    className: "st1",
    width: 8,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000134209489643945154580000007949587352817956543_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000064346670707017220860000003882381715908116150_",
    x: 260.9,
    y: 198.1,
    transform: "matrix(0.4062 -0.9138 0.9138 0.4062 -24.3581 360.0978)",
    className: "st1",
    width: 8,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000135653126581098416080000007139918049541583276_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_00000106118384503084533700000002334379273282177457_",
    transform: "matrix(0.4027 -0.9153 0.9153 0.4027 -11.8222 351.5216)",
    className: "st0",
    cx: 263.4,
    cy: 184.8,
    rx: 5,
    ry: 8.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000069373513340777987850000004030812534759231924_",
    className: "st1",
    d: "M266.7,191.2c-3.9,0-8.6-2.2-10.9-5.3 c-1.3-1.7-1.6-3.5-1-5s2.2-2.4,4.3-2.6c4.1-0.5,9.5,1.9,11.9,5.2c1.3,1.7,1.6,3.5,1,5s-2.2,2.4-4.3,2.6 C267.4,191.2,267,191.2,266.7,191.2z M260.2,179.7c-0.3,0-0.6,0-0.9,0c-1.6,0.2-2.8,0.8-3.2,1.8c-0.4,1-0.1,2.3,0.8,3.6 c2.2,3,7,5.1,10.6,4.7c1.6-0.2,2.8-0.8,3.2-1.8c0.4-1,0.1-2.3-0.8-3.6C267.9,181.7,263.7,179.7,260.2,179.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000002372818539037416480000016506779120126170768_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000150066288983712370650000007163308017101493901_",
    className: "st0",
    d: "M256.6,185.1c-0.2,0-0.2,0-0.3,0 c0.1,0.1,0,0.3,0.1,0.4c2.3,3.2,7.4,5.4,11.3,5c0.2,0,0.2-0.2,0.4-0.2c-0.1-0.1-0.1-0.1-0.2-0.3 C265.5,186.9,260.5,184.7,256.6,185.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000147924023876480920370000009281479538970220173_",
    className: "st1",
    d: "M266.7,191.2c-3.9,0-8.6-2.2-10.9-5.3 c-0.1-0.2-0.2-0.4-0.2-0.5l-0.5-0.8l1.4-0.2c4.1-0.5,9.5,1.9,11.9,5.2c0.1,0.1,0.1,0.1,0.2,0.2l0.6,0.9l-0.9,0.2 c-0.1,0.1-0.3,0.2-0.5,0.2C267.4,191.2,267,191.2,266.7,191.2z M257.4,185.7c2.1,2.4,6,4.1,9.2,4.1c0.1,0,0.1,0,0.2,0 C264.6,187.4,260.7,185.7,257.4,185.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000062154259607817381590000012192298640803756684_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000098902593199860122210000012207152440795902609_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000169530884171199442040000012912002187529811625_",
    className: "st0",
    d: "M409.2,50.3l-5.7,1.6l-6.1-3.4l-0.7-2.7 l0,0l-7.2,0.9l-8.5,8.5l-7.8,0.5c-0.1,0-0.2,0.1-0.1,0.2l2.2,7.7c0,0,0,0,0,0.1l0,0l-3.6,0.5l0,0l2.2,7.8c0,0,0.1,0.3,0.2,0.4 l1.6,1.9c0.6,0.7,2.2,0.8,3.5,0.2l1.9-0.9c0.8,0.4,1.6,0.7,2.6,0.9c0.7,0.2,1.5,0.3,2.3,0.4l0.5,1.7v0.1 c0.1,0.7,1.1,1.1,2.3,0.9l3.9-0.5c1.4-0.2,2.7-1.1,2.9-2l0.2-1.3c2.2-0.7,4.4-1.7,6.2-2.9l1.7,0.4c1.2,0.3,2.8-0.2,3.7-1 l2.3-2.4c0.4-0.4,0.6-0.8,0.5-1.1v-0.1l0,0l-1.6-5.8l1.5-0.7c1.2-0.5,1.8-1.5,1.4-2.1L409.2,50.3L409.2,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000072965949196412105770000017181200216043832220_",
    className: "st1",
    d: "M388.2,78.5c-1.3,0-2.3-0.6-2.4-1.5 l-0.4-1.3c-0.7-0.1-1.4-0.2-2-0.4c-0.8-0.2-1.6-0.5-2.4-0.8l-1.6,0.7c-1.6,0.8-3.5,0.6-4.3-0.3l-1.6-1.9 c-0.2-0.2-0.3-0.5-0.3-0.7l-2.3-8.2l0.4-0.6h0.4l2.7-0.4l-2.1-7.4l0.2-0.4c0.1-0.2,0.4-0.3,0.6-0.4l7.5-0.5l8.5-8.5l7.6-0.9 l0.5,0.4l0.7,2.6l5.6,3.2l5.8-1.6l0.5,0.4v0.2L412,58c0.2,0.3,0.2,0.8,0,1.2c-0.3,0.7-0.9,1.3-1.8,1.8l-0.9,0.4l1.5,5.4 c0.2,0.7-0.3,1.3-0.7,1.8l-2.3,2.4c-1,1.1-2.9,1.6-4.3,1.2l-1.4-0.4c-1.7,1.1-3.6,2-5.7,2.7l-0.1,0.9c-0.2,1.2-1.7,2.3-3.5,2.6 l-3.9,0.5C388.7,78.5,388.4,78.5,388.2,78.5z M381.1,73l0.3,0.2c0.7,0.4,1.5,0.7,2.4,0.9c0.6,0.2,1.3,0.3,2.2,0.4h0.5l0.6,2.3 c0,0.2,0.6,0.4,1.6,0.3l3.9-0.5c1.3-0.2,2.2-0.9,2.3-1.4l0.3-1.7l0.4-0.1c2.2-0.7,4.3-1.7,6.1-2.8l0.3-0.2l2,0.5 c0.9,0.2,2.3-0.2,3-0.9l2.3-2.4c0.2-0.2,0.3-0.4,0.3-0.5v-0.2l-1.8-6.3l2-0.9c0.7-0.3,1-0.7,1.1-1c0.1-0.2,0-0.2,0-0.3l-2.1-7.3 l-5.3,1.5l-6.6-3.7l-0.7-2.4l-6.3,0.8l-8.6,8.6l-7.4,0.5l2.2,7.9l-0.8,0.2l-2.8,0.4l2,7.1l0.1,0.2l1.6,1.9 c0.3,0.4,1.5,0.5,2.7,0L381.1,73z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000083788094834588453510000007649455668758568848_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000178917156046035998250000005399896191446701204_",
    className: "st0",
    d: "M404,48l-1.9,0.9 c-0.8-0.4-1.6-0.7-2.6-0.9s-2-0.4-3-0.5l0.2-1.3c0.1-0.9-0.9-1.5-2.4-1.3l-3.9,0.5c-1.4,0.2-2.7,1.1-2.9,2l-0.2,1.3 c-2.2,0.7-4.4,1.7-6.2,2.9l-1.7-0.4c-1.2-0.3-2.8,0.2-3.7,1l-2.3,2.4c-0.8,0.9-0.6,1.8,0.6,2.1l1.7,0.4c-0.7,1.5-0.9,3-0.7,4.3 l-1.9,0.9c-1.3,0.6-1.9,1.7-1.3,2.4l1.6,1.9c0.6,0.7,2.2,0.8,3.5,0.2l1.9-0.9c0.8,0.4,1.6,0.7,2.6,0.9s2,0.4,3,0.5l-0.2,1.3 c-0.1,0.9,0.9,1.5,2.4,1.3l3.9-0.5c1.4-0.2,2.7-1.1,2.9-2l0.2-1.3c2.2-0.7,4.4-1.7,6.2-2.9l1.7,0.4c1.2,0.3,2.8-0.2,3.7-1 l2.3-2.4c0.8-0.9,0.6-1.8-0.6-2.1l-1.7-0.4c0.7-1.5,0.9-3,0.7-4.3l1.9-0.9c1.3-0.6,1.9-1.7,1.3-2.4l-1.6-1.9 C406.8,47.5,405.3,47.4,404,48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000178190427327811719210000000476744276606801544_",
    className: "st1",
    d: "M386.1,70.6c-0.9,0-1.6-0.3-2.1-0.7 c-0.4-0.4-0.5-0.9-0.5-1.4l0.1-0.6c-0.8-0.1-1.6-0.2-2.4-0.4s-1.6-0.5-2.4-0.8l-1.6,0.7c-1.6,0.8-3.5,0.6-4.3-0.3l-1.6-1.9 c-0.3-0.4-0.5-0.9-0.4-1.4c0.2-0.8,0.9-1.5,1.9-2l1.4-0.7c-0.1-1.1,0-2.3,0.5-3.4l-0.9-0.2c-0.8-0.2-1.4-0.7-1.6-1.3 s0-1.4,0.6-2l2.3-2.4c1-1.1,2.9-1.6,4.3-1.2l1.4,0.4c1.7-1.1,3.6-2,5.7-2.7l0.1-0.9c0.2-1.2,1.7-2.3,3.5-2.6l3.9-0.5 c1.1-0.1,2.1,0.1,2.7,0.7c0.4,0.4,0.5,0.9,0.5,1.4l-0.1,0.6c0.8,0.1,1.6,0.2,2.4,0.4s1.6,0.5,2.4,0.8l1.6-0.7 c1.6-0.8,3.5-0.6,4.3,0.3l1.6,1.9c0.3,0.4,0.5,0.9,0.4,1.4c-0.2,0.8-0.9,1.5-1.9,2l-1.4,0.7c0.1,1.1,0,2.3-0.5,3.4l0.9,0.2 c0.8,0.2,1.4,0.7,1.6,1.3s0,1.4-0.6,2l-2.3,2.4c-1,1.1-2.9,1.6-4.3,1.2l-1.4-0.4c-1.7,1.1-3.6,2-5.8,2.7l-0.1,0.9 c-0.2,1.2-1.7,2.3-3.5,2.6l-3.9,0.5C386.4,70.5,386.2,70.6,386.1,70.6z M378.9,65l0.3,0.2c0.7,0.4,1.5,0.7,2.4,0.9 s1.8,0.4,2.9,0.4l0.8,0.1l-0.3,2c0,0.1,0,0.2,0.1,0.2c0.2,0.2,0.8,0.4,1.5,0.3l3.9-0.5c1.3-0.2,2.2-0.9,2.3-1.4l0.3-1.7l0.4-0.1 c2.3-0.7,4.3-1.6,6.1-2.8l0.3-0.2l2,0.5c0.9,0.2,2.3-0.2,3-0.9l2.3-2.4c0.2-0.2,0.3-0.5,0.3-0.6s-0.3-0.3-0.6-0.4l-2.5-0.6 l0.4-0.8c0.7-1.3,0.9-2.6,0.6-3.8l-0.1-0.5l2.4-1.1c0.7-0.3,1.1-0.8,1.1-1c0-0.1,0-0.2-0.1-0.2l-1.6-1.9c-0.3-0.4-1.5-0.5-2.7,0 l-2.2,1l-0.3-0.2c-0.7-0.4-1.5-0.7-2.4-0.9s-1.8-0.4-2.9-0.4l-0.8-0.1l0.3-2c0-0.1,0-0.2-0.1-0.2c-0.2-0.2-0.8-0.4-1.5-0.3 l-3.9,0.5c-1.3,0.2-2.2,0.9-2.3,1.4l-0.3,1.7l-0.4,0.1c-2.2,0.7-4.3,1.7-6.1,2.8l-0.3,0.2l-2-0.5c-0.9-0.2-2.3,0.2-3,0.9L374,55 c-0.2,0.2-0.3,0.5-0.3,0.6s0.3,0.3,0.6,0.4l2.5,0.6l-0.4,0.8c-0.7,1.3-0.9,2.6-0.6,3.8l0.1,0.5l-2.4,1.1c-0.7,0.3-1.1,0.8-1.1,1 c0,0.1,0,0.2,0.1,0.2l1.6,1.9c0.3,0.4,1.5,0.5,2.7,0L378.9,65z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000083081538817798962930000013127692855305733304_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000155143770868319112090000014114557548541573540_",
    x: 379.1,
    y: 65.5,
    transform: "matrix(0.9624 -0.2715 0.2715 0.9624 -4.6392 105.7302)",
    className: "st1",
    width: 1.4,
    height: 8.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000145758603285352874190000010255889167739415221_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000058562842329222286420000014017819926031469205_",
    x: 384.8,
    y: 69.2,
    transform: "matrix(0.9624 -0.2715 0.2715 0.9624 -5.4345 107.4203)",
    className: "st1",
    width: 1.4,
    height: 8.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000029036674669349717200000004836564470059892644_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000050648157466310646620000012252355599531749506_",
    x: 394.1,
    y: 66.6,
    transform: "matrix(0.9624 -0.2715 0.2715 0.9624 -4.3771 109.8483)",
    className: "st1",
    width: 1.4,
    height: 8.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000181769910394121640280000014539326726552166047_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000098901906250211346210000008121651741030179457_",
    x: 400.1,
    y: 63.4,
    transform: "matrix(0.9624 -0.2715 0.2715 0.9624 -3.2828 111.3572)",
    className: "st1",
    width: 1.4,
    height: 8.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000003792931119673902700000014471625487518115995_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_00000074404147982188994360000005087987812518142899_",
    transform: "matrix(0.9597 -0.2809 0.2809 0.9597 -0.372 111.9933)",
    className: "st0",
    cx: 390.5,
    cy: 57.3,
    rx: 8.9,
    ry: 5.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000051360616679943520560000013315076664302013604_",
    className: "st1",
    d: "M387.9,63.6c-0.9,0-1.8-0.1-2.6-0.3 c-2.1-0.5-3.6-1.7-4-3.3c-0.5-1.6,0.1-3.3,1.7-4.9c2.9-3.1,8.7-4.7,12.8-3.7c2.1,0.5,3.6,1.7,4,3.3c0.5,1.6-0.1,3.3-1.7,4.9 C395.7,62,391.5,63.6,387.9,63.6z M393,52.5c-3.3,0-7,1.4-9.1,3.6c-1.2,1.2-1.6,2.5-1.3,3.6c0.3,1.1,1.4,1.9,3,2.3 c3.7,0.9,8.8-0.6,11.4-3.3c1.2-1.2,1.6-2.5,1.3-3.6c-0.3-1.1-1.4-1.9-3-2.3C394.6,52.6,393.8,52.5,393,52.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000152971880537408707540000010371046198519298207_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000175297457139547077920000008435676441146652832_",
    className: "st0",
    d: "M385.3,62.1c-0.1,0.1-0.1,0.1-0.2,0.2 c0.1,0,0.2,0.2,0.4,0.3c3.9,1,9.3-0.6,12.1-3.5c0.1-0.1,0.1-0.3,0.2-0.4c-0.1,0-0.1,0-0.3-0.1C393.5,57.6,388.1,59.2,385.3,62.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000015318087774702626040000017125523692774932359_",
    className: "st1",
    d: "M387.9,63.6c-0.9,0-1.8-0.1-2.6-0.3 c-0.2-0.1-0.4-0.2-0.5-0.3l-0.9-0.3l0.9-1.1c2.9-3.1,8.7-4.7,12.8-3.7c0.2,0,0.2,0,0.3,0.1l1,0.3l-0.6,0.8c0,0,0,0.2-0.2,0.4 C395.7,62,391.5,63.6,387.9,63.6z M386.3,62.1c3.3,0.5,7.6-0.7,10.2-3C393.1,58.6,388.9,59.8,386.3,62.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000130631153651329469690000010475089018698850957_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000032622712249005208950000011287983559252897709_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000021091452614430844720000001611090594291089570_",
    className: "st0",
    d: "M334.7,75c-0.5,1.8-2.9,2.7-5.5,2 c-2.5-0.7-4.2-2.7-3.8-4.4c0.5-1.8,2.9-2.7,5.5-2C333.5,71.3,335.2,73.3,334.7,75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000160911274647148896600000005531025490666312840_",
    className: "st1",
    d: "M331,78c-0.6,0-1.2-0.1-1.9-0.3 c-2.9-0.8-4.8-3.1-4.2-5.3c0.3-1.1,1.1-1.9,2.4-2.4c1.2-0.4,2.6-0.5,3.9-0.1c3,0.8,4.8,3.1,4.2,5.3l0,0 C335,76.9,333.2,78,331,78z M329.3,71.1c-0.6,0-1.1,0.1-1.6,0.3c-0.8,0.3-1.3,0.8-1.5,1.4c-0.4,1.4,1.1,3,3.3,3.6 c2.1,0.6,4.2-0.1,4.6-1.5s-1.1-3-3.3-3.6C330.3,71.1,329.8,71.1,329.3,71.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000104700560103071404240000017213837513839609791_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000129926977002100448370000018200387541278730928_",
    className: "st0",
    d: "M351.8,71.5c-0.5,1.8-2.9,2.7-5.5,2 c-2.5-0.7-4.2-2.7-3.8-4.4c0.5-1.8,2.9-2.7,5.5-2C350.6,67.7,352.3,69.7,351.8,71.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000170976172607060179530000001513885094267127464_",
    className: "st1",
    d: "M348,74.4c-0.6,0-1.2-0.1-1.9-0.2 c-3-0.8-4.8-3.1-4.2-5.3c0.6-2.2,3.3-3.3,6.3-2.5c2.9,0.8,4.8,3.1,4.2,5.3c-0.3,1.1-1.1,1.9-2.4,2.4 C349.4,74.3,348.8,74.4,348,74.4z M346.4,67.5c-1.5,0-2.8,0.6-3.1,1.7c-0.4,1.4,1.1,3,3.3,3.6c1.1,0.3,2.2,0.3,3.1-0.1 c0.8-0.3,1.3-0.8,1.5-1.4c0.4-1.4-1.1-3-3.3-3.6C347.4,67.6,346.8,67.5,346.4,67.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000060007412841798152120000017576447528620866452_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000024681529651550686800000005086327096245774989_",
    className: "st1",
    d: "M335.4,75.2l-1.3-0.4l5.6-21.2 c0.2-0.9,1-1.7,2-1.8l14.3-2.6c0.6-0.1,1.1,0.1,1.5,0.5s0.5,1,0.4,1.5l-5.4,20.3l-1.3-0.4l5.4-20.3c0-0.1,0-0.2-0.1-0.2 c0,0-0.1-0.1-0.2-0.1L342,53.1c-0.4,0.1-0.8,0.4-0.9,0.8L335.4,75.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000052062975621404929020000005948614814206726842_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000010292632929191652070000005871057560772230789_",
    className: "st0",
    d: "M340.3,58.8l14.3-2.4 c0.7-0.1,1.4-0.7,1.5-1.4l1-3.9c0.2-0.7-0.4-1.3-1.1-1.2l-14.3,2.6c-0.7,0.1-1.3,0.6-1.4,1.3l-1,3.9 C339.2,58.3,339.7,58.9,340.3,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000157283770898853794050000018383134917875146124_",
    className: "st1",
    d: "M340.2,59.5c-0.4,0-0.8-0.2-1.1-0.5 c-0.4-0.4-0.5-0.9-0.4-1.4l1-3.9c0.2-0.9,1-1.7,2-1.8l14.3-2.6c0.6-0.1,1.1,0.1,1.5,0.5s0.5,1,0.4,1.5l-1,3.9 c-0.3,1-1.1,1.7-2.1,1.9l-14.3,2.4C340.3,59.5,340.2,59.5,340.2,59.5z M356.3,50.7L356.3,50.7l-14.4,2.6 c-0.4,0.1-0.8,0.4-0.9,0.8l-1,3.9l0.2,0.2l14.3-2.4c0.5-0.1,0.9-0.4,1-0.9l1-3.9c0-0.1,0-0.2-0.1-0.2 C356.4,50.7,356.4,50.7,356.3,50.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000009573615916323338580000006172202720636395181_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000057133105543200839160000003659460919836313734_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000123398681211613431530000012101973723739527816_",
    className: "st0",
    d: "M181.4,44.9c-1.7,0.7-3.9-0.7-4.9-3.1 c-1-2.4-0.5-5,1.2-5.7s3.9,0.7,4.9,3.1C183.6,41.7,183.1,44.2,181.4,44.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000158750602854006358030000018193123950247179679_",
    className: "st1",
    d: "M180.4,45.8c-1.8,0-3.6-1.4-4.6-3.7 c-1.2-2.8-0.4-5.7,1.6-6.6c2.1-0.9,4.6,0.7,5.8,3.5c1.2,2.8,0.4,5.7-1.6,6.6l0,0C181.3,45.7,180.9,45.8,180.4,45.8z M178.7,36.6 c-0.2,0-0.5,0-0.7,0.1c-1.3,0.5-1.7,2.7-0.9,4.8c0.8,2,2.7,3.3,4,2.7l0,0c1.3-0.5,1.7-2.7,0.9-4.8 C181.3,37.8,179.9,36.6,178.7,36.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000155112205164506602570000000744539621686348725_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000039126125753243999970000018287003630526820019_",
    className: "st0",
    d: "M191.5,40.7c0,0,3.6-0.2,6.1,6.3 s6.4,6.7,6.4,6.7l5.3-2.2c0.3-0.1,0.3-0.6,0-0.7c-1.7-0.7-5.3-2.7-6.2-6.7c-1.1-4.6-4.9-6.2-5.5-5.9l-16.2,6.7L191.5,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000168117544282386092920000015165079748774720697_",
    className: "st1",
    d: "M204.2,54.4H204c-0.2,0-4.4-0.2-7.1-7.1 c-2.1-5.4-4.8-5.9-5.3-5.9l-9.9,4.1l-0.5-1.3l16.2-6.7c0.6-0.3,1.6,0.1,2.1,0.4c0.8,0.4,3.5,2.1,4.4,6c0.9,3.8,4.3,5.6,5.8,6.3 c0.4,0.2,0.7,0.6,0.7,1s-0.3,0.8-0.7,1L204.2,54.4z M193.5,40.6c1.4,0.7,3.3,2.4,4.7,6.2c2.1,5.3,5,6.1,5.7,6.2l4.5-1.9 c-1.9-0.9-5.1-3-6-6.9c-0.9-4-4.1-5.4-4.7-5.4l0,0L193.5,40.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000010305878431239562120000018261968911500512653_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000033360582436144827670000001241274079905556375_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000063625877936084835500000003627340700662277761_",
    className: "st0",
    d: "M390.8,131.1c-1.7,0.7-3.9-0.7-4.9-3.1 c-1-2.4-0.5-5,1.2-5.7s3.9,0.7,4.9,3.1C393.1,127.8,392.5,130.4,390.8,131.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000013881554563825494020000017761245718132077246_",
    className: "st1",
    d: "M389.9,131.9c-0.7,0-1.4-0.2-2.1-0.7 c-1-0.7-1.9-1.8-2.5-3.1c-1.2-2.8-0.4-5.7,1.6-6.6c1-0.4,2.2-0.3,3.3,0.4c1,0.7,1.9,1.8,2.5,3.1c0.5,1.3,0.7,2.7,0.4,3.9 c-0.3,1.3-1,2.3-2.1,2.7C390.7,131.9,390.3,131.9,389.9,131.9z M388.1,122.8c-0.2,0-0.5,0-0.7,0.1c-1.3,0.5-1.7,2.7-0.9,4.8 c0.4,1,1.1,1.9,1.9,2.4c0.7,0.5,1.5,0.6,2.1,0.3l0,0c0.6-0.3,1-0.9,1.2-1.7c0.2-0.9,0.1-2-0.4-3.1c-0.4-1-1.1-1.9-1.9-2.4 C389.1,122.9,388.6,122.8,388.1,122.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000044875237373912401420000009694601690761152178_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000080202116287503649670000007069357412942642347_",
    className: "st0",
    d: "M400.9,126.9c0,0,3.6-0.2,6.1,6.3 s6.4,6.7,6.4,6.7l5.3-2.2c0.3-0.1,0.3-0.6,0-0.7c-1.7-0.7-5.3-2.7-6.2-6.7c-1.1-4.6-4.9-6.2-5.5-5.9l-16.2,6.7L400.9,126.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000115492506206306191960000001173534664088747676_",
    className: "st1",
    d: "M413.6,140.6h-0.2c-0.2,0-4.4-0.2-7.1-7.1 c-2.1-5.4-4.8-5.9-5.3-5.9l-9.9,4.1l-0.5-1.3l16.2-6.7c0.6-0.3,1.6,0.1,2.1,0.4c0.8,0.4,3.5,2.1,4.4,6c0.9,3.8,4.3,5.6,5.8,6.3 c0.4,0.2,0.7,0.6,0.7,1s-0.3,0.8-0.7,1L413.6,140.6z M403,126.8c1.4,0.7,3.3,2.4,4.7,6.2c2.1,5.3,5,6.1,5.7,6.2l4.5-1.9 c-1.9-0.9-5.1-3-6-6.9c-0.9-4.1-4.2-5.5-4.7-5.4L403,126.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000155861204636012270230000012718696666785333902_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000142170251336775668770000017556411160227373209_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000007408975134040642390000016252796557135365549_",
    className: "st0",
    d: "M291.9,53L277,31.9 c-0.9-1.3-0.6-3,0.7-3.9l10.6-7.5c1.3-0.9,3-0.6,3.9,0.7l14.9,21.1c0.9,1.3,0.6,3-0.7,3.9l-10.6,7.5 C294.5,54.6,292.8,54.3,291.9,53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000087408739557191625080000017754011878278844074_",
    className: "st1",
    d: "M294.2,54.9c-1.1,0-2.2-0.5-2.8-1.5 l-14.9-21.1c-0.5-0.8-0.7-1.7-0.6-2.6c0.2-0.9,0.7-1.7,1.4-2.2l10.6-7.5c1.6-1.1,3.7-0.7,4.8,0.8l14.9,21.1 c0.5,0.8,0.7,1.7,0.6,2.6c-0.2,0.9-0.7,1.7-1.4,2.2l-10.6,7.5C295.6,54.7,294.9,54.9,294.2,54.9z M292.5,52.6 c0.7,0.9,2,1.2,2.9,0.5l10.6-7.5c0.5-0.3,0.8-0.8,0.9-1.3s0-1.1-0.4-1.6l-14.9-21.1c-0.7-0.9-2-1.2-2.9-0.5l-10.6,7.5 c-0.5,0.3-0.8,0.8-0.9,1.3s0,1.1,0.4,1.6L292.5,52.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000175303836076388905500000003467942441240726924_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000158737289585545074350000009384405025296284340_",
    className: "st1",
    d: "M302.4,44.8l-0.8-1.1l1.1-0.8l0.8,1.1 L302.4,44.8z M299.5,40.7l-2.1-3l1.1-0.8l2.1,3L299.5,40.7z M295.3,34.6l-2.1-3l1.1-0.8l2.1,3L295.3,34.6z M291,28.6l-2.1-3 l1.1-0.8l2.1,3L291,28.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000094580287448154046890000012704469497460499903_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000059281255229733674730000016755893554076300459_",
    className: "st1",
    d: "M294.7,50.2l-0.8-1.1l1.1-0.8l0.8,1.1 L294.7,50.2z M291.8,46.2l-2.1-3l1.1-0.8l2.1,3L291.8,46.2z M287.5,40.1l-2.1-3l1.1-0.8l2.1,3L287.5,40.1z M283.3,34.1l-2.1-3 l1.1-0.8l2.1,3L283.3,34.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000008142529698343300180000005555485360304764295_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000131353194023426784000000012679508281916981679_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000148623671126107846450000009973096551306214062_",
    className: "st0",
    d: "M340.3,166.8l-25.6-3.6 c-1.5-0.2-2.6-1.6-2.4-3.1l1.8-12.8c0.2-1.5,1.6-2.6,3.1-2.4l25.6,3.6c1.5,0.2,2.6,1.6,2.4,3.1l-1.8,12.8 C343.3,165.9,341.9,167,340.3,166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000034075016875515179650000015819720257046164625_",
    className: "st1",
    d: "M340.7,167.5c-0.2,0-0.3,0-0.5,0 l-25.6-3.6c-0.9-0.1-1.7-0.6-2.3-1.3c-0.6-0.7-0.8-1.7-0.7-2.6l1.8-12.8c0.1-0.9,0.6-1.7,1.3-2.3c0.7-0.6,1.7-0.8,2.6-0.7 l25.6,3.6c0.9,0.1,1.7,0.6,2.3,1.4c0.6,0.7,0.8,1.7,0.7,2.6l-1.8,12.8c-0.1,0.9-0.6,1.7-1.4,2.3 C342.2,167.3,341.5,167.5,340.7,167.5z M340.4,166.1c0.6,0.1,1.1-0.1,1.5-0.4s0.7-0.8,0.8-1.4l1.8-12.8c0.1-0.6-0.1-1.1-0.4-1.5 s-0.8-0.7-1.4-0.8l-25.6-3.6c-0.5-0.1-1.1,0.1-1.5,0.4c-0.4,0.3-0.7,0.8-0.8,1.4l-1.8,12.8c-0.1,0.5,0.1,1.1,0.4,1.5 s0.8,0.7,1.4,0.8L340.4,166.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000088855501063512547990000008492440452863595447_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000159450755383501173220000017260513210261328257_",
    className: "st1",
    d: "M341.6,153.5l-1.3-0.2l0.2-1.4l1.3,0.2 L341.6,153.5z M336.6,152.8l-3.7-0.5l0.2-1.4l3.7,0.5L336.6,152.8z M329.3,151.7l-3.7-0.5l0.2-1.4l3.7,0.5L329.3,151.7z  M321.9,150.7l-3.7-0.5l0.2-1.4l3.7,0.5L321.9,150.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000183223365096430175800000001289552958372011687_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000098201735170704422990000014395720176878976698_",
    className: "st1",
    d: "M340.2,162.8l-1.3-0.2l0.2-1.4l1.3,0.2 L340.2,162.8z M335.3,162.1l-3.7-0.5l0.2-1.4l3.7,0.5L335.3,162.1z M327.9,161.1l-3.7-0.5l0.2-1.4l3.7,0.5L327.9,161.1z  M320.6,160l-3.7-0.5l0.2-1.4l3.7,0.5L320.6,160z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000022553352813653051140000011412981987985757603_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000161627469632954306130000009032000129289403312_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000005248772112413327450000016642691366339497600_",
    className: "st0",
    d: "M202,94.1l-6.4-25c-0.4-1.5,0.5-3,2-3.4 l12.5-3.2c1.5-0.4,3,0.5,3.4,2l6.4,25c0.4,1.5-0.5,3-2,3.4l-12.5,3.2C203.9,96.5,202.4,95.6,202,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000102525565803196904660000000482635903367926442_",
    className: "st1",
    d: "M204.7,96.9c-0.6,0-1.2-0.2-1.8-0.5 c-0.8-0.5-1.4-1.2-1.6-2.1l-6.4-25c-0.5-1.9,0.6-3.7,2.5-4.2l12.5-3.2c1.9-0.5,3.7,0.6,4.2,2.5l6.4,25c0.5,1.9-0.6,3.7-2.5,4.2 l-12.5,3.2C205.3,96.9,205,96.9,204.7,96.9z M210.8,63.1c-0.2,0-0.3,0-0.5,0.1l-12.5,3.2c-1.1,0.3-1.8,1.4-1.5,2.5l6.4,25 c0.1,0.5,0.5,1,1,1.3s1,0.4,1.6,0.2l12.5-3.2c1.1-0.3,1.8-1.4,1.5-2.5l-6.4-25C212.6,63.7,211.8,63.1,210.8,63.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000009585749097885923690000006043293912120023703_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000027588340926222594940000012982358786854457241_",
    className: "st1",
    d: "M214.8,90.1l-0.3-1.3l1.3-0.3l0.3,1.3 L214.8,90.1z M213.5,85.3l-0.9-3.6l1.3-0.3l0.9,3.6L213.5,85.3z M211.7,78.1l-0.9-3.6l1.3-0.3l0.9,3.6L211.7,78.1z M209.9,70.9 l-0.9-3.6l1.3-0.3l0.9,3.6L209.9,70.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000088120416728310418480000001357786047420834432_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000111177560396873211370000001656359295085266832_",
    className: "st1",
    d: "M205.6,92.5l-0.3-1.3l1.3-0.3l0.3,1.3 L205.6,92.5z M204.4,87.6l-0.9-3.6l1.3-0.3l0.9,3.6L204.4,87.6z M202.6,80.5l-0.9-3.6l1.3-0.3l0.9,3.6L202.6,80.5z M200.7,73.3 l-0.9-3.6l1.3-0.3L202,73L200.7,73.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000095335327986566180690000011386708055031620251_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000016066476560504219680000004056756871773445819_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000087414216111716461570000009895507208776102037_",
    className: "st0",
    d: "M185.4,339.5l9.5-24 c0.6-1.4,2.2-2.1,3.6-1.6l12,4.8c1.4,0.6,2.1,2.2,1.6,3.6l-9.5,24c-0.6,1.4-2.2,2.1-3.6,1.6l-12-4.8 C185.5,342.5,184.8,340.9,185.4,339.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000008124047279295920170000015605550344175241392_",
    className: "st1",
    d: "M200,348.7c-0.4,0-0.9-0.1-1.3-0.2 l-12-4.8c-0.9-0.3-1.5-1-1.9-1.8c-0.4-0.9-0.4-1.8,0-2.7l9.5-24c0.7-1.8,2.7-2.6,4.5-1.9l12,4.8c1.8,0.7,2.7,2.7,2,4.5l-9.5,24 C202.7,347.9,201.4,348.7,200,348.7z M186,339.7c-0.2,0.5-0.2,1.1,0,1.6s0.6,0.9,1.1,1.1l12,4.8c1.1,0.4,2.3-0.1,2.7-1.2l9.5-24 c0.4-1.1-0.1-2.3-1.2-2.7l-12-4.8c-1.1-0.4-2.3,0.1-2.7,1.2L186,339.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000072281683784379621600000017134497143308159616_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000047041317986466051990000006660431068622806932_",
    className: "st1",
    d: "M199.3,344.3l-1.3-0.5l0.5-1.2l1.3,0.5 L199.3,344.3z M201.2,339.6l-1.3-0.5l1.4-3.4l1.3,0.5L201.2,339.6z M203.9,332.7l-1.3-0.5l1.4-3.4l1.3,0.5L203.9,332.7z  M206.6,325.8l-1.3-0.5l1.4-3.4l1.3,0.5L206.6,325.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000147178594906724492520000004407683344111376784_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000095323296652617787810000012096447263051140274_",
    className: "st1",
    d: "M190.5,340.8l-1.3-0.5l0.5-1.2l1.3,0.5 L190.5,340.8z M192.4,336.1l-1.3-0.5l1.4-3.4l1.3,0.5L192.4,336.1z M195.1,329.2l-1.3-0.5l1.4-3.4l1.3,0.5L195.1,329.2z  M197.8,322.3l-1.3-0.5l1.4-3.4l1.3,0.5L197.8,322.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000064315136571234443240000005528478414074058882_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000063627109862041597070000015301620215673528453_",
    className: "st0",
    d: "M142.9,113.8l0.3,2.9c0,0.4,0.3,0.8,0.7,1 l2.5,1.4c0.9,0.5,0.9,1.9-0.1,2.3l-2.7,1.2c-0.4,0.2-0.7,0.5-0.7,0.9l-0.6,2.9c-0.2,1-1.5,1.4-2.2,0.6l-1.9-2.2 c-0.3-0.3-0.7-0.5-1.1-0.4l-2.9,0.4c-1.1,0.1-1.8-1-1.3-1.9l1.5-2.5c0.2-0.4,0.2-0.8,0.1-1.2l-1.2-2.6c-0.4-1,0.4-2,1.4-1.8 l2.8,0.6c0.4,0.1,0.8,0,1.1-0.3l2.1-2C141.5,112.3,142.8,112.8,142.9,113.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000034780846461031016140000014643370302291852421_",
    className: "st1",
    d: "M141,128.1c-0.6,0-1.1-0.2-1.5-0.7 l-1.9-2.2c-0.1-0.1-0.3-0.2-0.5-0.2l-2.9,0.4c-0.8,0.1-1.5-0.2-1.9-0.9c-0.4-0.6-0.4-1.4-0.1-2.1l1.5-2.5c0.1-0.2,0.1-0.4,0-0.5 l-1.2-2.6c-0.3-0.7-0.2-1.5,0.2-2.1c0.5-0.6,1.2-0.9,2-0.7l2.8,0.6c0.2,0,0.4,0,0.5-0.1l2.1-2c0.6-0.5,1.3-0.7,2-0.4 s1.2,0.9,1.3,1.7l0.3,2.9c0,0.2,0.1,0.4,0.3,0.5l2.5,1.4c0.7,0.4,1.1,1.1,1,1.8c0,0.8-0.5,1.4-1.2,1.7l-2.7,1.2 c-0.2,0.1-0.3,0.2-0.3,0.4l-0.6,2.9c-0.1,0.7-0.7,1.3-1.4,1.5C141.4,128.1,141.2,128.1,141,128.1z M137.2,123.7 c0.6,0,1.1,0.2,1.5,0.7l1.9,2.2c0.2,0.2,0.5,0.2,0.6,0.2s0.4-0.1,0.4-0.5l0.6-2.9c0.1-0.6,0.6-1.2,1.1-1.4l2.7-1.2 c0.3-0.1,0.3-0.4,0.4-0.5c0-0.1,0-0.4-0.3-0.5l-2.5-1.4c-0.6-0.3-0.9-0.9-1-1.5l-0.3-2.9c0-0.3-0.3-0.5-0.4-0.5 c-0.1,0-0.4-0.1-0.6,0.1l-2.1,2c-0.5,0.4-1.1,0.6-1.8,0.5l-2.8-0.6c-0.3-0.1-0.5,0.1-0.6,0.2c-0.1,0.1-0.2,0.3-0.1,0.6l1.2,2.6 c0.3,0.6,0.2,1.3-0.1,1.8l-1.5,2.5c-0.2,0.3,0,0.5,0,0.6c0.1,0.1,0.2,0.3,0.6,0.3l2.9-0.4C137,123.7,137.1,123.7,137.2,123.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000042732125356789133410000009794999711073338807_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000051351378907503579450000005332773529951592870_",
    className: "st0",
    d: "M366.1,140.9l2.4,1.6 c0.4,0.2,0.8,0.3,1.2,0.1l2.7-1.1c1-0.4,2,0.5,1.7,1.5l-0.8,2.8c-0.1,0.4,0,0.8,0.3,1.2l1.9,2.2c0.7,0.8,0.1,2.1-0.9,2.1 l-2.9,0.1c-0.4,0-0.8,0.2-1,0.6l-1.5,2.5c-0.6,0.9-1.9,0.8-2.3-0.2l-1-2.7c-0.2-0.4-0.5-0.7-0.9-0.8l-2.8-0.7 c-1-0.2-1.3-1.6-0.5-2.2l2.3-1.8c0.3-0.3,0.5-0.7,0.5-1.1l-0.2-2.9C364,141,365.2,140.3,366.1,140.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000022562399123181450550000013378238774656103336_",
    className: "st1",
    d: "M368,155.9c-0.1,0-0.1,0-0.2,0 c-0.8-0.1-1.4-0.6-1.7-1.3l-1-2.7c-0.1-0.2-0.2-0.3-0.4-0.4l-2.8-0.7c-0.7-0.2-1.3-0.7-1.5-1.5c-0.2-0.7,0.1-1.5,0.7-2l2.3-1.8 c0.2-0.1,0.2-0.3,0.2-0.5l-0.2-2.9c-0.1-0.8,0.3-1.5,1-1.9s1.5-0.4,2.1,0l0,0l2.4,1.6c0.2,0.1,0.4,0.1,0.5,0.1l2.7-1.1 c0.7-0.3,1.5-0.2,2.1,0.3s0.8,1.3,0.6,2L374,146c-0.1,0.2,0,0.4,0.1,0.5l1.9,2.2c0.5,0.6,0.6,1.4,0.3,2.1c-0.3,0.7-1,1.2-1.7,1.2 l-2.9,0.1c-0.2,0-0.4,0.1-0.5,0.3l-1.5,2.5C369.4,155.5,368.7,155.9,368,155.9z M365.4,141.4c-0.1,0-0.2,0.1-0.3,0.1 c-0.1,0.1-0.3,0.2-0.3,0.5l0.2,2.9c0.1,0.6-0.2,1.3-0.7,1.7l-2.3,1.8c-0.3,0.2-0.2,0.5-0.2,0.6s0.1,0.4,0.4,0.4l2.8,0.7 c0.6,0.2,1.2,0.6,1.4,1.2l1,2.7c0.1,0.3,0.4,0.4,0.5,0.4s0.4,0,0.6-0.3l1.5-2.5c0.3-0.6,0.9-0.9,1.6-0.9l2.9-0.1 c0.3,0,0.5-0.3,0.5-0.4c0-0.1,0.1-0.4-0.1-0.6l-1.9-2.2c-0.4-0.5-0.6-1.2-0.4-1.8l0.8-2.8c0.1-0.3-0.1-0.5-0.2-0.6 s-0.3-0.2-0.6-0.1l-2.7,1.1c-0.6,0.2-1.3,0.2-1.8-0.2l-2.4-1.6C365.6,141.4,365.5,141.4,365.4,141.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000044158338066658032470000008960399181322934421_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000023251717238003778120000011304534958672100480_",
    className: "st0",
    d: "M264.4,139.4l-0.6,2.8 c-0.1,0.4,0,0.8,0.3,1.2l2,2.1c0.7,0.8,0.2,2-0.8,2.1l-2.9,0.3c-0.4,0-0.8,0.3-1,0.6L260,151c-0.5,0.9-1.9,0.8-2.3-0.1l-1.1-2.7 c-0.2-0.4-0.5-0.7-0.9-0.8l-2.9-0.6c-1-0.2-1.4-1.5-0.6-2.2l2.2-1.9c0.3-0.3,0.5-0.7,0.4-1.1l-0.3-2.9c-0.1-1.1,1-1.8,1.9-1.2 l2.5,1.5c0.4,0.2,0.8,0.2,1.2,0.1l2.6-1.2C263.6,137.5,264.6,138.4,264.4,139.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000082354430843511027320000000380887171403287483_",
    className: "st1",
    d: "M258.7,152.5h-0.1c-0.8,0-1.4-0.5-1.7-1.2 l-1.1-2.7c-0.1-0.2-0.2-0.3-0.4-0.3l-2.9-0.6c-0.7-0.2-1.3-0.7-1.5-1.4s0-1.5,0.6-2l2.2-1.9c0.1-0.1,0.2-0.3,0.2-0.5l-0.3-2.9 c-0.1-0.8,0.3-1.5,0.9-1.9s1.4-0.4,2.1,0l2.5,1.5c0.2,0.1,0.4,0.1,0.5,0l2.6-1.2c0.7-0.3,1.5-0.2,2.1,0.3s0.8,1.2,0.7,2l-0.6,2.8 c0,0.2,0,0.4,0.1,0.5l2,2.1c0.5,0.6,0.7,1.3,0.4,2.1c-0.3,0.7-0.9,1.2-1.7,1.3l-2.9,0.3c-0.2,0-0.4,0.1-0.5,0.3l-1.4,2.5 C260.1,152.1,259.4,152.5,258.7,152.5z M255.6,138.1c-0.1,0-0.3,0.1-0.3,0.1c-0.1,0.1-0.3,0.2-0.3,0.6l0.3,2.9 c0.1,0.6-0.2,1.3-0.7,1.7l-2.2,1.9c-0.2,0.2-0.2,0.5-0.2,0.6s0.1,0.4,0.5,0.4l2.9,0.6c0.6,0.1,1.2,0.6,1.4,1.2l1.1,2.7 c0.1,0.3,0.4,0.3,0.5,0.4c0.1,0,0.4,0,0.5-0.3l1.4-2.5c0.3-0.6,0.9-0.9,1.5-1l2.9-0.3c0.3,0,0.5-0.3,0.5-0.4 c0-0.1,0.1-0.4-0.1-0.6l-2-2.1c-0.4-0.5-0.6-1.1-0.5-1.8l0.6-2.8c0.1-0.3-0.1-0.5-0.2-0.6s-0.3-0.2-0.6-0.1l-2.6,1.2 c-0.6,0.3-1.3,0.2-1.8-0.1l-2.5-1.5C255.8,138.2,255.7,138.1,255.6,138.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000164499555546538756850000015936952528773019286_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000130605397599150336800000003167393988539888303_",
    className: "st0",
    d: "M232.3,191.2l-2,0.7 c-0.3,0.1-0.5,0.3-0.6,0.6l-0.5,2.1c-0.2,0.8-1.2,1-1.6,0.3l-1.3-1.7c-0.2-0.2-0.5-0.4-0.8-0.4l-2.1,0.1c-0.8,0-1.3-0.8-0.8-1.5 l1.2-1.8c0.2-0.3,0.2-0.6,0.1-0.9l-0.8-2c-0.3-0.7,0.4-1.5,1.1-1.2l2.1,0.6c0.3,0.1,0.6,0,0.9-0.2l1.6-1.4 c0.6-0.5,1.5-0.1,1.5,0.7l0.1,2.1c0,0.3,0.2,0.6,0.4,0.8l1.8,1.2C233.1,189.9,233,190.9,232.3,191.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000163054963254961173950000003172345371809031592_",
    className: "st1",
    d: "M228.2,196c-0.5,0-1-0.2-1.3-0.6l-1.3-1.7 c0-0.1-0.1-0.1-0.2-0.1l-2.1,0.1c-0.7,0-1.2-0.3-1.5-0.8s-0.3-1.2,0.1-1.7l1.2-1.8c0-0.1,0.1-0.2,0-0.2l-0.8-2 c-0.2-0.6-0.1-1.2,0.3-1.7s1.1-0.6,1.7-0.5l2.1,0.6c0.1,0,0.2,0,0.2,0l1.7-1.4c0.5-0.4,1.1-0.5,1.7-0.2s0.9,0.8,1,1.4l0.1,2.1 c0,0.1,0,0.2,0.1,0.2l1.8,1.1c0.5,0.3,0.8,0.9,0.7,1.6c-0.1,0.6-0.5,1.1-1.1,1.4l-2,0.7c-0.1,0-0.1,0.1-0.2,0.2l-0.5,2.1 c-0.2,0.6-0.6,1.1-1.3,1.2C228.4,196,228.3,196,228.2,196z M225.4,192.2c0.5,0,1,0.2,1.3,0.6l1.3,1.7c0.1,0.1,0.2,0.1,0.2,0.1 c0.1,0,0.2,0,0.2-0.2l0.5-2.1c0.1-0.5,0.5-0.9,1-1.1l2-0.7c0.1,0,0.2-0.1,0.2-0.2s0-0.2-0.1-0.2l-1.8-1.1 c-0.5-0.3-0.7-0.8-0.8-1.3l-0.1-2.1c0-0.1-0.1-0.2-0.1-0.2c-0.1,0-0.2-0.1-0.3,0l-1.7,1.4c-0.4,0.3-1,0.5-1.5,0.3l-2.1-0.6 c-0.1,0-0.2,0-0.2,0.1c0,0-0.1,0.1,0,0.3l0.8,2c0.2,0.5,0.1,1.1-0.2,1.5l-1.2,1.8c-0.1,0.1,0,0.2,0,0.3c0,0,0.1,0.2,0.2,0.1 L225.4,192.2L225.4,192.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000116923931608641970060000001773877878981173160_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000109729304598102602240000001097774601024922013_",
    className: "st0",
    d: "M337.3,180.4l-2,0.7 c-0.3,0.1-0.5,0.3-0.6,0.6l-0.5,2.1c-0.2,0.8-1.2,1-1.6,0.3l-1.3-1.7c-0.2-0.2-0.5-0.4-0.8-0.4l-2.1,0.1c-0.8,0-1.3-0.8-0.8-1.5 l1.2-1.8c0.2-0.3,0.2-0.6,0.1-0.9l-0.8-2c-0.3-0.7,0.4-1.5,1.1-1.2l2.1,0.6c0.3,0.1,0.6,0,0.9-0.2l1.6-1.4 c0.6-0.5,1.5-0.1,1.5,0.7l0.1,2.1c0,0.3,0.2,0.6,0.4,0.8l1.8,1.2C338.2,179.1,338.1,180.1,337.3,180.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000062159638075292214150000011862998136759935165_",
    className: "st1",
    d: "M333.3,185.2c-0.5,0-1-0.2-1.3-0.6 l-1.3-1.7c-0.1-0.1-0.2-0.1-0.2-0.1l-2.1,0.1c-0.7,0-1.2-0.3-1.5-0.8s-0.3-1.2,0.1-1.7l1.2-1.8c0-0.1,0.1-0.2,0-0.2l-0.8-2 c-0.2-0.6-0.1-1.2,0.3-1.7s1.1-0.6,1.7-0.5l2.1,0.6c0.1,0,0.2,0,0.2,0l1.7-1.4c0.5-0.4,1.1-0.5,1.7-0.2s0.9,0.8,1,1.4l0.1,2.1 c0,0.1,0,0.2,0.1,0.2l1.8,1.1c0.5,0.3,0.8,0.9,0.7,1.6c-0.1,0.6-0.5,1.1-1.1,1.4l-2,0.7c-0.1,0-0.1,0.1-0.2,0.2L335,184 c-0.2,0.6-0.6,1.1-1.3,1.2C333.5,185.2,333.4,185.2,333.3,185.2z M330.5,181.4c0.5,0,1,0.2,1.3,0.6l1.3,1.7 c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.2l0.5-2.1c0.1-0.5,0.5-0.9,1-1.1l2-0.7c0.1,0,0.2-0.1,0.2-0.2s0-0.2-0.1-0.2 l-1.8-1.1c-0.5-0.3-0.7-0.8-0.8-1.3l-0.1-2.1c0-0.1-0.1-0.2-0.1-0.2c-0.1,0-0.2-0.1-0.3,0l-1.7,1.4c-0.4,0.3-1,0.5-1.5,0.3 l-2.1-0.6c-0.1,0-0.2,0-0.2,0.1c0,0-0.1,0.1,0,0.3l0.8,2c0.2,0.5,0.1,1.1-0.2,1.5l-1.2,1.8c-0.1,0.1,0,0.2,0,0.3 c0,0,0.1,0.2,0.2,0.1L330.5,181.4C330.4,181.4,330.5,181.4,330.5,181.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000005957695761312232220000000178386649189982117_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000089566299142803336730000010890033327966894738_",
    className: "st0",
    d: "M229.7,329.6l-2,0.7 c-0.3,0.1-0.5,0.3-0.6,0.6l-0.5,2.1c-0.2,0.8-1.2,1-1.6,0.3l-1.3-1.7c-0.2-0.2-0.5-0.4-0.8-0.4l-2.1,0.1c-0.8,0-1.3-0.8-0.8-1.5 l1.2-1.8c0.2-0.3,0.2-0.6,0.1-0.9l-0.8-2c-0.3-0.7,0.4-1.5,1.1-1.2l2.1,0.6c0.3,0.1,0.6,0,0.9-0.2l1.6-1.4 c0.6-0.5,1.5-0.1,1.5,0.7l0.1,2.1c0,0.3,0.2,0.6,0.4,0.8l1.8,1.2C230.5,328.3,230.4,329.3,229.7,329.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000078758450213959345950000003753423837771887787_",
    className: "st1",
    d: "M225.6,334.4c-0.5,0-1-0.2-1.3-0.6 l-1.3-1.7c-0.1-0.1-0.2-0.1-0.2-0.1l-2.1,0.1c-0.6,0-1.2-0.3-1.5-0.8s-0.3-1.2,0.1-1.7l1.2-1.8c0-0.1,0.1-0.2,0-0.2l-0.8-2 c-0.2-0.6-0.1-1.2,0.3-1.7s1.1-0.6,1.7-0.5l2.1,0.6c0.1,0,0.2,0,0.2,0l1.7-1.4c0.5-0.4,1.1-0.5,1.7-0.2s0.9,0.8,1,1.4l0.1,2.1 c0,0.1,0,0.2,0.1,0.2l1.8,1.2c0.5,0.3,0.8,0.9,0.7,1.6c-0.1,0.6-0.5,1.1-1.1,1.4l-2,0.7c-0.1,0-0.1,0.1-0.2,0.2l-0.5,2.1 c-0.2,0.6-0.6,1.1-1.3,1.2C225.8,334.4,225.7,334.4,225.6,334.4z M222.8,330.6c0.5,0,1,0.2,1.3,0.6l1.3,1.7 c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.2l0.5-2.1c0.1-0.5,0.5-0.9,1-1.1l2-0.7c0.1,0,0.2-0.1,0.2-0.2s0-0.2-0.1-0.2 l-1.8-1.2c-0.5-0.3-0.7-0.8-0.8-1.3l-0.1-2.1c0-0.1-0.1-0.2-0.1-0.2c-0.1,0-0.2-0.1-0.3,0l-1.7,1.4c-0.4,0.3-1,0.5-1.5,0.3 l-2.1-0.6c-0.1,0-0.2,0-0.2,0.1c0,0-0.1,0.1,0,0.3l0.8,2c0.2,0.5,0.1,1.1-0.2,1.5l-1.2,1.8c-0.1,0.1,0,0.2,0,0.3 c0,0,0.1,0.1,0.2,0.1L222.8,330.6C222.7,330.6,222.8,330.6,222.8,330.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000125567066950566938010000000699286165081903747_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000031915301484530227770000015181196000820271030_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000057864017268131216680000005081472268926976404_",
    className: "st0",
    d: "M180.3,194l-9.1-21.4 c-0.7-1.6-1.8-2.4-2.7-2.3l-0.3,0.1l-5.6,1.5c-0.1,0-0.1,0.1-0.1,0.1l0.7,6l0.2,2.5l1.4-0.8l-3,10.3c-0.7,2.4,0.7,5.8,2.5,6.2 l7.1,1.6c0,0,0.1,0,0.1,0.1l2.1,3.1l0.1,0.1l5.7-1.5C180.8,199.1,181.4,196.5,180.3,194z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000090263545780471560210000014060844854736526769_",
    className: "st1",
    d: "M173.4,201.8l-0.4-0.5l-2-2.9l-6.9-1.5 c-0.9-0.2-1.7-0.9-2.3-1.9c-0.9-1.6-1.2-3.6-0.8-5.2l2.5-8.6l-0.8,0.5l-0.3-3.6l-0.7-6.6l0.7-0.3l5.9-1.6 c1.4-0.2,2.7,0.8,3.5,2.7l9.1,21.4c0.7,1.7,0.8,3.7,0.1,5c-0.4,0.7-0.9,1.2-1.5,1.3L173.4,201.8z M166,178.3l-3.5,12 c-0.3,1.2-0.1,2.8,0.6,4.1c0.4,0.7,0.9,1.1,1.4,1.2l7.3,1.6l0.2,0.3l1.9,2.7l5.3-1.4c0.3-0.1,0.5-0.4,0.6-0.6 c0.4-0.8,0.5-2.3-0.2-3.9l-9.1-21.4c-0.6-1.4-1.4-1.9-2-1.8h-0.2l-5.1,1.4l0.7,6.9L166,178.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000156572764767427425020000000259958092582602671_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000055674632149054313420000015504721800319111565_",
    className: "st0",
    d: "M177.7,187.9l-6.5-15.3 c-0.7-1.6-1.8-2.4-2.7-2.3l-0.3,0.1l-5.6,1.5c-0.1,0-0.1,0.1-0.1,0.1l0.7,6l0.2,2.5l1.4-0.8l-1.3,4.6c0.1,0,0.2,0.1,0.3,0.1 l-0.4,0.5l-1.5,5.2c-0.2,0.7-0.2,1.4-0.1,2.2L177.7,187.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000138538473271739500180000013741860145124868530_",
    className: "st1",
    d: "M161.1,193.1l-0.1-0.8 c-0.1-0.9-0.1-1.7,0.1-2.5l2.5-8.6l-0.8,0.5l-0.3-3.6l-0.7-6.6l0.7-0.3l5.9-1.6c1.4-0.2,2.7,0.8,3.5,2.7l6.8,16L161.1,193.1z  M163.9,185.3l-1.5,5c-0.1,0.3-0.1,0.7-0.1,1.1l14.5-3.9l-6.2-14.5c-0.6-1.4-1.4-1.9-2-1.8h-0.2l-5.1,1.4l0.7,6.9l2-1.2 l-1.6,5.6l0.7,0.2L163.9,185.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000123400991183457876240000017131905199937649566_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000062171253602481371820000004694748204645173640_",
    className: "st0",
    d: "M161.2,173.5l-5.3,18.2 c-0.7,2.4,0.7,5.8,2.5,6.2l14.4,3.2c1.9,0.4,2.8-2.6,1.6-5.4l-9.1-21.4C164.1,171.6,161.9,171.2,161.2,173.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000070120441283029935160000006562834024187370411_",
    className: "st1",
    d: "M173.2,201.8c-0.2,0-0.3,0-0.5-0.1 l-14.4-3.2c-0.8-0.2-1.7-0.9-2.3-1.9c-0.9-1.6-1.2-3.6-0.8-5.2l5.3-18.2c0.4-1.2,1.1-2,2.1-2c1.2-0.1,2.5,1,3.3,2.7l9.1,21.4 c0.9,2,0.8,4.4-0.2,5.6C174.4,201.5,173.8,201.8,173.2,201.8z M162.8,172.7L162.8,172.7c-0.6,0-0.8,0.7-0.9,1l0,0l-5.3,18.2 c-0.3,1.2-0.1,2.8,0.6,4.1c0.4,0.7,0.9,1.1,1.4,1.2l14.4,3.2c0.2,0,0.5,0.1,0.7-0.3c0.6-0.7,0.8-2.5,0-4.2l-9.1-21.4 C164.1,173.3,163.3,172.7,162.8,172.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000125586147406246455860000018044995439395298214_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000098218181349681978480000016788743301185073305_",
    x: 165.2,
    y: 172.8,
    transform: "matrix(0.9648 -0.263 0.263 0.9648 -39.7063 50.3598)",
    className: "st1",
    width: 6.1,
    height: 1.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000016033150141158254540000008984740743177548945_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000140702684833817679890000012077381375328599191_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000047747960986933308400000014373714589586410419_",
    className: "st0",
    d: "M180.6,83.7L181,82 c0.4-2.1-0.2-4.8-1.5-6.5l-1.3-1.6c-1.1-1.5-2.3-2.9-3.5-4.3l0.4-1.9c0.4-2.1-0.3-4.8-1.6-6.3l-2.5-2.7c-0.7-0.8-1.4-1.1-2.1-1 l0,0l-4.1,0.8c-1.2-1.2-2.4-2.4-3.6-3.6l-4.7-4.5c-0.7-0.7-1.4-0.9-2-0.9c-7.2,0.2-12.8,4.7-12.8,4.7l1.1-1.1l5.7,5.6l1.3-0.5 c-1.1,3.1-2,6.4-2.7,9.8l-0.3,1.6c-0.5,2.1,0.3,4.9,1.6,6.4l17.2,18.8c-1.4,1.3-2.6,2.5-2.7,2.5c-0.2,0-1.9,7-1.9,7 s7.3,0.4,12.8-2.5c0.1,0,0.1-0.1,0.2-0.1l0,0c0.4-0.2,0.8-0.6,1-1.2l0.6-1.3C177.8,94.6,179.4,89.4,180.6,83.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000060013462210555930560000017608445465276227495_",
    className: "st1",
    d: "M162.2,105.2c-0.7,0-1.1,0-1.2,0h-0.8 l0.2-0.8c1.6-6.6,1.8-7.4,2.3-7.5c0.2-0.2,0.7-0.6,2-1.9L148,76.7c-1.6-1.7-2.3-4.7-1.8-7l0.3-1.6c0.6-2.9,1.4-5.8,2.2-8.5 l-0.4,0.1l-5.5-5.3c-0.5,0.3-0.7,0.5-0.7,0.5l-0.9-1l1.6-1.5l0.3,0.3c2.3-1.4,6.5-3.5,11.4-3.6c0.8-0.1,1.7,0.3,2.5,1.1l4.7,4.5 c1.1,1.1,2.2,2.2,3.3,3.3l3.8-0.8c0.7-0.1,1.7,0.1,2.8,1.2l2.5,2.7c1.5,1.7,2.3,4.6,1.8,6.9l-0.3,1.6c1.1,1.3,2.2,2.7,3.2,4 l1.3,1.6c1.4,1.8,2.1,4.7,1.6,7.1l-0.4,1.7c-1.2,5.7-2.9,11-5,15.8l-0.6,1.3c-0.3,0.7-0.8,1.2-1.3,1.5c-0.1,0-0.2,0.1-0.2,0.1 C169.8,105,164.5,105.2,162.2,105.2z M161.9,103.8c2.1,0,7.4-0.2,11.6-2.4l0.5,0.5l-0.3-0.6c0.3-0.2,0.5-0.5,0.7-0.9l0.6-1.3 c2.1-4.7,3.7-9.9,4.9-15.5l0.4-1.7c0.4-1.9-0.2-4.4-1.4-5.9l-1.3-1.6c-1.1-1.4-2.3-2.9-3.4-4.3l-0.2-0.3l0.5-2.2 c0.4-1.9-0.2-4.4-1.5-5.7l-2.5-2.7c-0.4-0.4-0.9-0.9-1.5-0.8l-4.5,0.9l-0.3-0.3c-1.2-1.2-2.4-2.4-3.6-3.5l-4.7-4.5 c-0.5-0.5-1-0.7-1.5-0.7c-4.4,0.1-8.3,2-10.5,3.3l4.6,4.5l2.3-0.9l-0.5,1.4c-1.1,3.1-1.9,6.4-2.7,9.7l-0.3,1.6 c-0.4,1.9,0.2,4.5,1.5,5.8L166.5,95l-0.5,0.5c-1.6,1.5-2.3,2.2-2.7,2.5C163.2,98.6,162.5,101.2,161.9,103.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000035525171391245309780000017772085832117475774_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000029766714802977235580000009482866137647785906_",
    className: "st0",
    d: "M179.5,75.4l-1.3-1.6 c-1.1-1.5-2.3-2.9-3.5-4.3l0.4-1.9c0.4-2.1-0.3-4.8-1.6-6.3l-2.5-2.7c-0.7-0.8-1.4-1.1-2.1-1l0,0l-4.1,0.8 c-1.2-1.2-2.4-2.4-3.6-3.6l-4.7-4.5c-0.7-0.7-1.4-0.9-2-0.9c-5.8,0.2-10.3,1.7-11.7,2.3c-0.3,0.1-0.4,0.4-0.3,0.7l0.3,0.6 l5.7,5.6l-3.3,3c-1,3,2.7,2.7,2,6l6.9,6.2l14.6,5.5c0,0,6.2-1.2,11.6-2.7C180.1,76.2,179.8,75.8,179.5,75.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000132074179529599130890000003409726058397665982_",
    className: "st1",
    d: "M168.6,80.2l-15-5.7l-7.2-6.4l0.1-0.4 c0.3-1.3-0.3-1.8-0.9-2.5c-0.8-0.8-1.7-1.7-1.1-3.6l0.2-0.3l2.8-2.5l-5.4-5.3l-0.3-0.6c-0.1-0.3-0.1-0.7,0-1s0.4-0.6,0.7-0.7 c1.6-0.7,6.1-2.2,12-2.4c0.8-0.1,1.7,0.3,2.5,1.1l4.7,4.5c1.1,1.1,2.2,2.2,3.3,3.3l3.8-0.8c0.7-0.1,1.7,0.1,2.8,1.2l2.5,2.7 c1.5,1.7,2.3,4.6,1.8,6.9l-0.3,1.6c1.1,1.3,2.2,2.7,3.2,4l1.3,1.6c0.3,0.4,0.6,0.9,0.9,1.5l0.4,0.8l-0.8,0.2 c-5.4,1.4-11.6,2.7-11.7,2.7L168.6,80.2z M154.5,73.3l14.3,5.4c1-0.2,6-1.2,10.5-2.4c-0.1-0.2-0.2-0.3-0.3-0.4l-1.3-1.6 c-1.1-1.4-2.3-2.9-3.4-4.3l-0.2-0.3l0.5-2.2c0.4-1.9-0.2-4.4-1.5-5.7l-2.5-2.7c-0.4-0.4-0.9-0.9-1.5-0.8l-4.5,0.9l-0.3-0.3 c-1.2-1.2-2.4-2.4-3.6-3.5l-4.7-4.5c-0.5-0.5-1-0.7-1.5-0.7c-5.5,0.2-9.7,1.6-11.4,2.2l0.2,0.3l6.2,6l-3.7,3.4 c-0.3,1,0.1,1.4,0.8,2c0.7,0.7,1.6,1.6,1.4,3.4L154.5,73.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000056418817365023317940000001462746053294110080_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000024719105185744990000000013017204717363379354_",
    className: "st0",
    d: "M173.5,61.3l-2.5-2.7 c-0.7-0.8-1.4-1.1-2.1-1l-4.2,0.9l-6.9,1.4c-0.3,0.1-0.5,0.4-0.4,0.7l2.7,5.5l14.5-3C174.4,62.5,174,61.8,173.5,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000110443261357185793940000008906917586506334093_",
    className: "st1",
    d: "M159.8,66.9l-2.9-6 c-0.2-0.3-0.2-0.7,0-1.1c0.2-0.3,0.5-0.6,0.8-0.6l11.1-2.3c0.7-0.1,1.7,0.1,2.8,1.2l2.5,2.7c0.5,0.6,0.9,1.2,1.3,2.1l0.3,0.8 L159.8,66.9z M158.2,60.5l2.3,4.8l13.1-2.7c-0.2-0.3-0.4-0.6-0.6-0.9l0,0l-2.5-2.7c-0.4-0.4-0.9-0.9-1.5-0.8L158.2,60.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000125563546887103388770000002612740565181126078_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000069373914362401683240000004133526350941135762_",
    className: "st0",
    d: "M168.9,86.1l0.4-1.7 c0.4-2.1-0.2-4.8-1.5-6.5l-1.3-1.6c-1.1-1.5-2.3-2.9-3.5-4.3l0.4-1.9c0.4-2.1-0.3-4.8-1.6-6.3l-2.5-2.7c-1.4-1.5-3-1.3-3.8,0.4 l-0.6,1.4c-1.8-1.9-3.6-3.7-5.4-5.5l-4.7-4.5c-1.4-1.4-3-1.1-3.8,0.7l-0.6,1.4c-2.1,4.7-3.8,9.9-5,15.6l-0.3,1.6 c-0.5,2.1,0.3,4.9,1.6,6.4l22.8,25c1.4,1.5,3,1.3,3.8-0.4l0.6-1.3C166,97.1,167.7,91.8,168.9,86.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000160895633164782879800000000240387342257240223_",
    className: "st1",
    d: "M161.4,105.3c-0.8,0-1.7-0.4-2.5-1.3 l-22.8-25c-1.6-1.7-2.3-4.7-1.8-7l0.3-1.6c1.2-5.7,2.9-11,5-15.8l0.6-1.4c0.5-1.1,1.2-1.7,2.1-1.9c0.9-0.2,1.9,0.2,2.8,1 l4.7,4.5c1.5,1.5,3.1,3.1,4.7,4.8l0.2-0.4c0.5-1,1.2-1.7,2.1-1.8c1-0.2,2,0.3,2.8,1.2l2.5,2.7c1.5,1.7,2.3,4.6,1.8,6.9l-0.3,1.6 c1.1,1.3,2.2,2.7,3.2,4l1.3,1.6c1.4,1.8,2.1,4.7,1.6,7.1l-0.4,1.7c-1.2,5.7-2.9,11-5,15.8l-0.6,1.3c-0.5,1-1.2,1.7-2.1,1.8 C161.7,105.2,161.6,105.3,161.4,105.3z M142.9,52.6c-0.1,0-0.1,0-0.2,0c-0.5,0.1-0.9,0.5-1.1,1.1l-0.6,1.4 c-2.1,4.7-3.7,9.9-4.9,15.5l-0.3,1.6c-0.4,1.9,0.2,4.5,1.5,5.8l22.8,25c0.5,0.6,1.1,0.9,1.6,0.8c0.4-0.1,0.8-0.4,1.1-1l0.6-1.3 c2.1-4.6,3.7-9.9,4.9-15.5l0.4-1.7c0.4-1.9-0.2-4.4-1.4-5.9l-1.3-1.6c-1.1-1.4-2.3-2.9-3.4-4.3l-0.2-0.3l0.5-2.2 c0.4-1.9-0.2-4.4-1.5-5.7l-2.5-2.7c-0.5-0.6-1.1-0.9-1.6-0.8c-0.4,0.1-0.8,0.4-1.1,1l-1.1,2.3l-0.7-0.8 c-1.8-1.9-3.7-3.8-5.4-5.5l-4.7-4.5C143.9,52.9,143.4,52.6,142.9,52.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000056413573828696373500000005981485330234780037_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000118398211815157342570000010774077219778792624_",
    className: "st0",
    d: "M160.6,88.7c2-6.3,0-15.5-4.5-20.4 c-2.1-2.3-4.4-3.3-6.5-3l0,0l0,0c-0.2,0-0.3,0.1-0.5,0.1l-11.9,2.5l6.2,28.9l12-2.5c0.1,0,0.3-0.1,0.4-0.1l0,0l0,0 C157.9,93.7,159.6,91.8,160.6,88.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000165216635102062335920000009718274745461158052_",
    className: "st1",
    d: "M142.8,97.6l-6.5-30.2l12.6-2.6 c0.1,0,0.3-0.1,0.5-0.1c2.4-0.4,4.9,0.8,7.1,3.2c4.6,5.1,6.7,14.5,4.6,21.1l-0.7-0.2l0.7,0.2c-1,3.2-2.9,5.3-5.3,5.9 c-0.2,0.1-0.4,0.1-0.5,0.1L142.8,97.6z M138,68.5l5.9,27.5l11.3-2.3c0.2,0,0.3,0,0.4-0.1c1.9-0.5,3.5-2.3,4.3-5 c1.9-6.1,0-15-4.3-19.7c-1.9-2.1-4-3.1-5.9-2.8c-0.2,0-0.3,0.1-0.4,0.1L138,68.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000181775961552405513070000014638139834613584771_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000106130359595742347290000002364668614990685344_",
    className: "st0",
    d: "M160.7,77.6c-0.8-3.6-2.4-6.9-4.6-9.3 c-2.1-2.3-4.4-3.3-6.5-3L136.8,68l1.3,3.9l10.4,8.1l12-2.5C160.5,77.6,160.6,77.6,160.7,77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000074438342789093526270000014586559919123615113_",
    className: "st1",
    d: "M148.2,80.9l-10.8-8.5l-1.6-4.9l13.6-2.9 c2.4-0.4,4.9,0.8,7.1,3.2s3.9,5.8,4.8,9.6l0.2,0.7l-0.7,0.2l-0.2-0.7l0.1,0.7c-0.1,0-0.2,0-0.3,0.1L148.2,80.9z M138.6,71.6 l10,7.8l11.2-2.3c-0.9-3.3-2.4-6.2-4.3-8.3s-4-3.1-5.9-2.8l-12,2.6L138.6,71.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000172418149140358363050000015856239044899870601_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_00000136401044936587478110000004647589930672139159_",
    transform: "matrix(0.9767 -0.2146 0.2146 0.9767 -14.3894 32.0454)",
    className: "st0",
    cx: 140.4,
    cy: 82.3,
    rx: 8.5,
    ry: 14.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000116915362848093578990000004615079998785680049_",
    className: "st1",
    d: "M142.4,97.6c-2.1,0-4.3-1.1-6.2-3.3 c-4.6-5.1-6.7-14.5-4.6-21.1c1.1-3.3,3-5.4,5.5-6c2.5-0.5,5.1,0.6,7.5,3.1c4.6,5.1,6.7,14.5,4.6,21.1c-1.1,3.3-3,5.4-5.5,6 C143.3,97.5,142.9,97.6,142.4,97.6z M138.3,68.5c-0.3,0-0.6,0-0.9,0.1c-2,0.4-3.6,2.2-4.4,5.1c-1.9,6.1,0,15,4.3,19.7 c2,2.2,4.2,3.2,6.2,2.7c2-0.4,3.6-2.2,4.4-5.1l0,0c1.9-6.1,0-15-4.3-19.7C141.8,69.5,140,68.5,138.3,68.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000050627322185454621320000016399893707705726113_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000098193140908647439510000012679097211325609365_",
    className: "st1",
    d: "M144.6,87c-1.1,3.3-3.8,3.9-6.1,1.4 c-2.3-2.6-3.4-7.3-2.3-10.6c1.1-3.3,3.8-3.9,6.1-1.4S145.7,83.7,144.6,87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000155144779803970662700000015964497553337988790_",
    className: "st1",
    d: "M141.5,90.6c-1.2,0-2.4-0.6-3.5-1.8 c-2.5-2.8-3.6-7.7-2.5-11.3c0.6-1.8,1.7-3,3.1-3.3c1.4-0.3,2.9,0.3,4.2,1.7c2.5,2.8,3.6,7.7,2.5,11.3l0,0 c-0.6,1.8-1.7,3-3.1,3.3C141.9,90.6,141.7,90.6,141.5,90.6z M139.3,75.4c-0.1,0-0.3,0-0.4,0c-0.9,0.2-1.6,1.1-2.1,2.4 c-1,3.1,0,7.6,2.2,10c1,1.1,2,1.5,2.9,1.3s1.6-1.1,2.1-2.4l0,0c1-3.1,0-7.6-2.2-10C140.9,75.9,140.1,75.4,139.3,75.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000079459418434503245370000016446511585345403326_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000157281288577137246560000001679120113122049463_",
    className: "st0",
    d: "M143.6,78.3c-0.9-1.7-2-2.7-3-3.2 c-0.8,0.9-1.5,2.3-1.6,4.4c-0.1,2.2,0.4,4.5,1.5,6.5c0.9,1.7,1.8,2.6,2.9,3.1c0.8-0.9,1.6-2.2,1.8-4.3 C145.1,82.5,144.6,80.2,143.6,78.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000131346706006731913350000002393403067071815049_",
    className: "st1",
    d: "M143.4,89.9l-0.4-0.2 c-1.2-0.5-2.2-1.6-3.2-3.4c-1.1-2.1-1.7-4.4-1.5-6.8c0.1-2.1,0.7-3.8,1.8-4.8l0.3-0.3l0.4,0.2c1.3,0.5,2.4,1.7,3.4,3.5l0,0 c1.1,2.1,1.7,4.4,1.5,6.8c-0.1,1.9-0.8,3.5-2,4.8L143.4,89.9z M140.7,76c-0.6,0.8-1,2-1,3.6c-0.1,2.1,0.4,4.3,1.4,6.1 c0.7,1.3,1.3,2.1,2.1,2.5c0.7-0.9,1.2-2.1,1.2-3.5c0.1-2.1-0.4-4.3-1.4-6.1C142.3,77.4,141.5,76.5,140.7,76z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000050643550779580501160000013265970788835441810_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_00000119106456069256597470000003095511900483487400_",
    className: "st0",
    cx: 320.1,
    cy: 43.3,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000114057460191338201600000014741776735958586267_",
    className: "st1",
    d: "M320.1,46.7c-1.9,0-3.4-1.5-3.4-3.4 s1.5-3.4,3.4-3.4s3.4,1.5,3.4,3.4S322,46.7,320.1,46.7z M320.1,41.2c-1.1,0-2.1,0.9-2.1,2.1s0.9,2.1,2.1,2.1 c1.1,0,2.1-0.9,2.1-2.1S321.2,41.2,320.1,41.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000173126009867085327450000014796351640029561255_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_00000137112895128744564950000004107805943108659345_",
    className: "st0",
    cx: 129,
    cy: 139.5,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000098924625960782102010000013771506866194473648_",
    className: "st1",
    d: "M129,143c-1.9,0-3.4-1.5-3.4-3.4 s1.5-3.4,3.4-3.4s3.4,1.5,3.4,3.4C132.4,141.4,130.9,143,129,143z M129,137.5c-1.1,0-2.1,0.9-2.1,2.1c0,1.1,0.9,2.1,2.1,2.1 c1.1,0,2.1-0.9,2.1-2.1C131,138.4,130.1,137.5,129,137.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000086667001746867682510000000451127369292189116_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_00000059268041914022190620000011272454332398101935_",
    className: "st0",
    cx: 330.8,
    cy: 113.1,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000142859874377451271820000015524394607736501902_",
    className: "st1",
    d: "M330.8,116.6c-1.9,0-3.4-1.5-3.4-3.4 s1.5-3.4,3.4-3.4s3.4,1.5,3.4,3.4C334.3,115,332.7,116.6,330.8,116.6z M330.8,111.1c-1.1,0-2.1,0.9-2.1,2.1 c0,1.1,0.9,2.1,2.1,2.1c1.1,0,2.1-0.9,2.1-2.1S332,111.1,330.8,111.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000143593291212801060900000002087062203604944527_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000016780220423883645610000011738587917888291257_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000176005347942130386670000014785829708831436446_",
    x: 190.2,
    y: 94.3,
    className: "st1",
    width: 1.4,
    height: 8.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000033338482701487862600000012737324581476728723_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000150809036165519910800000017955486600779946681_",
    x: 186.3,
    y: 98,
    className: "st1",
    width: 9.2,
    height: 1.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000147194283226736582880000003042222675297522069_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000096057036513672747770000013638289578647249303_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000096046015045210170890000004982126820732817028_",
    x: 167.2,
    y: 211.5,
    className: "st1",
    width: 1.4,
    height: 8.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000021114544865495097540000004364048229791030700_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000003827892209493034320000010757816572116927904_",
    x: 163.3,
    y: 215.2,
    className: "st1",
    width: 9.2,
    height: 1.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000070096737833386878580000014323915038005108412_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000091695726982773683630000006217300294068829621_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000012455947705238923700000016793479483634189227_",
    x: 25.1,
    y: 345.2,
    className: "st1",
    width: 1.4,
    height: 8.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000161621796215658730640000011072382566917656198_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000119812319956811265210000006629626238589332896_",
    x: 21.2,
    y: 348.9,
    className: "st1",
    width: 9.2,
    height: 1.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000002383822205967285310000005307743801925318020_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000121975648053953432810000003146827590784860850_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000137841030347248882890000003640223208183847041_",
    x: 212.6,
    y: 304,
    className: "st1",
    width: 1.4,
    height: 8.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000066498315295253354230000017727781634523089558_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000023244317505339979580000011515909656343498125_",
    x: 208.7,
    y: 307.7,
    className: "st1",
    width: 9.2,
    height: 1.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000144303751735321470380000016750260850276138932_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000067197201393314553470000007704938276106462109_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000111870704880995168510000001938005253628692659_",
    x: 367.8,
    y: 34.7,
    className: "st1",
    width: 1.4,
    height: 8.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000020379387775840635450000006799664352562269580_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000054958263142516399860000000739456207046973318_",
    x: 363.9,
    y: 38.4,
    className: "st1",
    width: 9.2,
    height: 1.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000085241566797480414260000016389509476709447836_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000108296291681098979860000015293148550427966385_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000127736978370210501290000003482318196850661265_",
    x: 405.4,
    y: 249.7,
    className: "st1",
    width: 1.4,
    height: 8.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000168089966563741048290000001256423221033845898_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000181766509945969917450000016125539441954139026_",
    x: 401.5,
    y: 253.4,
    className: "st1",
    width: 9.2,
    height: 1.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000107582365826075422120000017291866672373610384_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000141426662461412051220000003374049795087851152_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000085954949506845658460000014007073995454268556_",
    x: 385.9,
    y: 89.2,
    className: "st1",
    width: 1.4,
    height: 8.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000174567364282142515660000009888938049092732593_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000038405195056041229750000007365857337130941088_",
    x: 382,
    y: 92.9,
    className: "st1",
    width: 9.2,
    height: 1.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000183966391150814851610000012678864075193840533_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000013173032866482536990000008258672962828293775_",
    className: "st0",
    d: "M306.1,199.9h-3.5c-0.4,0-0.8-0.4-0.8-0.8 v-3.5c0-0.4,0.4-0.8,0.8-0.8h3.5c0.4,0,0.8,0.4,0.8,0.8v3.5C306.9,199.6,306.5,199.9,306.1,199.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000069372869247425539150000012049906067756707241_",
    className: "st1",
    d: "M306.1,200.6h-3.5c-0.8,0-1.5-0.7-1.5-1.5 v-3.5c0-0.8,0.7-1.5,1.5-1.5h3.5c0.8,0,1.5,0.7,1.5,1.5v3.5C307.6,200,306.9,200.6,306.1,200.6z M302.6,195.5l-0.1,3.6l3.6,0.1 c0.1,0,0.1,0,0.1-0.1v-3.5L302.6,195.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000155849991814235577920000007870785963597133498_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000138549383840457757880000007176960787248208018_",
    className: "st0",
    d: "M181,325.5h-3.5c-0.4,0-0.8-0.4-0.8-0.8 v-3.5c0-0.4,0.4-0.8,0.8-0.8h3.5c0.4,0,0.8,0.4,0.8,0.8v3.5C181.8,325.1,181.5,325.5,181,325.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000117639499175017145520000014672578361688239004_",
    className: "st1",
    d: "M181,326.2h-3.5c-0.8,0-1.5-0.7-1.5-1.5 v-3.5c0-0.8,0.7-1.5,1.5-1.5h3.5c0.8,0,1.5,0.7,1.5,1.5v3.5C182.5,325.5,181.8,326.2,181,326.2z M177.5,321.1l-0.1,3.6l3.6,0.1 c0.1,0,0.1,0,0.1-0.1v-3.5L177.5,321.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000088823052949812313750000010463720935300292796_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000081622110410902354820000001798422196075072430_",
    className: "st0",
    d: "M34.7,362h-3.5c-0.4,0-0.8-0.4-0.8-0.8 v-3.5c0-0.4,0.4-0.8,0.8-0.8h3.5c0.4,0,0.8,0.4,0.8,0.8v3.5C35.5,361.7,35.2,362,34.7,362z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000155858138762919442320000017830435016771377031_",
    className: "st1",
    d: "M34.7,362.7h-3.5c-0.8,0-1.5-0.7-1.5-1.5 v-3.5c0-0.8,0.7-1.5,1.5-1.5h3.5c0.8,0,1.5,0.7,1.5,1.5v3.5C36.2,362.1,35.6,362.7,34.7,362.7z M31.2,357.6l-0.1,3.6l3.6,0.1 c0.1,0,0.1,0,0.1-0.1v-3.5L31.2,357.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000172440285394660658730000013363709444533971337_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000173845607473491499870000008114896363462464897_",
    className: "st0",
    d: "M417.9,249.1h-3.5c-0.4,0-0.8-0.4-0.8-0.8 v-3.5c0-0.4,0.4-0.8,0.8-0.8h3.5c0.4,0,0.8,0.4,0.8,0.8v3.5C418.7,248.7,418.3,249.1,417.9,249.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.a063fd2ee07209432860a45b5969d545.svg";
export { ForwardRef as ReactComponent };